// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.publishing-state {
  padding: 0 32px 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.publishing-state__banner {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 16px;
  border-radius: 10px;
  font-size: 13px;
  line-height: 1.5;
}
.publishing-state__banner mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}
.publishing-state__banner--rejected {
  background: #fdecea;
  border: 1px solid #f5b5ae;
  color: #8a1c12;
}
.publishing-state__banner--rejected mat-icon {
  color: #d93025;
}
.publishing-state__banner--status {
  background: #eef4ff;
  border: 1px solid #c7d7fe;
  color: #1e3a8a;
}
.publishing-state__banner--status mat-icon {
  color: #2563eb;
}
.publishing-state__text {
  flex: 1;
}
.publishing-state__hint {
  display: block;
  font-size: 12px;
  opacity: 0.8;
}
.publishing-state__change {
  margin-left: auto;
  border: 1px solid currentColor;
  background: transparent;
  color: inherit;
  border-radius: 999px;
  padding: 4px 12px;
  font-size: 12px;
  cursor: pointer;
  white-space: nowrap;
}
.publishing-state__change:disabled {
  opacity: 0.5;
  cursor: default;
}

.publishing-info-btn {
  flex: 0 0 auto;
  width: 32px;
  height: 32px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: transparent;
  color: #2563eb;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.publishing-info-btn mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  line-height: 20px;
}
.publishing-info-btn:hover, .publishing-info-btn:focus-visible {
  background: rgba(37, 99, 235, 0.1);
}

:host-context(body.theme-dark) .publishing-info-btn {
  color: #8ab4f8;
}

:host-context(body.theme-dark) .publishing-state .publishing-state__banner--rejected {
  background: rgba(217, 48, 37, 0.12);
  border-color: rgba(217, 48, 37, 0.35);
  color: #f9b4ad;
}
:host-context(body.theme-dark) .publishing-state .publishing-state__banner--rejected mat-icon {
  color: #f28b82;
}
:host-context(body.theme-dark) .publishing-state .publishing-state__banner--status {
  background: rgba(37, 99, 235, 0.12);
  border-color: rgba(37, 99, 235, 0.35);
  color: #bfd3fe;
}
:host-context(body.theme-dark) .publishing-state .publishing-state__banner--status mat-icon {
  color: #8ab4f8;
}

.mat-badge-content {
  background: #5ea1d8;
}

.upload-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  overflow: hidden;
}

.upload-dialog {
  width: 90%;
  max-width: 1380px;
  height: 90vh;
  max-height: 90vh;
  background: #fff;
  border-radius: 22px;
  box-shadow: 0 35px 70px rgba(7, 8, 10, 0.35);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  position: relative;
  margin: auto;
  z-index: 10000;
}

.upload-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px 10px;
  background: #fff;
  color: #111827;
  border-bottom: 1px solid #e4e8f0;
  position: relative;
  z-index: 10008;
  isolation: isolate;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 16px;
}
@media (max-width: 768px) {
  .header-left {
    gap: 12px;
  }
}

.header-right {
  position: relative;
  z-index: 10009;
  isolation: isolate;
}

.icon-circle {
  width: 54px;
  height: 54px;
  border-radius: 50%;
  background: #f3f4f6;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.icon-circle mat-icon {
  color: #5ea1d8;
  font-size: 24px;
  width: 24px;
  height: 24px;
  line-height: 24px;
}
@media (max-width: 768px) {
  .icon-circle {
    width: 40px;
    height: 40px;
  }
  .icon-circle mat-icon {
    font-size: 20px;
    width: 20px;
    height: 20px;
    line-height: 20px;
  }
}

.header-copy p {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
}
.header-copy p .desktop-title {
  display: block;
}
@media (max-width: 768px) {
  .header-copy p .desktop-title {
    display: none;
  }
}
.header-copy p .mobile-title {
  display: none;
}
@media (max-width: 768px) {
  .header-copy p .mobile-title {
    display: block;
  }
}
.header-copy .header-description {
  font-size: 14px;
  color: #6b7280;
}
@media (max-width: 768px) {
  .header-copy .header-description {
    display: none;
  }
}
.header-copy span {
  font-size: 14px;
  color: #6b7280;
}

.icon-button {
  border: none;
  background: #f3f4f6;
  color: inherit;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.2s ease;
  position: relative;
  z-index: 10007;
}
.icon-button mat-icon {
  font-size: 22px;
}
.icon-button:hover {
  background: #e5e7eb;
  transform: translateY(-1px);
}

.stage-banner {
  padding: 1px 10px 1px;
  background: #fff;
  border-bottom: 1px solid #edf1f7;
  flex-shrink: 0;
}

.journey-progress {
  display: flex;
  align-items: center;
  gap: 0;
  padding: 16px 0 0;
  margin-top: 12px;
  flex-shrink: 0;
  overflow-x: hidden;
  flex-wrap: nowrap;
  width: 100%;
  position: relative;
}

.journey-step {
  background: transparent;
  border: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0;
  min-width: auto;
  flex-shrink: 0;
  cursor: pointer;
  color: #9ca3af;
  transition: color 0.2s ease;
  white-space: nowrap;
  outline: none;
  box-shadow: none;
  -webkit-tap-highlight-color: transparent;
  align-self: center;
}
.journey-step .tab-count {
  font-size: 11px;
  background: rgba(37, 99, 235, 0.08);
  color: #2563eb;
  border-radius: 999px;
  padding: 2px 8px;
}
.journey-step:focus, .journey-step:focus-visible, .journey-step:active {
  outline: none !important;
  box-shadow: none !important;
}
.journey-step:focus .step-label, .journey-step:focus-visible .step-label, .journey-step:active .step-label {
  outline: none;
  box-shadow: none;
}
.journey-step:disabled {
  opacity: 0.45;
  cursor: not-allowed;
  pointer-events: auto;
}

.journey-step.active {
  color: #5ea1d8;
}
.journey-step.active .step-label {
  border-color: #5ea1d8;
  background: rgba(94, 161, 216, 0.1);
  color: #5ea1d8;
}

.journey-step.complete {
  color: #16a34a;
}
.journey-step.complete .step-label {
  border-color: #16a34a;
  background: rgba(22, 163, 74, 0.1);
  color: #16a34a;
}

.step-indicator {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 2px solid currentColor;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 14px;
  flex-shrink: 0;
}
.step-indicator mat-icon {
  font-size: 20px;
}

.step-label {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  line-height: 1.2;
  white-space: nowrap;
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  padding: 8px 16px;
  border-radius: 35px;
  border: 2px solid currentColor;
  background: transparent;
  flex-shrink: 0;
}

.step-label .step-count,
.step-label .label-text {
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
}

/* Dark mode pass for create-bundle */
:host-context(body.theme-dark) {
  /* Ensure readable text across all create-bundle panels */
  /* Rephrase / AI action links â€” keep hyperlink appearance in dark mode */
  /* Remove unnecessary panel backgrounds in dark mode */
  /* Force white readable text across create bundle views */
  /* Remove leftover white backgrounds in dark mode */
  /* Fix white UI surfaces: textarea, cover image containers, buttons */
  /* Description area dark-mode fix */
  /* Footer dark-mode fix */
  /* Hardening: no white surfaces on any tab/panel content */
  /* Explicit tab fixes: Flows/Items(Steps-like)/Summary */
}
:host-context(body.theme-dark) .upload-dialog {
  background: #0f172a !important;
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) .upload-header,
:host-context(body.theme-dark) .upload-body,
:host-context(body.theme-dark) .section-card,
:host-context(body.theme-dark) .journey-card,
:host-context(body.theme-dark) .secondary-pane,
:host-context(body.theme-dark) .primary-pane {
  background: #111827 !important;
  color: #e5e7eb !important;
  border-color: rgba(148, 163, 184, 0.25) !important;
}
:host-context(body.theme-dark) .stage-banner {
  background: transparent !important;
  border-bottom-color: rgba(148, 163, 184, 0.18) !important;
}
:host-context(body.theme-dark) .header-copy p,
:host-context(body.theme-dark) .header-copy p span,
:host-context(body.theme-dark) .header-copy .desktop-title,
:host-context(body.theme-dark) .header-copy .mobile-title,
:host-context(body.theme-dark) .journey-pane-header h5,
:host-context(body.theme-dark) .stage-title-row {
  color: #f8fafc !important;
}
:host-context(body.theme-dark) .header-description,
:host-context(body.theme-dark) .journey-pane-header p {
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .icon-circle,
:host-context(body.theme-dark) .icon-button {
  background: #1f2937 !important;
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) .icon-button:hover {
  background: #334155 !important;
}
:host-context(body.theme-dark) .upload-dialog .step-connector,
:host-context(body.theme-dark) .step-connector {
  background: rgba(148, 163, 184, 0.2) !important;
}
:host-context(body.theme-dark) .upload-dialog .step-connector.fill,
:host-context(body.theme-dark) .step-connector.fill {
  background: #16a34a !important;
}
:host-context(body.theme-dark) .upload-dialog .journey-step,
:host-context(body.theme-dark) .journey-step {
  background: transparent !important;
  box-shadow: none !important;
}
:host-context(body.theme-dark) .upload-dialog .journey-step:not(.active):not(.complete),
:host-context(body.theme-dark) .journey-step:not(.active):not(.complete) {
  color: #64748b !important;
}
:host-context(body.theme-dark) .upload-dialog .journey-step:not(.active):not(.complete) .step-label,
:host-context(body.theme-dark) .journey-step:not(.active):not(.complete) .step-label {
  border-color: #64748b !important;
  background: transparent !important;
  color: #64748b !important;
}
:host-context(body.theme-dark) .upload-dialog .journey-step:not(.active):not(.complete) .step-count,
:host-context(body.theme-dark) .upload-dialog .journey-step:not(.active):not(.complete) .label-text,
:host-context(body.theme-dark) .journey-step:not(.active):not(.complete) .step-count,
:host-context(body.theme-dark) .journey-step:not(.active):not(.complete) .label-text {
  color: #64748b !important;
}
:host-context(body.theme-dark) .upload-dialog .journey-step.active,
:host-context(body.theme-dark) .journey-step.active {
  color: #5ea1d8 !important;
}
:host-context(body.theme-dark) .upload-dialog .journey-step.active .step-label,
:host-context(body.theme-dark) .journey-step.active .step-label {
  background: rgba(94, 161, 216, 0.15) !important;
  color: #93c5fd !important;
  border-color: #5ea1d8 !important;
}
:host-context(body.theme-dark) .upload-dialog .journey-step.active .step-count,
:host-context(body.theme-dark) .upload-dialog .journey-step.active .label-text,
:host-context(body.theme-dark) .journey-step.active .step-count,
:host-context(body.theme-dark) .journey-step.active .label-text {
  color: #93c5fd !important;
}
:host-context(body.theme-dark) .upload-dialog .journey-step.complete,
:host-context(body.theme-dark) .journey-step.complete {
  color: #4ade80 !important;
}
:host-context(body.theme-dark) .upload-dialog .journey-step.complete .step-label,
:host-context(body.theme-dark) .journey-step.complete .step-label {
  background: rgba(22, 163, 74, 0.15) !important;
  color: #4ade80 !important;
  border-color: #16a34a !important;
}
:host-context(body.theme-dark) .upload-dialog .journey-step.complete .step-count,
:host-context(body.theme-dark) .upload-dialog .journey-step.complete .label-text,
:host-context(body.theme-dark) .upload-dialog .journey-step.complete .label-check,
:host-context(body.theme-dark) .journey-step.complete .step-count,
:host-context(body.theme-dark) .journey-step.complete .label-text,
:host-context(body.theme-dark) .journey-step.complete .label-check {
  color: #4ade80 !important;
}
:host-context(body.theme-dark) ::ng-deep .mat-mdc-form-field .mdc-text-field--outlined,
:host-context(body.theme-dark) ::ng-deep .mat-mdc-select-value,
:host-context(body.theme-dark) ::ng-deep .mat-mdc-input-element,
:host-context(body.theme-dark) textarea,
:host-context(body.theme-dark) input,
:host-context(body.theme-dark) select {
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) ::ng-deep .mat-mdc-form-field .mdc-notched-outline__leading,
:host-context(body.theme-dark) ::ng-deep .mat-mdc-form-field .mdc-notched-outline__notch,
:host-context(body.theme-dark) ::ng-deep .mat-mdc-form-field .mdc-notched-outline__trailing {
  border-color: rgba(148, 163, 184, 0.4) !important;
}
:host-context(body.theme-dark) .upload-dialog h1,
:host-context(body.theme-dark) .upload-dialog h2,
:host-context(body.theme-dark) .upload-dialog h3,
:host-context(body.theme-dark) .upload-dialog h4,
:host-context(body.theme-dark) .upload-dialog h5,
:host-context(body.theme-dark) .upload-dialog h6,
:host-context(body.theme-dark) .upload-dialog p,
:host-context(body.theme-dark) .upload-dialog span,
:host-context(body.theme-dark) .upload-dialog label,
:host-context(body.theme-dark) .upload-dialog li,
:host-context(body.theme-dark) .upload-dialog small,
:host-context(body.theme-dark) .upload-dialog .mat-mdc-form-field-hint,
:host-context(body.theme-dark) .upload-dialog .mat-mdc-form-field-error,
:host-context(body.theme-dark) .upload-dialog .mdc-floating-label {
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) .upload-dialog .clickable-text {
  color: #5ea1d8 !important;
  text-decoration: underline !important;
  cursor: pointer;
}
:host-context(body.theme-dark) .upload-dialog .clickable-text:hover {
  color: #93c5fd !important;
}
:host-context(body.theme-dark) .upload-dialog .clickable-text .material-icons {
  color: inherit !important;
}
:host-context(body.theme-dark) .upload-body,
:host-context(body.theme-dark) .primary-pane,
:host-context(body.theme-dark) .secondary-pane,
:host-context(body.theme-dark) .journey-content,
:host-context(body.theme-dark) .cover-form-wrapper,
:host-context(body.theme-dark) .section-card,
:host-context(body.theme-dark) .journey-card,
:host-context(body.theme-dark) .summary-card,
:host-context(body.theme-dark) .preview-card,
:host-context(body.theme-dark) .mobile-section,
:host-context(body.theme-dark) .main-content {
  background: transparent !important;
  box-shadow: none !important;
}
:host-context(body.theme-dark) .upload-dialog,
:host-context(body.theme-dark) .upload-dialog .video-title,
:host-context(body.theme-dark) .upload-dialog .video-title-sticky,
:host-context(body.theme-dark) .upload-dialog .mobile-section-title,
:host-context(body.theme-dark) .upload-dialog .mobile-section-description,
:host-context(body.theme-dark) .upload-dialog .flow-card-title,
:host-context(body.theme-dark) .upload-dialog .flow-creator-name,
:host-context(body.theme-dark) .upload-dialog .channel-name,
:host-context(body.theme-dark) .upload-dialog .channel-meta,
:host-context(body.theme-dark) .upload-dialog .document-name,
:host-context(body.theme-dark) .upload-dialog .link-name,
:host-context(body.theme-dark) .upload-dialog [style*="color: #333"],
:host-context(body.theme-dark) .upload-dialog [style*="color:#333"],
:host-context(body.theme-dark) .upload-dialog [style*="color: #666"],
:host-context(body.theme-dark) .upload-dialog [style*="color:#666"] {
  color: #ffffff !important;
}
:host-context(body.theme-dark) .upload-dialog [style*="background: #fff"],
:host-context(body.theme-dark) .upload-dialog [style*="background:#fff"],
:host-context(body.theme-dark) .upload-dialog [style*="background: #ffffff"],
:host-context(body.theme-dark) .upload-dialog [style*="background:#ffffff"],
:host-context(body.theme-dark) .upload-dialog [style*="background-color: #fff"],
:host-context(body.theme-dark) .upload-dialog [style*="background-color:#fff"],
:host-context(body.theme-dark) .upload-dialog [style*="background-color: #ffffff"],
:host-context(body.theme-dark) .upload-dialog [style*="background-color:#ffffff"] {
  background: transparent !important;
  background-color: transparent !important;
}
:host-context(body.theme-dark) ::ng-deep .mat-mdc-form-field .mdc-text-field--outlined,
:host-context(body.theme-dark) ::ng-deep .mat-mdc-form-field-focus-overlay {
  background: transparent !important;
}
:host-context(body.theme-dark) textarea,
:host-context(body.theme-dark) input,
:host-context(body.theme-dark) .mat-mdc-input-element,
:host-context(body.theme-dark) .mat-mdc-text-field-wrapper,
:host-context(body.theme-dark) .mdc-text-field,
:host-context(body.theme-dark) .mdc-text-field--outlined,
:host-context(body.theme-dark) .mdc-text-field--filled {
  background: #111827 !important;
  color: #ffffff !important;
}
:host-context(body.theme-dark) .cover-upload-placeholder,
:host-context(body.theme-dark) .cover-preview,
:host-context(body.theme-dark) .table-inner,
:host-context(body.theme-dark) .img-and-video-sec,
:host-context(body.theme-dark) .step-preview,
:host-context(body.theme-dark) .pending-image-preview {
  background: #111827 !important;
}
:host-context(body.theme-dark) button:not(.btn-primary):not(.footer-btn):not(.add-flows-header-btn):not(.category-action-btn):not(.access-restore-btn),
:host-context(body.theme-dark) .btn:not(.btn-primary),
:host-context(body.theme-dark) .btn-secondary,
:host-context(body.theme-dark) .square_btn,
:host-context(body.theme-dark) .upload-icon-btn,
:host-context(body.theme-dark) .action-item,
:host-context(body.theme-dark) .icon-button {
  background-color: #1f2937 !important;
  color: #ffffff !important;
  border-color: rgba(148, 163, 184, 0.35) !important;
}
:host-context(body.theme-dark) .btn-primary,
:host-context(body.theme-dark) .footer-btn.primary,
:host-context(body.theme-dark) .add-flows-header-btn,
:host-context(body.theme-dark) .category-action-btn {
  background-color: #5ea1d8 !important;
  color: #ffffff !important;
  border-color: #5ea1d8 !important;
}
:host-context(body.theme-dark) .description-section,
:host-context(body.theme-dark) .description-content,
:host-context(body.theme-dark) .summary-description,
:host-context(body.theme-dark) .step-description,
:host-context(body.theme-dark) .cover-details-display,
:host-context(body.theme-dark) .quill-wrapper,
:host-context(body.theme-dark) .quill-field,
:host-context(body.theme-dark) ::ng-deep .ql-container,
:host-context(body.theme-dark) ::ng-deep .ql-toolbar,
:host-context(body.theme-dark) ::ng-deep .ql-editor {
  background: #111827 !important;
  color: #ffffff !important;
  border-color: rgba(148, 163, 184, 0.35) !important;
}
:host-context(body.theme-dark) ::ng-deep .ql-editor.ql-blank::before {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .upload-footer,
:host-context(body.theme-dark) .quick-create-footer,
:host-context(body.theme-dark) .mobile-footer,
:host-context(body.theme-dark) .add-flows-popup-footer {
  background: #111827 !important;
  border-top-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .upload-dialog .mat-mdc-tab-group,
:host-context(body.theme-dark) .upload-dialog .mat-mdc-tab-header,
:host-context(body.theme-dark) .upload-dialog .mat-mdc-tab-body-wrapper,
:host-context(body.theme-dark) .upload-dialog .mat-mdc-tab-body,
:host-context(body.theme-dark) .upload-dialog .mat-mdc-tab-body-content,
:host-context(body.theme-dark) .upload-dialog [role=tabpanel],
:host-context(body.theme-dark) .upload-dialog .journey-content,
:host-context(body.theme-dark) .upload-dialog .quick-create-body {
  background: #111827 !important;
  color: #ffffff !important;
}
:host-context(body.theme-dark) .upload-dialog *[style*="background: white"],
:host-context(body.theme-dark) .upload-dialog *[style*="background:white"],
:host-context(body.theme-dark) .upload-dialog *[style*="background-color: white"],
:host-context(body.theme-dark) .upload-dialog *[style*="background-color:white"],
:host-context(body.theme-dark) .upload-dialog *[style*="background: #fff"],
:host-context(body.theme-dark) .upload-dialog *[style*="background:#fff"],
:host-context(body.theme-dark) .upload-dialog *[style*="background: #ffffff"],
:host-context(body.theme-dark) .upload-dialog *[style*="background:#ffffff"],
:host-context(body.theme-dark) .upload-dialog *[style*="background-color: #fff"],
:host-context(body.theme-dark) .upload-dialog *[style*="background-color:#fff"],
:host-context(body.theme-dark) .upload-dialog *[style*="background-color: #ffffff"],
:host-context(body.theme-dark) .upload-dialog *[style*="background-color:#ffffff"] {
  background: #111827 !important;
  background-color: #111827 !important;
  color: #ffffff !important;
}
:host-context(body.theme-dark) .upload-dialog .journey-content,
:host-context(body.theme-dark) .upload-dialog .bundle-flows-grid,
:host-context(body.theme-dark) .upload-dialog .bundle-flow-card,
:host-context(body.theme-dark) .upload-dialog .flow-card-info,
:host-context(body.theme-dark) .upload-dialog .flow-card-meta,
:host-context(body.theme-dark) .upload-dialog .preview-card,
:host-context(body.theme-dark) .upload-dialog .summary-card,
:host-context(body.theme-dark) .upload-dialog .mobile-section,
:host-context(body.theme-dark) .upload-dialog .mobile-section-body,
:host-context(body.theme-dark) .upload-dialog .flow-main-grid,
:host-context(body.theme-dark) .upload-dialog .flow-main-content,
:host-context(body.theme-dark) .upload-dialog .flow-sidebar.summary-preview-sidebar,
:host-context(body.theme-dark) .upload-dialog .step-navigation,
:host-context(body.theme-dark) .upload-dialog .step-panel-body {
  background: #111827 !important;
  color: #ffffff !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
}

.step-label.complete {
  border-color: #16a34a;
  color: #16a34a;
  background: rgba(22, 163, 74, 0.1);
}

.step-label .label-check {
  font-size: 18px;
  width: 18px;
  height: 18px;
}

.step-label.complete .label-check {
  font-size: 18px;
  margin-left: 0.15rem;
}

.step-connector {
  flex: 1;
  min-width: 20px;
  height: 2px;
  background: #e5e7eb;
  flex-shrink: 0;
  align-self: center;
  margin: 0;
  position: relative;
  z-index: 0;
  top: -10px;
}

.step-connector.fill {
  background: #16a34a;
}

.upload-body {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  padding: 10px;
  background: #fdfdff;
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 0;
  flex: 1 1 auto;
}
.upload-body::-webkit-scrollbar {
  width: 8px;
}
.upload-body::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}
.upload-body::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}
.upload-body::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.upload-footer {
  padding: 20px 32px;
  border-top: 1px solid #e4e8f0;
  background: #fff;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 -6px 18px rgba(15, 23, 42, 0.05);
  flex-shrink: 0;
}
.upload-footer .footer-step {
  flex: 1 1 220px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.footer-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: flex-end;
  flex: 2 1 320px;
  align-items: center;
}

/* Disabled buttons swallow hover, so the tooltip with the reason lives on this wrapper */
.take-public-group {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.take-public-wrap,
.publish-wrap {
  display: inline-flex;
}

.take-public-info {
  flex: 0 0 auto;
  width: 32px;
  height: 32px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: transparent;
  color: #6b7280;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.take-public-info mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  line-height: 20px;
}
.take-public-info:hover, .take-public-info:focus-visible {
  color: #5ea1d8;
  background: rgba(94, 161, 216, 0.1);
}

.footer-btn {
  border-radius: 8px;
  border: 1px solid transparent;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0;
  text-transform: none;
  cursor: pointer;
  transition: all 0.2s ease;
  min-height: 44px;
  margin: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  white-space: nowrap;
  box-sizing: border-box;
}
.footer-btn.primary {
  background: #5ea1d8;
  color: #fff;
  border-color: #5ea1d8;
}
.footer-btn.primary:hover:not(:disabled) {
  background: #4c8ec2;
}
.footer-btn.secondary {
  background: #f4f6fb;
  color: #1f2937;
  border-color: #d1d5db;
}
.footer-btn.secondary:hover:not(:disabled) {
  background: #e8edf5;
}
.footer-btn.ghost {
  background: transparent;
  color: #5ea1d8;
  border-color: #5ea1d8;
}
.footer-btn.ghost:hover:not(:disabled) {
  background: rgba(94, 161, 216, 0.08);
}
.footer-btn.danger {
  color: #b42318;
  border-color: #fda29b;
}
.footer-btn.danger:hover:not(:disabled) {
  background: #fef3f2;
}
.footer-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.approval-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  align-self: center;
  max-width: 260px;
  padding: 6px 12px;
  border-radius: 999px;
  background: #eef6fc;
  color: #1565c0;
  font-size: 12px;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.approval-pill mat-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.approval-pill[data-state=InReview] {
  background: #fff4e5;
  color: #b54708;
}
.approval-pill[data-state=Approved], .approval-pill[data-state=Published] {
  background: #e8f7ee;
  color: #067647;
}
.approval-pill[data-state=Rejected] {
  background: #fdecec;
  color: #b42318;
}

:host-context(body.theme-dark) .approval-pill {
  background: #1a2c3d;
  color: #7ec8f0;
}
:host-context(body.theme-dark) .approval-pill[data-state=InReview] {
  background: rgba(181, 71, 8, 0.2);
  color: #fdba74;
}
:host-context(body.theme-dark) .approval-pill[data-state=Approved], :host-context(body.theme-dark) .approval-pill[data-state=Published] {
  background: rgba(18, 183, 106, 0.16);
  color: #75e0a7;
}
:host-context(body.theme-dark) .approval-pill[data-state=Rejected] {
  background: rgba(240, 68, 56, 0.16);
  color: #fda29b;
}
:host-context(body.theme-dark) .footer-btn.danger {
  color: #fda29b;
  border-color: rgba(240, 68, 56, 0.4);
}

.primary-pane {
  flex: 2 1 640px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  min-height: 0;
  max-height: 100%;
  overflow: hidden;
}
.primary-pane.full-width {
  flex: 1 1 100%;
  max-width: 100%;
}
.primary-pane.access-primary-pane {
  flex: 3.2 1 0;
  min-width: 0;
  max-width: none;
}

.secondary-pane {
  flex: 1 1 320px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.secondary-pane.access-secondary-pane {
  flex: 0 0 280px;
  max-width: 300px;
}

.section-card {
  background: #fff;
  border-radius: 18px;
  border: 1px solid #e4e8f0;
  padding: 24px;
  box-shadow: 0 20px 45px rgba(15, 23, 42, 0.08);
}
.section-card.full-screen-summary {
  border-radius: 0;
  border: none;
  background: transparent;
  padding: 0;
  box-shadow: none;
}
.section-card.journey-card {
  padding: 0;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  max-height: 100%;
  overflow: hidden;
}

.journey-content {
  padding: 24px;
  overflow-y: auto;
  overflow-x: hidden;
  flex: 1 1 0;
  min-height: 0;
  max-height: 100%;
}
.journey-content::-webkit-scrollbar {
  width: 8px;
}
.journey-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}
.journey-content::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}
.journey-content::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.cover-form-wrapper {
  background: #fff;
  border-radius: 0;
  padding: 0;
  max-width: 100%;
}
.cover-form-wrapper h3 {
  font-size: 14px;
  font-weight: 400;
  color: #030303;
  margin: 0 0 8px 0;
  padding: 0;
  border: none;
  text-transform: none;
  letter-spacing: 0;
  line-height: 20px;
}
.cover-form-wrapper .example-form {
  margin-bottom: 0;
  margin-top: 0;
}
.cover-form-wrapper .example-form.field-anchor {
  margin-left: 0;
  margin-right: 0;
}
.cover-form-wrapper .example-form:first-child mat-form-field {
  margin-top: 0;
}
.cover-form-wrapper .example-form:first-child .form-label-wrapper {
  margin-top: 0;
}
.cover-form-wrapper .form-label-wrapper {
  margin-top: 20px;
  margin-bottom: 10px;
  padding: 0;
  margin-left: 0;
  margin-right: 0;
}
.cover-form-wrapper .form-label-wrapper .form-label {
  font-size: 16px;
  font-weight: 500;
  color: #000000;
  display: block;
  margin-bottom: 0;
}
.cover-form-wrapper .form-label-wrapper .form-label.font16 {
  font-size: 16px;
}
.cover-form-wrapper mat-form-field {
  width: 100%;
  margin-top: 20px;
  margin-bottom: 10px;
}
.cover-form-wrapper mat-form-field ::ng-deep .mdc-notched-outline {
  border-radius: 8px;
}
.cover-form-wrapper mat-form-field ::ng-deep .mdc-notched-outline__leading {
  border-radius: 8px 0 0 8px;
}
.cover-form-wrapper mat-form-field ::ng-deep .mdc-notched-outline__trailing {
  border-radius: 0 8px 8px 0;
}
.cover-form-wrapper mat-form-field ::ng-deep .mat-mdc-text-field-input-wrapper {
  border-radius: 8px;
}
.cover-form-wrapper mat-form-field ::ng-deep input.mat-mdc-input-element,
.cover-form-wrapper mat-form-field ::ng-deep input[matInput] {
  border-radius: 8px;
}
.cover-form-wrapper mat-form-field ::ng-deep mat-label {
  color: #000000;
  font-size: 16px;
  font-weight: 500;
}
.cover-form-wrapper .title-field-container {
  position: relative;
  width: 100%;
  margin-bottom: 0;
  margin-top: 0;
}
.cover-form-wrapper .title-field-container .title-field-with-rephrase {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}
.cover-form-wrapper .title-field-container .title-field-with-rephrase ::ng-deep .mat-mdc-form-field-subscript-wrapper {
  margin-top: 0;
  padding-bottom: 0;
  min-height: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.cover-form-wrapper .title-field-container .title-field-with-rephrase ::ng-deep .mat-mdc-form-field-hint-wrapper {
  margin-top: 0;
  padding-bottom: 0;
  order: 1;
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.cover-form-wrapper .title-field-container .title-field-with-rephrase ::ng-deep .mat-mdc-form-field-hint {
  text-align: right;
  width: auto;
  margin: 0;
}
.cover-form-wrapper .title-field-container .title-field-with-rephrase ::ng-deep .mat-mdc-form-field-hint-spacer {
  display: none;
}
.cover-form-wrapper .title-field-container .title-rephrase-wrapper-inline {
  margin-top: 4px;
  margin-bottom: 0;
  padding: 0;
  padding-left: 0;
  padding-right: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
  width: 100%;
}
.cover-form-wrapper .title-field-container .title-rephrase-wrapper-inline .title-rephrase-progress {
  margin-bottom: 0;
  width: 200px;
}
.cover-form-wrapper .title-field-container .title-rephrase-wrapper-inline .title-rephrase-buttons {
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
}
.cover-form-wrapper .title-field-container .title-rephrase-wrapper-inline .title-rephrase-buttons .clickable-text {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #065fd4;
  font-size: 14px;
  cursor: pointer;
  font-weight: 500;
  transition: color 0.2s;
  margin-right: 13px;
}
.cover-form-wrapper .title-field-container .title-rephrase-wrapper-inline .title-rephrase-buttons .clickable-text:hover {
  color: #0d47a1;
}
.cover-form-wrapper .title-field-container .title-rephrase-wrapper-inline .title-rephrase-buttons .clickable-text .material-icons {
  font-size: 18px;
}
.cover-form-wrapper .commonlintbtn-wrapper {
  margin-top: 8px;
  margin-bottom: 24px;
}
.cover-form-wrapper .commonlintbtn-wrapper .commonlintbtn-parent {
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: flex-end;
}
.cover-form-wrapper .commonlintbtn-wrapper .commonlintbtn-parent .clickable-text {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #065fd4;
  font-size: 14px;
  cursor: pointer;
  font-weight: 500;
  transition: color 0.2s;
  margin-right: 13px;
}
.cover-form-wrapper .commonlintbtn-wrapper .commonlintbtn-parent .clickable-text:hover {
  color: #0d47a1;
}
.cover-form-wrapper .commonlintbtn-wrapper .commonlintbtn-parent .clickable-text .material-icons {
  font-size: 18px;
}
.cover-form-wrapper .upload-icon-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  margin-top: 20px;
  margin-bottom: 10px;
  flex-wrap: nowrap;
  width: 100%;
}
.cover-form-wrapper .upload-icon-row .upload-icon-stack {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  flex-shrink: 0;
}
.cover-form-wrapper .upload-icon-row .form-label-wrapper {
  margin-top: 0;
  margin-bottom: 0;
  padding: 0;
  flex-shrink: 0;
  text-align: center;
}
.cover-form-wrapper .upload-icon-row .form-label-wrapper .required-hint {
  display: block;
  font-size: 11px;
  color: #b45309;
  margin-top: 2px;
}
.cover-form-wrapper .upload-icon-row .upload-icon-btn {
  margin-top: 0;
  flex-shrink: 0;
}
.cover-form-wrapper .upload-icon-row .flow-upload-progress {
  flex: 1;
  min-width: 0;
  flex-shrink: 1;
}
.cover-form-wrapper .upload-icon-row .media-size-recommendation {
  flex: 1;
  min-width: 0;
  margin-top: 0;
  padding: 12px;
  background-color: #f0f7ff;
  border-radius: 6px;
  border-left: 3px solid #1d67a3;
  box-sizing: border-box;
}
.cover-form-wrapper .upload-icon-row .media-size-recommendation__inner {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}
.cover-form-wrapper .upload-icon-row .media-size-recommendation__icon {
  color: #1d67a3;
  font-size: 20px;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  margin-top: 2px;
}
.cover-form-wrapper .upload-icon-row .media-size-recommendation__body {
  flex: 1;
  min-width: 0;
}
.cover-form-wrapper .upload-icon-row .media-size-recommendation__title {
  color: #1d67a3;
  font-size: 13px;
  display: block;
  margin-bottom: 4px;
  font-weight: 600;
}
.cover-form-wrapper .upload-icon-row .media-size-recommendation__lines {
  font-size: 12px;
  color: #333;
  line-height: 1.6;
}
.cover-form-wrapper .upload-icon-row .media-size-recommendation__lines div {
  margin-bottom: 4px;
}
.cover-form-wrapper .upload-icon-row .media-size-recommendation__lines div:last-child {
  margin-bottom: 0;
}
@media (max-width: 767px) {
  .cover-form-wrapper .upload-icon-row {
    gap: 12px;
    align-items: flex-start;
  }
  .cover-form-wrapper .upload-icon-row .form-label-wrapper {
    min-width: 0;
  }
}
.cover-form-wrapper .upload-label-inline {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  margin-top: 0;
  margin-bottom: 0;
  padding: 0;
  flex-wrap: nowrap;
}
.cover-form-wrapper .upload-label-inline label,
.cover-form-wrapper .upload-label-inline .form-label {
  margin-top: 0;
  margin-bottom: 0;
  color: #000000;
  font-size: 16px;
  font-weight: 500;
  white-space: nowrap;
}
.cover-form-wrapper .upload-label-inline .upload-icon-btn {
  margin: 0;
  flex-shrink: 0;
}
.cover-form-wrapper .form-label-wrapper.upload-label-inline {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  margin-top: 0;
  margin-bottom: 0;
  padding: 0;
}
.cover-form-wrapper .form-label-wrapper.upload-label-inline label,
.cover-form-wrapper .form-label-wrapper.upload-label-inline .form-label {
  margin: 0;
  white-space: nowrap;
  color: #000000;
  font-size: 16px;
  font-weight: 500;
}
.cover-form-wrapper .form-label-wrapper.upload-label-inline .upload-icon-btn {
  margin: 0;
}
.cover-form-wrapper .upload-progress-inline {
  font-size: 13px;
  color: #64748b;
  display: flex;
  align-items: center;
  gap: 8px;
}
.cover-form-wrapper .upload-progress-inline progress {
  width: 120px;
  height: 6px;
}
.cover-form-wrapper .flow-upload-progress {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 0;
  min-width: 200px;
}
.cover-form-wrapper .flow-upload-progress .flow-progress-bar-container {
  flex: 1;
  height: 4px;
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 2px;
  overflow: hidden;
  position: relative;
  min-width: 120px;
  max-width: 300px;
}
.cover-form-wrapper .flow-upload-progress .flow-progress-bar-container .flow-progress-bar {
  height: 100%;
  background: linear-gradient(90deg, #065fd4 0%, #0d96ff 100%);
  border-radius: 2px;
  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}
.cover-form-wrapper .flow-upload-progress .flow-progress-bar-container .flow-progress-bar::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  animation: shimmer 1.5s infinite;
}
.cover-form-wrapper .flow-upload-progress .flow-progress-text {
  font-size: 12px;
  font-weight: 500;
  color: #065fd4;
  min-width: 40px;
  text-align: right;
  font-family: "Roboto", sans-serif;
}
@keyframes shimmer {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}
.cover-form-wrapper .upload-icon-btn {
  width: 56px;
  height: 56px;
  border-radius: 20px;
  background: #e0f2fe;
  color: #0369a1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  transition: transform 0.2s, box-shadow 0.2s;
  box-shadow: inset 0 0 0 1px rgba(3, 105, 161, 0.1);
}
.cover-form-wrapper .upload-icon-btn.light {
  background: #f8fafc;
  color: #475569;
  box-shadow: inset 0 0 0 1px rgba(15, 23, 42, 0.08);
}
.cover-form-wrapper .upload-icon-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 20px rgba(3, 105, 161, 0.15);
}
.cover-form-wrapper .upload-icon-btn mat-icon {
  font-size: 28px;
  width: 28px;
  height: 28px;
}
.cover-form-wrapper .upload-icon-btn input {
  position: absolute;
  inset: 0;
  opacity: 0;
  cursor: pointer;
}
.cover-form-wrapper .table-wrapper {
  margin-bottom: 24px;
}
.cover-form-wrapper .table-wrapper .table-inner {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  background: #f9f9f9;
  min-height: 200px;
  max-height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}
.cover-form-wrapper .table-wrapper .table-inner img.img-display {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}
.cover-form-wrapper .table-wrapper .table-inner video.video-display {
  width: 100%;
  height: 100%;
  max-height: 400px;
  object-fit: contain;
}
.cover-form-wrapper .table-wrapper .table-inner p.text-center {
  color: #606060;
  font-size: 13px;
  text-align: center;
  padding: 20px;
  margin: 0;
}
.cover-form-wrapper .quill-field {
  width: 100%;
  margin-bottom: 0;
}
.cover-form-wrapper .quill-field.field-anchor {
  margin-left: 0;
  margin-right: 0;
}
.cover-form-wrapper .quill-label {
  display: block;
  color: #000000;
  font-size: 16px;
  font-weight: 500;
  margin-top: 20px;
  margin-bottom: 10px;
  padding: 0;
  line-height: 1.5;
}
.cover-form-wrapper .quill-wrapper {
  margin: 10px 0px;
  border: 1px solid #dadce0;
  border-radius: 8px;
  background: #fff;
  overflow: hidden;
  transition: border-color 0.2s, box-shadow 0.2s;
}
.cover-form-wrapper .quill-wrapper:focus-within {
  border-color: #1a73e8;
  box-shadow: 0 0 0 1px #1a73e8;
}
.cover-form-wrapper .quill-wrapper:hover:not(:focus-within) {
  border-color: #80868b;
}
.cover-form-wrapper .quill-wrapper ::ng-deep .ql-toolbar {
  border: none;
  border-bottom: 1px solid #e0e0e0;
  background: #fff;
  padding: 10px 12px;
}
.cover-form-wrapper .quill-wrapper ::ng-deep .ql-container {
  border: none !important;
  font-size: 14px;
  min-height: 220px;
  background: #fff;
  font-family: "Roboto", "Helvetica Neue", sans-serif;
}
.cover-form-wrapper .quill-wrapper ::ng-deep .ql-editor {
  min-height: 220px;
  font-size: 14px;
  color: #030303;
  line-height: 20px;
  padding: 16px;
}
.cover-form-wrapper .quill-wrapper ::ng-deep .ql-editor.ql-blank::before {
  color: #80868b;
  font-style: normal;
  font-size: 14px;
}

.field-anchor {
  position: relative;
  transition: box-shadow 0.25s ease, border-color 0.25s ease;
  border-radius: 16px;
}

.flow-layout-container {
  width: 100%;
  padding: 0;
  margin: 0;
}
.flow-layout-container .flow-main-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 402px;
  gap: 24px;
  max-width: 100%;
  margin: 0;
  padding: 16px 24px;
}
@media (min-width: 1920px) {
  .flow-layout-container .flow-main-grid {
    max-width: 1920px;
    margin: 0 auto;
    padding: 24px 48px;
  }
}
@media (max-width: 1024px) {
  .flow-layout-container .flow-main-grid {
    grid-template-columns: 1fr;
    gap: 16px;
    padding: 16px;
  }
}
@media (max-width: 768px) {
  .flow-layout-container .flow-main-grid {
    padding: 12px;
    gap: 12px;
  }
}

.flow-main-content {
  min-width: 0;
}
.flow-main-content .flow-title-sticky {
  background: #ffffff;
  border-bottom: 1px solid #e0e0e0;
  padding: 16px 0 8px 0;
  margin-bottom: 8px;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.04);
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  justify-content: space-between;
}
.flow-main-content .flow-title-sticky .video-title-sticky {
  font-size: 20px;
  font-weight: 600;
  line-height: 1.3;
  color: #0f0f0f;
  margin: 4px;
  font-family: "Raleway", sans-serif;
  flex: 1;
  min-width: 0;
}
.flow-main-content .video-player-section {
  background: #000;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 16px;
  position: relative;
}
.flow-main-content .video-player-section .img-wrap {
  width: 100%;
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  background: #000;
}
.flow-main-content .video-player-section .img-wrap img,
.flow-main-content .video-player-section .img-wrap video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #000;
}
.flow-main-content .video-player-section .img-wrap .main-video-player {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  object-fit: contain;
  background: #000;
}
.flow-main-content .video-metadata {
  padding: 16px 0;
  border-bottom: 1px solid #e0e0e0;
  margin-bottom: 16px;
}
.flow-main-content .video-metadata .step-header {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 12px;
  flex-wrap: wrap;
  justify-content: space-between;
}
.flow-main-content .video-metadata .step-header .step-header-main {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  min-width: 0;
}
.flow-main-content .video-metadata .step-header .video-title {
  font-size: 20px;
  font-weight: 500;
  line-height: 28px;
  color: #0f0f0f;
  margin: 0;
  flex: 1;
  min-width: 0;
}
.flow-main-content .video-metadata .video-actions-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  overflow-x: auto;
  overflow-y: hidden;
}
.flow-main-content .video-metadata .video-actions-bar::-webkit-scrollbar {
  height: 6px;
}
.flow-main-content .video-metadata .video-actions-bar::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}
.flow-main-content .video-metadata .video-actions-bar .action-buttons {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap;
  width: max-content;
}
.flow-main-content .video-metadata .video-actions-bar .action-buttons .action-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: 18px;
  cursor: pointer;
  transition: background 0.2s;
  background: #f2f2f2;
  flex: 0 0 auto;
}
.flow-main-content .video-metadata .video-actions-bar .action-buttons .action-item:hover:not(.disabled) {
  background: #e5e5e5;
}
.flow-main-content .video-metadata .video-actions-bar .action-buttons .action-item mat-icon {
  font-size: 18px;
}
.flow-main-content .channel-info-section {
  padding: 16px 0;
  border-bottom: 1px solid #e0e0e0;
  margin-bottom: 16px;
}
.flow-main-content .channel-info-section .channel-header {
  display: flex;
  align-items: center;
  gap: 16px;
}
.flow-main-content .channel-info-section .channel-header .channel-avatar {
  flex-shrink: 0;
}
.flow-main-content .channel-info-section .channel-header .channel-avatar img {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
  cursor: pointer;
}
.flow-main-content .channel-info-section .channel-header .channel-avatar .material-icons {
  font-size: 48px;
  width: 48px;
  height: 48px;
  color: #606060;
  cursor: pointer;
}
.flow-main-content .channel-info-section .channel-header .channel-details {
  flex: 1;
  min-width: 0;
}
.flow-main-content .channel-info-section .channel-header .channel-details .channel-name {
  font-size: 16px;
  font-weight: 500;
  color: #0f0f0f;
  cursor: pointer;
  margin-bottom: 4px;
}
.flow-main-content .channel-info-section .channel-header .channel-details .channel-name:hover {
  color: #606060;
}
.flow-main-content .channel-info-section .channel-header .channel-details .channel-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  font-size: 14px;
  color: #606060;
}
.flow-main-content .channel-info-section .channel-header .channel-details .channel-meta .price-tag {
  font-weight: 600;
  color: #d32f2f;
  cursor: pointer;
}
.flow-main-content .channel-info-section .channel-header .channel-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}
.flow-main-content .channel-info-section .channel-header .channel-actions .follow-btn,
.flow-main-content .channel-info-section .channel-header .channel-actions .purchase-btn {
  border-radius: 999px;
  padding: 6px 16px;
  font-size: 14px;
  font-weight: 500;
  border: none;
  cursor: pointer;
}
.flow-main-content .channel-info-section .channel-header .channel-actions .follow-btn {
  background: #5ea1d8;
  color: #fff;
}
.flow-main-content .channel-info-section .channel-header .channel-actions .purchase-btn {
  background: #111827;
  color: #fff;
}
.flow-main-content .description-section {
  padding: 16px;
  background: #f9f9f9;
  border-radius: 12px;
  margin-bottom: 16px;
}
.flow-main-content .description-section .description-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: -16px !important;
}
.flow-main-content .description-section .description-header h3 {
  font-size: 16px;
  font-weight: 500;
  color: #0f0f0f;
  margin: 0;
}
.flow-main-content .description-section .description-content {
  font-size: 14px;
  line-height: 20px;
  color: #0f0f0f;
  max-height: 60px;
  overflow: hidden;
  transition: max-height 0.3s ease;
}
.flow-main-content .description-section .description-content.expanded {
  max-height: none;
}
.flow-main-content .description-section .description-content .supporting-docs-link {
  margin-top: 12px;
}
.flow-main-content .description-section .description-content .supporting-docs-link a {
  color: #5ea1d8;
  text-decoration: none;
  font-weight: 500;
}
.flow-main-content .description-section .description-content .supporting-docs-link a:hover {
  text-decoration: underline;
}
.flow-main-content .description-section .expand-description-btn {
  margin-top: 8px;
  background: none;
  border: none;
  color: #606060;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  padding: 0;
}
.flow-main-content .description-section .expand-description-btn:hover {
  color: #0f0f0f;
}

.flow-sidebar {
  width: 402px;
  min-width: 402px;
  max-width: 402px;
  position: relative;
  z-index: 10;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
}
@media (max-width: 1024px) {
  .flow-sidebar {
    width: 100%;
    min-width: 100%;
    max-width: 100%;
  }
}
.flow-sidebar.summary-preview-sidebar {
  position: sticky;
  top: 24px;
  height: -moz-fit-content;
  height: fit-content;
}
.flow-sidebar .step-navigation {
  margin-bottom: 24px;
  flex: 0 0 auto;
  min-height: 0;
}
.flow-sidebar .step-navigation .step-scroll {
  max-height: 320px;
  overflow: hidden;
}
.flow-sidebar .step-navigation .steps-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.flow-sidebar .step-navigation .step-btn {
  border: none;
  background: rgba(240, 240, 240, 0.8);
  padding: 10px 16px;
  border-radius: 6px !important;
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
}
.flow-sidebar .step-navigation .step-btn.active {
  background: #5ea1d8;
  color: #fff;
}
.flow-sidebar .step-navigation .step-btn .step-icon {
  font-size: 14px;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.flow-sidebar .step-navigation .step-btn .step-number {
  font-weight: 600;
}
.flow-sidebar .step-navigation .step-btn .step-title-text {
  flex: 1;
  text-align: left;
}
.flow-sidebar .recommendations-section {
  flex: 0 0 auto;
  padding-top: 0;
  border-top: 1px solid #e0e0e0;
  align-self: flex-start;
  width: 100%;
}
.flow-sidebar .recommendations-section h2 {
  font-size: 16px;
  font-weight: 500;
  color: #0f0f0f;
  margin-bottom: 16px;
}
.flow-sidebar .recommendations-section .recommendations-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow-x: hidden;
}
.flow-sidebar .recommendations-section .recommendation-item {
  display: flex;
  gap: 8px;
  cursor: pointer;
  padding: 8px;
  border-radius: 8px;
  transition: background 0.2s;
  overflow: hidden;
}
.flow-sidebar .recommendations-section .recommendation-item:hover {
  background: #f9f9f9;
}
.flow-sidebar .recommendations-section .recommendation-item .recommendation-thumbnail {
  flex-shrink: 0;
  width: 168px;
  height: 94px;
  border-radius: 4px;
  overflow: hidden;
  background: #000;
}
.flow-sidebar .recommendations-section .recommendation-item .recommendation-thumbnail img,
.flow-sidebar .recommendations-section .recommendation-item .recommendation-thumbnail video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.flow-sidebar .recommendations-section .recommendation-item .recommendation-info {
  flex: 1;
  min-width: 0;
}
.flow-sidebar .recommendations-section .recommendation-item .recommendation-info .recommendation-title {
  font-size: 14px;
  font-weight: 500;
  color: #0f0f0f;
  margin: 0 0 4px 0;
  line-height: 20px;
  white-space: normal;
  word-break: break-word;
  overflow: hidden;
}
.flow-sidebar .recommendations-section .recommendation-item .recommendation-info .recommendation-meta {
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-size: 12px;
  color: #606060;
  flex-wrap: wrap;
}
.flow-sidebar .recommendations-section .recommendation-item .recommendation-info .recommendation-meta .recommendation-creator {
  color: #606060;
}
.flow-sidebar .recommendations-section .recommendation-item .recommendation-info .recommendation-meta .recommendation-id {
  color: #909090;
}
.flow-sidebar .recommendations-section .recommendation-item .recommendation-info .recommendation-price {
  display: block;
  margin-top: 4px;
  font-size: 14px;
  font-weight: 500;
  color: #e83e8c;
}
@media (max-width: 1024px) {
  .flow-sidebar .recommendations-section {
    display: none !important;
  }
}

.add-flows-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 10050 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.add-flows-popup-dialog {
  background: #fff;
  border-radius: 12px;
  width: 90%;
  max-width: 1200px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}

.add-flows-popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #e5e7eb;
}
.add-flows-popup-header h4 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #111827;
}
.add-flows-popup-header .icon-button {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background 0.2s;
}
.add-flows-popup-header .icon-button:hover {
  background: #f3f4f6;
}
.add-flows-popup-header .icon-button mat-icon {
  color: #6b7280;
}

.add-flows-popup-body {
  padding: 24px;
  flex: 1;
  overflow-y: auto;
}
.add-flows-popup-body .flow-search-input {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 16px;
  margin-bottom: 16px;
}
.add-flows-popup-body .flow-search-input:focus {
  outline: none;
  border-color: #5ea1d8;
  box-shadow: 0 0 0 3px rgba(94, 161, 216, 0.1);
}

.add-flows-popup-footer {
  padding: 16px 24px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  justify-content: flex-end;
}
.add-flows-popup-footer .btn {
  padding: 10px 24px;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}
.add-flows-popup-footer .btn.btn-primary {
  background: #5ea1d8;
  color: white;
  border: none;
}
.add-flows-popup-footer .btn.btn-primary:hover {
  background: #4a8fc4;
}

input {
  outline: none !important;
}

label {
  color: #212427 !important;
}

.label-button {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 0;
  margin-top: 20px;
  padding: 0;
  margin-left: 0;
  margin-right: 0;
  background: transparent;
  border-radius: 0;
}
.label-button label {
  margin: 0;
  color: #000000;
  font-size: 16px;
  font-weight: 500;
}
.label-button ::ng-deep .mat-mdc-slide-toggle .mdc-switch__track {
  background-color: #ccc;
}
.label-button ::ng-deep .mat-mdc-slide-toggle.mat-checked .mdc-switch__track {
  background-color: #5ea1d8;
}

.creator-paid-only-notice {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  margin-top: 0.75rem;
  padding: 0.85rem 1rem;
  border-radius: 10px;
  background: rgba(94, 161, 216, 0.1);
  border: 1px solid rgba(94, 161, 216, 0.28);
}
.creator-paid-only-notice .notice-title-row {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  max-width: 100%;
}
.creator-paid-only-notice .notice-icon {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  flex: 0 0 18px;
  width: 18px !important;
  height: 18px !important;
  font-size: 18px !important;
  line-height: 18px !important;
  margin: 0 !important;
  padding: 0 !important;
  overflow: visible;
  color: #5ea1d8;
  transform: translateY(1px);
}
.creator-paid-only-notice .notice-lead {
  margin: 0;
  min-width: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #334155;
}
.creator-paid-only-notice .notice-detail {
  margin: 0;
  padding-left: 26px;
  font-size: 14px;
  line-height: 20px;
  color: #334155;
}
.creator-paid-only-notice .upgrade-free-link {
  display: inline-block;
  margin-top: 0.35rem;
  margin-left: 26px;
  border: none;
  background: none;
  padding: 0;
  color: #5ea1d8;
  font-weight: 700;
  font-size: 0.85rem;
  line-height: 1.3;
  cursor: pointer;
  text-decoration: underline;
}

.main-div {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 89vh;
  background: #efeeee !important;
}
.main-div .main-content {
  border-radius: 10px 10px 10px 10px;
  background: #fff;
  padding: 20px 20px !important;
  width: 90%;
  max-width: 600px;
  max-height: auto;
  width: 100%;
  position: relative;
  padding: 0px;
  border: 1px solid #ddd;
  box-shadow: -2px 2px 7px rgba(200, 193, 193, 0.5);
  text-align: center;
}
.main-div .mat-form-field-appearance-legacy .mat-form-field-underline {
  background: lightgray !important;
}
.main-div .font16 {
  font-size: 14px !important;
  font-family: "Raleway";
}
.main-div .table-wrapper .table-inner {
  border-radius: 5px;
  max-height: 300px;
  height: 100%;
  position: relative;
  overflow: hidden;
  min-height: 300px;
  border: 1px solid lightgray;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.main-div .table-wrapper .table-inner img.img-display {
  max-width: 100%;
  max-height: 250px;
  object-fit: contain;
}
.main-div .table-wrapper .table-inner video.video-display {
  width: 100%;
  height: 100%;
}
.main-div .table-wrapper p {
  color: #212427 !important;
  text-align: left !important;
  padding: 10px;
  line-height: 20px;
}
.main-div button.close {
  position: absolute;
  top: -2px;
  right: 6px;
  z-index: 10;
}
.main-div .btn-primary {
  background-color: #5ea1d8;
  border: none;
}
.main-div .flowbycat {
  background-color: transparent;
}
.main-div .transfer-toggle-section {
  margin: 20px 0;
  padding: 16px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}
.main-div .transfer-toggle-section .transfer-toggle {
  display: flex;
  align-items: center;
  gap: 12px;
}
.main-div .transfer-toggle-section .transfer-toggle .toggle-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
  color: #333;
}
.main-div .transfer-toggle-section .transfer-toggle .toggle-label .toggle-icon {
  color: #5ea1d8;
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.main-div .transfer-toggle-section .toggle-description {
  margin-top: 12px;
  padding: 12px;
  background: #e3f2fd;
  border-radius: 6px;
  border-left: 4px solid #5ea1d8;
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 14px;
  color: #1976d2;
}
.main-div .transfer-toggle-section .toggle-description .info-icon {
  color: #5ea1d8;
  font-size: 18px;
  width: 18px;
  height: 18px;
  margin-top: 1px;
}
.main-div .hide_file {
  position: absolute;
  z-index: 1000;
  opacity: 0;
  cursor: pointer;
  right: 0;
  top: 0;
  height: 100%;
  font-size: 24px;
  width: 100%;
}
@media only screen and (max-width: 1024px) and (min-width: 768px) {
  .main-div .main-div {
    min-height: 92vh;
  }
  .main-div .main-content {
    width: 75%;
  }
}

@media only screen and (max-width: 767px) and (min-width: 320px) {
  .main-div {
    background: #fff !important;
  }
  .main-div .main-content {
    width: calc(100% - 30px) !important;
    padding: 5px 5px 20px !important;
  }
}
@media (max-width: 460px) {
  .main-div .table-wrapper .table-inner {
    max-height: 150px;
    min-height: 150px;
  }
  .main-div .table-wrapper .table-inner img.img-display {
    max-height: 100px;
  }
  .main-div .table-wrapper .table-inner .video-display {
    max-height: 100px;
  }
}
/* Mobile refinements to prevent overlaps and align content */
@media (max-width: 460px) {
  h3 {
    font-size: 16px !important;
  }
  .font16 {
    font-size: 12px !important;
  }
  /* Align icon and text; shrink icon */
  .clickable-text .material-icons {
    font-size: 18px !important;
    line-height: 1;
  }
  /* Quill toolbar: allow wrapping */
  .ql-toolbar .ql-formats {
    display: inline-flex;
    flex-wrap: wrap;
    gap: 2px;
  }
  /* Title character counter: override inline margin to avoid overlap */
  .main-div .mat-hint.font16 {
    margin-left: 0 !important;
    display: block;
    width: 100%;
    text-align: right;
    margin-top: 6px;
  }
  .fileExplorer.btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 6px 10px;
    font-size: 12px;
  }
}
.card {
  height: 100px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  width: 30%;
}

.card:hover {
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
}

.add-flow-card-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 20px;
  margin-bottom: 20px;
}
.add-flow-card-wrapper .card.add-flow-card-centered .container {
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  height: 100%;
}
.add-flow-card-wrapper .card.add-flow-card-centered .container h4 {
  margin: 0 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  overflow: visible;
}
.add-flow-card-wrapper .card.add-flow-card-centered .container h4 mat-icon {
  width: 50px !important;
  height: 50px !important;
  font-size: 50px !important;
  line-height: 50px !important;
  overflow: visible;
}
.add-flow-card-wrapper .card.add-flow-card-centered .container p {
  margin: 0 !important;
}

.add-flow-card-centered {
  width: 22% !important;
  margin: 0 auto;
  height: auto !important;
  min-height: 120px;
  padding: 16px;
  overflow: visible;
  display: flex;
  align-items: center;
  justify-content: center;
}

@media (max-width: 768px) {
  .add-flow-card-centered {
    width: 90% !important;
    min-height: 90px;
  }
  .add-flow-card-wrapper .card.add-flow-card-centered .container {
    flex-direction: row;
    gap: 12px;
  }
}
.container {
  padding: 2px 16px;
}

/* new design starta here*/
.createBund .card {
  width: calc(50% - 30px);
  box-shadow: none;
  margin: 40px auto 0px auto;
  height: auto !important;
}
.createBund .card .container {
  padding: 5px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.createBund .card h4 {
  margin: 0px !important;
}
.createBund .card p {
  margin: 0px !important;
}
.createBund .card .mat-icon {
  width: auto;
  color: #212427;
  text-shadow: 0px 2px 2px rgba(186, 183, 183, 0.4);
  font-size: 35px !important;
  height: auto;
}
.createBund form + .row {
  text-align: center;
  width: 100%;
  margin: 0px !important;
  display: flex;
  align-items: center;
  justify-content: end;
}
.createBund .item {
  padding: 5px;
  width: 31% !important;
  margin-right: 0px !important;
  margin-left: 0px !important;
  border: 1px solid #ddd !important;
  margin: 5px !important;
  overflow: hidden;
  background: #fff;
  position: relative;
  box-shadow: -2px 2px 7px hsla(0, 6%, 77%, 0.5);
}
.createBund .item .example-margin {
  position: absolute;
  top: -4px;
  left: 0px;
  color: black;
  font-size: 24px !important;
}
.createBund .item p {
  text-align: left;
}
.createBund .item img {
  border: 1px solid #ddd;
  width: calc(100% - 10px) !important;
  height: 150px !important;
  border-radius: 0 !important;
  margin: 5px !important;
  object-fit: cover;
}
.createBund .item .with-icon {
  display: flex;
}
.createBund .item .with-icon img {
  width: 30px !important;
  height: 30px !important;
  border-radius: 20px !important;
}
.createBund .mat-checkbox {
  position: absolute;
  top: 5px;
  right: 5px;
}
.createBund .mat-checkbox .mat-checkbox-frame {
  border-color: rgb(94, 161, 216) !important;
}

@media (max-width: 768px) {
  .createBund .main-div .table-wrapper .table-inner {
    min-height: 210px !important;
  }
}
@media (max-width: 460px) {
  .createBund form + .row {
    width: 100% !important;
    display: flex;
    justify-content: space-between;
  }
  .createBund .item {
    width: 47% !important;
    margin: 5px !important;
  }
}
@media only screen and (min-width: 461px) and (max-width: 1024px) {
  .createBund form + .row {
    width: 100% !important;
    display: flex;
    justify-content: space-evenly;
  }
  .createBund .item {
    width: 31% !important;
    margin: 5px !important;
  }
}
.bundleIcon {
  position: absolute;
  bottom: 10px;
  right: 10px;
  z-index: 10;
  width: 25px;
  height: 25px;
}
.bundleIcon img {
  width: 100% !important;
  height: auto !important;
  object-fit: contain;
  border: none;
}

.upload-tab-item {
  display: flex;
  padding: 0px;
  margin-top: 10px;
  flex-wrap: wrap;
  align-items: center;
}
.upload-tab-item .inputfield {
  order: 1;
}
.upload-tab-item .file-details {
  order: 4;
  display: block;
  width: 100%;
  text-align: left;
  padding: 0px 10px;
}
.upload-tab-item .item-field {
  order: 2;
}
.upload-tab-item .item-field.upload-field-inline {
  display: flex;
  align-items: flex-start;
}
.upload-tab-item .item-field.upload-field-inline .form-label-wrapper.upload-label-inline {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  margin-top: 0;
  margin-bottom: 0;
  padding: 0;
}
.upload-tab-item .item-field.upload-field-inline .form-label-wrapper.upload-label-inline label {
  margin: 0;
  white-space: nowrap;
}
.upload-tab-item .item-field.upload-field-inline .form-label-wrapper.upload-label-inline .upload-icon-btn {
  margin: 0;
}
.upload-tab-item .addbtn {
  order: 3;
  height: auto;
  display: flex;
  align-items: center;
}
.upload-tab-item .addbtn .btn,
.upload-tab-item .addbtn .btn-primary {
  min-height: 48px;
  height: 48px;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  text-transform: none;
}
.upload-tab-item .example-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 12px;
  margin-bottom: 20px;
}

.tab-design-wrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-top: 0;
  padding: 20px 0;
}
.tab-design-wrapper.field-anchor {
  margin-left: 0;
  margin-right: 0;
}
.tab-design-wrapper mat-form-field {
  margin-left: 0;
  margin-right: 0;
  margin-bottom: 12px;
}
.tab-design-wrapper mat-form-field ::ng-deep .mdc-notched-outline {
  border-radius: 8px;
}
.tab-design-wrapper mat-form-field ::ng-deep .mdc-notched-outline__leading {
  border-radius: 8px 0 0 8px;
}
.tab-design-wrapper mat-form-field ::ng-deep .mdc-notched-outline__trailing {
  border-radius: 0 8px 8px 0;
}
.tab-design-wrapper mat-form-field ::ng-deep mat-label {
  color: #000000;
  font-size: 16px;
  font-weight: 500;
}
.tab-design-wrapper .item-field.upload-field-inline {
  flex: 0 0 auto !important;
  max-width: none !important;
  width: auto !important;
  display: flex;
  align-items: center;
  padding: 0 !important;
  margin-right: 12px;
}
.tab-design-wrapper .upload-label-inline {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  margin-top: 0;
  margin-bottom: 0;
  padding: 0;
  white-space: nowrap;
}
.tab-design-wrapper .upload-label-inline label {
  margin: 0;
  white-space: nowrap;
}
.tab-design-wrapper .upload-label-inline .upload-icon-btn {
  margin: 0;
}
.tab-design-wrapper .addbtn {
  flex: 0 0 auto !important;
  max-width: none !important;
  width: auto !important;
  height: auto !important;
  display: flex !important;
  align-items: center;
  padding: 0 !important;
}
.tab-design-wrapper .addbtn .btn,
.tab-design-wrapper .addbtn .btn-primary {
  white-space: nowrap;
  min-height: 48px;
  height: 48px;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  text-transform: none;
}
.tab-design-wrapper .tab-design-item.field-anchor {
  margin-left: 0;
  margin-right: 0;
}
.tab-design-wrapper .tab-design-item:last-child {
  display: block;
  position: relative;
  order: 4;
}
.tab-design-wrapper .example-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 12px;
  margin-bottom: 20px;
}
.tab-design-wrapper .example-box.document-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #f8fafc;
  transition: box-shadow 0.15s ease, border-color 0.15s ease;
  cursor: grab;
}
.tab-design-wrapper .example-box.document-row:hover {
  border-color: #cbd5e1;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.07);
}
.tab-design-wrapper .example-box.document-row .doc-type-icon {
  flex-shrink: 0;
  font-size: 22px;
  width: 22px;
  height: 22px;
  color: #5ea1d8;
}
.tab-design-wrapper .example-box.document-row .doc-type-icon.link-icon {
  color: #8b5cf6;
}
.tab-design-wrapper .example-box.document-row .doc-name {
  flex: 1;
  font-size: 14px;
  font-weight: 500;
  color: #1e293b;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}
.tab-design-wrapper .example-box.document-row .doc-name-group {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.tab-design-wrapper .example-box.document-row .doc-name-group .doc-name {
  flex: none;
  font-size: 14px;
  font-weight: 500;
  color: #1e293b;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.tab-design-wrapper .example-box.document-row .doc-name-group .doc-url {
  font-size: 12px;
  color: #64748b;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.tab-design-wrapper .example-box.document-row .doc-actions {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}
.tab-design-wrapper .example-box.document-row .doc-action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  background: transparent;
  transition: background 0.15s ease, color 0.15s ease;
}
.tab-design-wrapper .example-box.document-row .doc-action-btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.tab-design-wrapper .example-box.document-row .doc-action-btn.edit {
  color: #5ea1d8;
}
.tab-design-wrapper .example-box.document-row .doc-action-btn.edit:hover {
  background: rgba(94, 161, 216, 0.1);
}
.tab-design-wrapper .example-box.document-row .doc-action-btn.delete {
  color: #ef4444;
}
.tab-design-wrapper .example-box.document-row .doc-action-btn.delete:hover {
  background: rgba(239, 68, 68, 0.1);
}

.img-div-left.small-spinner {
  position: absolute !important;
  width: 100px !important;
  height: 100px !important;
  top: 100px !important;
}
.img-div-left.small-spinner img {
  width: 100px !important;
  height: 100px !important;
  top: unset !important;
}

.quill-wrapper .fl-left {
  margin-bottom: 10px;
  display: block;
}
.quill-wrapper quill-editor {
  width: 100%;
}

.fileExplorer {
  margin-top: 20px;
}

.clickable-text {
  color: #007bff; /* Link color */
  cursor: pointer; /* Pointer cursor on hover */
  text-decoration: underline; /* Underline text */
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.clickable-text:hover {
  color: #0056b3; /* Darker shade on hover */
}

/* Ensure action links wrap and keep spacing */
.commonlintbtn-parent {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  flex-wrap: wrap;
}

.file-upload {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
}

input[type=file] {
  margin-bottom: 10px;
}

button {
  margin-bottom: 20px;
}

mat-progress-bar {
  width: 100%;
  margin-top: 10px;
}

progress {
  appearance: none;
  -webkit-appearance: none;
  border: none; /* Remove any borders */
  background-color: #e0e0e0; /* Background color of the progress bar */
  border-radius: 10px; /* Curve the corners of the entire progress bar */
  overflow: hidden; /* Ensure inner elements respect the border radius */
  height: 20px; /* Optional: adjust the height if needed */
}

progress::-webkit-progress-bar {
  background-color: #e0e0e0; /* Background color of the progress bar */
}

progress::-webkit-progress-value {
  background-color: #5ea1d8; /* The color of the actual progress */
}

progress::-moz-progress-bar {
  background-color: #5ea1d8; /* The color of the actual progress in Firefox */
}

@media (max-width: 1200px) {
  .upload-body {
    flex-direction: column;
  }
  .secondary-pane {
    flex-direction: row;
    flex-wrap: wrap;
  }
}
@media (max-width: 768px) {
  .upload-backdrop {
    padding: 0;
  }
  .upload-dialog {
    width: 100%;
    height: 100vh;
    max-height: 100vh;
    border-radius: 0;
  }
  .upload-header,
  .stage-banner {
    padding: 20px;
  }
  .upload-body {
    padding: 20px;
  }
  .section-card {
    padding: 18px;
  }
  .journey-progress {
    overflow-x: auto !important;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    padding-top: 8px;
    margin-top: 8px;
    touch-action: pan-x;
  }
  .journey-progress::-webkit-scrollbar {
    display: none;
  }
  .step-connector {
    display: block !important;
    flex: 0 0 16px;
    min-width: 16px;
    height: 2px;
    margin: 0 4px;
    align-self: center;
  }
  .journey-step {
    flex: 0 0 auto;
    padding-right: 8px;
    touch-action: pan-x !important;
  }
  .step-label {
    font-size: 12px;
    letter-spacing: 0.02em;
  }
  .journey-content {
    padding: 16px;
    overflow-x: hidden;
  }
  mat-form-field {
    width: 100%;
    max-width: 100%;
  }
  .cover-form-wrapper,
  .cover-form-wrapper .row,
  .cover-form-wrapper .col-12,
  .cover-form-wrapper [class*=col-] {
    max-width: 100%;
  }
  .cover-form-wrapper .row {
    margin-left: 0;
    margin-right: 0;
  }
  .cover-form-wrapper [class*=col-] {
    padding-left: 0;
    padding-right: 0;
  }
  .upload-dialog {
    height: 100dvh;
    max-height: 100dvh;
  }
  .upload-footer {
    display: flex !important;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 10010;
    padding: 8px 12px;
    padding-bottom: max(8px, env(safe-area-inset-bottom));
    gap: 8px;
    flex-wrap: nowrap;
    align-items: center;
  }
  .upload-body {
    padding-bottom: calc(80px + env(safe-area-inset-bottom));
  }
  .upload-footer .footer-step,
  .upload-footer .footer-actions {
    flex: 1 1 0;
    min-width: 0;
  }
  .upload-footer .footer-step .footer-btn {
    width: 100%;
  }
  .upload-footer .footer-actions {
    display: flex;
    flex-wrap: nowrap;
    gap: 8px;
    justify-content: stretch;
  }
  .upload-footer .footer-actions .take-public-group,
  .upload-footer .footer-actions .take-public-wrap,
  .upload-footer .footer-actions .publish-wrap {
    flex: 1 1 0;
    min-width: 0;
    display: flex;
  }
  .upload-footer .footer-actions .footer-btn {
    flex: 1 1 0;
    width: 100%;
    min-height: 36px;
    padding: 6px 12px;
    font-size: 12px;
    letter-spacing: 0.02em;
  }
  /* Secondary actions sit in the ⋮ menu; the button keeps a fixed square size */
  .upload-footer .footer-actions .footer-more-btn {
    flex: 0 0 36px;
    width: 36px;
    height: 36px;
    padding: 0;
    border-radius: 50%;
    border: 1px solid #d0d7de;
    background: #fff;
    color: #374151;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  .upload-footer .footer-actions .footer-more-btn mat-icon {
    font-size: 22px;
    width: 22px;
    height: 22px;
    line-height: 22px;
  }
  :host-context(body.theme-dark) .upload-footer .footer-actions .footer-more-btn {
    background: #1b1f27;
    border-color: #2f3542;
    color: #e2e8f0;
  }
  :host ::ng-deep .standard-tab-group .mat-mdc-tab-header-pagination {
    display: none !important;
  }
  :host ::ng-deep .standard-tab-group .mat-mdc-tab-label-container {
    overflow-x: auto !important;
    overflow-y: hidden !important;
    -webkit-overflow-scrolling: touch;
    touch-action: pan-x;
    scrollbar-width: none;
  }
  :host ::ng-deep .standard-tab-group .mat-mdc-tab-label-container::-webkit-scrollbar {
    display: none;
  }
  :host ::ng-deep .standard-tab-group .mat-mdc-tab-list {
    transform: none !important;
    width: max-content;
  }
  :host ::ng-deep .standard-tab-group .mat-mdc-tab-labels {
    width: max-content;
    flex-wrap: nowrap;
  }
  :host ::ng-deep .standard-tab-group .mdc-tab__text-label > span {
    min-width: 0 !important;
  }
}
.confirm-menu {
  padding: 16px;
  border-bottom: 1px solid #e4e8f0;
}
.confirm-menu h5 {
  margin: 0 0 8px 0;
  font-size: 16px;
  font-weight: 600;
  color: #111827;
}
.confirm-menu p {
  margin: 0;
  font-size: 14px;
  color: #64748b;
  line-height: 1.5;
}

::ng-deep .upload-backdrop .cdk-overlay-pane {
  z-index: 10030 !important;
}
::ng-deep .upload-backdrop .cdk-overlay-backdrop {
  z-index: 10029 !important;
}
::ng-deep .upload-backdrop .mat-mdc-menu-panel {
  z-index: 10031 !important;
}

::ng-deep .cdk-overlay-container .cdk-overlay-pane[data-mat-menu-panel], ::ng-deep .cdk-overlay-container .cdk-overlay-pane[class*=menu], ::ng-deep .cdk-overlay-container .cdk-overlay-pane:has(.mat-mdc-menu-panel), ::ng-deep .cdk-overlay-container .cdk-overlay-pane:has(.mat-menu-panel) {
  z-index: 10030 !important;
}

::ng-deep body .cdk-overlay-pane:has(.mat-mdc-menu-panel), ::ng-deep body .cdk-overlay-pane:has(.mat-menu-panel) {
  z-index: 10030 !important;
}
::ng-deep body .cdk-overlay-container .cdk-overlay-pane[class*=menu], ::ng-deep body .cdk-overlay-container .cdk-overlay-pane:has(.mat-mdc-menu-panel), ::ng-deep body .cdk-overlay-container .cdk-overlay-pane:has(.mat-menu-panel) {
  z-index: 10030 !important;
}

.preview-card .preview-content {
  max-height: 600px;
  overflow-y: auto;
}
.preview-card .preview-content::-webkit-scrollbar {
  width: 6px;
}
.preview-card .preview-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}
.preview-card .preview-content::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}
.preview-card .preview-content::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
.preview-card .mobile-preview-wrapper {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.preview-card .mobile-section {
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 12px 28px rgba(31, 47, 70, 0.1);
  overflow: hidden;
  margin-bottom: 16px;
}
.preview-card .mobile-section .mobile-media {
  background: #000;
  width: 100%;
  min-height: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.preview-card .mobile-section .mobile-media img,
.preview-card .mobile-section .mobile-media video {
  width: 100%;
  max-height: 260px;
  object-fit: cover;
  display: block;
}
.preview-card .mobile-section .mobile-media.placeholder {
  color: #9ca3af;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: #f3f4f6;
}
.preview-card .mobile-section .mobile-media.placeholder mat-icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
}
.preview-card .mobile-section .mobile-media.placeholder p {
  margin: 0;
  font-size: 14px;
}
.preview-card .mobile-section .mobile-section-body {
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.preview-card .mobile-section .mobile-section-title {
  font-size: 20px;
  font-weight: 600;
  margin: 0;
  color: #1f2f46;
  line-height: 1.4;
}
.preview-card .mobile-section .mobile-section-description {
  color: #4a5568;
  line-height: 1.6;
  font-size: 14px;
}
.preview-card .mobile-section .mobile-section-description p {
  margin-bottom: 12px;
}
.preview-card .mobile-section .mobile-meta-row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 8px;
}
.preview-card .mobile-section .mobile-meta-row .info-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 12px;
  border-radius: 999px;
  background: #f1f5f9;
  color: #475569;
  font-size: 13px;
}
.preview-card .mobile-section .mobile-meta-row .info-badge mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: #5ea1d8;
}
.preview-card .preview-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  text-align: center;
  color: #9ca3af;
}
.preview-card .preview-empty mat-icon {
  font-size: 64px;
  width: 64px;
  height: 64px;
  margin-bottom: 16px;
  color: #d1d5db;
}
.preview-card .preview-empty p {
  margin: 0;
  font-size: 16px;
  color: #6b7280;
}
.preview-card .mobile-documents-view {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.preview-card .mobile-documents-list,
.preview-card .mobile-links-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 12px;
}
.preview-card .mobile-document-item,
.preview-card .mobile-link-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #fff;
  transition: all 0.2s ease;
}
.preview-card .mobile-document-item:hover,
.preview-card .mobile-link-item:hover {
  border-color: #cbd5e1;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}
.preview-card .mobile-document-item .document-icon,
.preview-card .mobile-document-item .link-icon,
.preview-card .mobile-link-item .document-icon,
.preview-card .mobile-link-item .link-icon {
  font-size: 24px;
  width: 24px;
  height: 24px;
  color: #5ea1d8;
  flex-shrink: 0;
}
.preview-card .mobile-document-item .document-info,
.preview-card .mobile-document-item .link-info,
.preview-card .mobile-link-item .document-info,
.preview-card .mobile-link-item .link-info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.preview-card .mobile-document-item .document-info .document-name,
.preview-card .mobile-document-item .document-info .link-name,
.preview-card .mobile-document-item .link-info .document-name,
.preview-card .mobile-document-item .link-info .link-name,
.preview-card .mobile-link-item .document-info .document-name,
.preview-card .mobile-link-item .document-info .link-name,
.preview-card .mobile-link-item .link-info .document-name,
.preview-card .mobile-link-item .link-info .link-name {
  font-size: 14px;
  font-weight: 600;
  color: #1f2f46;
}
.preview-card .mobile-document-item .document-info .document-link,
.preview-card .mobile-document-item .document-info .link-url,
.preview-card .mobile-document-item .link-info .document-link,
.preview-card .mobile-document-item .link-info .link-url,
.preview-card .mobile-link-item .document-info .document-link,
.preview-card .mobile-link-item .document-info .link-url,
.preview-card .mobile-link-item .link-info .document-link,
.preview-card .mobile-link-item .link-info .link-url {
  font-size: 12px;
  color: #2563eb;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-weight: 500;
}
.preview-card .mobile-document-item .document-info .document-link:hover,
.preview-card .mobile-document-item .document-info .link-url:hover,
.preview-card .mobile-document-item .link-info .document-link:hover,
.preview-card .mobile-document-item .link-info .link-url:hover,
.preview-card .mobile-link-item .document-info .document-link:hover,
.preview-card .mobile-link-item .document-info .link-url:hover,
.preview-card .mobile-link-item .link-info .document-link:hover,
.preview-card .mobile-link-item .link-info .link-url:hover {
  text-decoration: underline;
}
.preview-card .mobile-document-item .document-info .document-link .link-icon-tiny,
.preview-card .mobile-document-item .document-info .link-url .link-icon-tiny,
.preview-card .mobile-document-item .link-info .document-link .link-icon-tiny,
.preview-card .mobile-document-item .link-info .link-url .link-icon-tiny,
.preview-card .mobile-link-item .document-info .document-link .link-icon-tiny,
.preview-card .mobile-link-item .document-info .link-url .link-icon-tiny,
.preview-card .mobile-link-item .link-info .document-link .link-icon-tiny,
.preview-card .mobile-link-item .link-info .link-url .link-icon-tiny {
  font-size: 14px;
  width: 14px;
  height: 14px;
}
.preview-card .mobile-pricing-view .pricing-info {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.preview-card .mobile-pricing-view .pricing-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #fff;
}
.preview-card .mobile-pricing-view .pricing-row .pricing-label {
  font-size: 14px;
  font-weight: 500;
  color: #64748b;
}
.preview-card .mobile-pricing-view .pricing-row .pricing-value {
  font-size: 16px;
  font-weight: 600;
  color: #1f2f46;
}
.preview-card .mobile-pricing-view .pricing-row .pricing-value.price-amount {
  color: #16a34a;
  font-size: 18px;
}
.preview-card .mobile-pricing-view .pricing-row .pricing-warning {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #dc2626;
  font-size: 13px;
  font-weight: 500;
}
.preview-card .mobile-pricing-view .pricing-row .pricing-warning mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
@media (max-width: 767px) {
  .preview-card .mobile-pricing-view .pricing-row {
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 6px;
  }
}
.preview-card .mobile-flows-view {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.preview-card .mobile-flows-view .flows-count-badge {
  padding: 8px 16px;
  background: #e0f2fe;
  border-radius: 8px;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  color: #0284c7;
  margin-bottom: 8px;
}
.preview-card .mobile-flows-view .mobile-flows-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.preview-card .mobile-flows-view .mobile-flow-item {
  display: flex;
  gap: 12px;
  padding: 12px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #fff;
  cursor: pointer;
  transition: all 0.2s ease;
}
.preview-card .mobile-flows-view .mobile-flow-item:hover {
  border-color: #cbd5e1;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  transform: translateY(-1px);
}
.preview-card .mobile-flows-view .mobile-flow-item .mobile-flow-thumbnail {
  width: 80px;
  height: 60px;
  border-radius: 8px;
  background: #f1f5f9;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.preview-card .mobile-flows-view .mobile-flow-item .mobile-flow-thumbnail img,
.preview-card .mobile-flows-view .mobile-flow-item .mobile-flow-thumbnail video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.preview-card .mobile-flows-view .mobile-flow-item .mobile-flow-thumbnail .mobile-flow-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: #9ca3af;
}
.preview-card .mobile-flows-view .mobile-flow-item .mobile-flow-thumbnail .mobile-flow-placeholder mat-icon {
  font-size: 32px;
  width: 32px;
  height: 32px;
}
.preview-card .mobile-flows-view .mobile-flow-item .mobile-flow-content {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
  justify-content: center;
}
.preview-card .mobile-flows-view .mobile-flow-item .mobile-flow-content .mobile-flow-title {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #1f2f46;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.preview-card .mobile-flows-view .mobile-flow-item .mobile-flow-content .mobile-flow-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #64748b;
}
.preview-card .mobile-flows-view .mobile-flow-item .mobile-flow-content .mobile-flow-meta .flow-creator {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.preview-card .mobile-flows-view .mobile-flow-item .mobile-flow-content .mobile-flow-meta .flow-price {
  font-weight: 600;
  color: #16a34a;
}

.flow-thumbnail-section {
  margin-top: 24px;
  padding: 0;
  background: transparent;
}

.thumbnail-section-header {
  margin-bottom: 16px;
}
.thumbnail-section-header h4 {
  font-size: 14px;
  font-weight: 500;
  color: #030303;
  margin: 0 0 4px 0;
  line-height: 20px;
}
.thumbnail-section-header p {
  font-size: 13px;
  color: #606060;
  margin: 0;
  line-height: 18px;
}

.thumbnail-choice-row {
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}

.thumbnail-dialog-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.65);
  z-index: 10010;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}

.thumbnail-dialog-card {
  width: min(960px, 90vw);
  max-height: 90vh;
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 25px 60px rgba(15, 23, 42, 0.3);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.thumbnail-dialog-header {
  padding: 20px 24px;
  border-bottom: 1px solid #e4e8f0;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  position: relative;
  z-index: 10011;
}
.thumbnail-dialog-header h4 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
}
.thumbnail-dialog-header p {
  margin: 4px 0 0;
  color: #64748b;
  font-size: 14px;
  max-width: 480px;
}
.thumbnail-dialog-header .icon-button {
  z-index: 10012;
}

.thumbnail-dialog-body {
  padding: 24px;
  overflow-y: auto;
}
@media (max-width: 768px) {
  .thumbnail-dialog-body {
    padding: 16px;
  }
}

.thumbnail-choice {
  flex: 1;
  min-width: 160px;
  border: 1px dashed #d3d3d3;
  background: #fff;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  border-radius: 4px;
  cursor: pointer;
  transition: border-color 0.2s ease, background-color 0.2s ease;
  font-size: 13px;
  color: #030303;
}
.thumbnail-choice.selected {
  border: 1px solid #065fd4;
  background: rgba(6, 95, 212, 0.05);
}
.thumbnail-choice.disabled {
  opacity: 0.5;
  cursor: default;
}

.choice-icon {
  font-size: 20px;
  color: #606060;
}

.choice-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
}
.choice-text strong {
  font-weight: 500;
  font-size: 13px;
}
.choice-text small {
  font-size: 12px;
  color: #606060;
}

.thumbnail-mode {
  margin-top: 0;
  margin-bottom: 16px;
}
.thumbnail-mode.upload-mode {
  margin-bottom: 24px;
}

.thumbnail-mode-header {
  margin-bottom: 12px;
}
.thumbnail-mode-header h5 {
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  color: #030303;
}
.thumbnail-mode-header p {
  margin: 4px 0 0 0;
  font-size: 12px;
  color: #606060;
}

.yt-button {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 6px 12px;
  border: 1px solid #d3d3d3;
  background: #fff;
  color: #030303;
  font-size: 13px;
  border-radius: 2px;
  cursor: pointer;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}
.yt-button:hover {
  background: #f0f0f0;
}
.yt-button:disabled {
  color: #9e9e9e;
  border-color: #e0e0e0;
  cursor: not-allowed;
}
.yt-button.primary {
  background: #065fd4;
  color: #fff;
  border-color: #065fd4;
}
.yt-button.primary:hover {
  background: #0d96ff;
  border-color: #0d96ff;
}
.yt-button mat-icon {
  font-size: 16px;
}

.video-preview-container {
  margin-bottom: 16px;
}

.video-wrapper {
  position: relative;
  width: 100%;
  max-width: 640px;
  background: #000;
  border-radius: 0;
  overflow: hidden;
  aspect-ratio: 16/9;
}

.thumbnail-video-preview {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

.video-controls-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.75), transparent);
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.video-scrubber-container {
  display: flex;
  align-items: center;
  gap: 12px;
}

.video-scrubber {
  flex: 1;
  height: 4px;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 2px;
  outline: none;
  cursor: pointer;
}
.video-scrubber::-webkit-slider-thumb {
  -webkit-appearance: none;
          appearance: none;
  width: 14px;
  height: 14px;
  background: #fff;
  border-radius: 50%;
  cursor: pointer;
}
.video-scrubber::-moz-range-thumb {
  width: 14px;
  height: 14px;
  background: #fff;
  border-radius: 50%;
  cursor: pointer;
  border: none;
}

.scrubber-time {
  color: #fff;
  font-size: 12px;
  font-weight: 400;
  white-space: nowrap;
  min-width: 70px;
  text-align: right;
}

.capture-frame-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: rgba(255, 255, 255, 0.9);
  color: #030303;
  border: none;
  border-radius: 2px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s ease;
}
.capture-frame-btn:hover {
  background: #fff;
}
.capture-frame-btn mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}

.thumbnails-horizontal-scroll {
  display: flex;
  gap: 8px;
  overflow-x: auto;
  padding-bottom: 4px;
  scrollbar-width: thin;
  scrollbar-color: #d3d3d3 transparent;
}
.thumbnails-horizontal-scroll::-webkit-scrollbar {
  height: 4px;
}
.thumbnails-horizontal-scroll::-webkit-scrollbar-track {
  background: transparent;
}
.thumbnails-horizontal-scroll::-webkit-scrollbar-thumb {
  background: #d3d3d3;
  border-radius: 2px;
}
.thumbnails-horizontal-scroll::-webkit-scrollbar-thumb:hover {
  background: #b3b3b3;
}

.thumbnail-item-small {
  position: relative;
  width: 120px;
  height: 68px;
  flex-shrink: 0;
  border-radius: 0;
  overflow: hidden;
  cursor: pointer;
  border: 2px solid transparent;
  transition: border-color 0.15s ease;
  background: #000;
}
.thumbnail-item-small:hover {
  border-color: #065fd4;
}
.thumbnail-item-small.selected {
  border-color: #065fd4;
  border-width: 3px;
}
.thumbnail-item-small img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.thumbnail-check-small {
  position: absolute;
  top: 4px;
  right: 4px;
  background: #065fd4;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.thumbnail-check-small mat-icon {
  color: #fff;
  font-size: 12px;
  width: 12px;
  height: 12px;
}

.thumbnails-loading-small {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 0;
  color: #606060;
  font-size: 13px;
}

.no-thumbnails-message {
  padding: 12px 0;
  text-align: left;
  color: #606060;
  font-size: 13px;
}

.custom-thumbnail-upload-compact {
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-width: 320px;
}

.upload-preview-compact {
  position: relative;
  width: 320px;
  height: 180px;
  border-radius: 0;
  overflow: hidden;
  background: #f9f9f9;
  border: 1px solid #d3d3d3;
  flex-shrink: 0;
}

.custom-thumbnail-preview-small {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.upload-placeholder-compact {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #f9f9f9;
  gap: 8px;
}
.upload-placeholder-compact mat-icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
  color: #909090;
}
.upload-placeholder-compact span {
  font-size: 13px;
  color: #606060;
  font-weight: 400;
}

.upload-progress-compact {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: #f9f9f9;
}
.upload-progress-compact span {
  font-size: 13px;
  color: #606060;
}

.thumbnail-upload-action {
  margin-top: 12px;
}

.flows-sequence-toggle-row {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 8px;
}
.flows-sequence-toggle-row .form-label {
  margin-bottom: 0;
}

.nested-bundles-section {
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
}

.nested-category-header {
  margin-top: 8px;
  margin-bottom: 20px;
}
.nested-category-header h5 {
  margin: 0 0 6px;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.3;
  color: #111827;
}
.nested-category-header p {
  margin: 0;
  color: #6b7280;
  font-size: 14px;
  line-height: 1.4;
}

.nested-categories-panel {
  margin-top: 20px;
  padding-top: 4px;
}

.add-category-row mat-form-field,
.bundle-category-card-header mat-form-field {
  flex: 1 1 auto;
  width: auto !important;
  min-width: 0;
  margin: 0 !important;
}
.add-category-row mat-form-field ::ng-deep .mat-mdc-form-field-subscript-wrapper,
.bundle-category-card-header mat-form-field ::ng-deep .mat-mdc-form-field-subscript-wrapper {
  display: none;
}
.add-category-row mat-form-field ::ng-deep .mat-mdc-form-field-infix,
.bundle-category-card-header mat-form-field ::ng-deep .mat-mdc-form-field-infix {
  min-height: 48px;
  padding-top: 12px;
  padding-bottom: 12px;
}
.add-category-row mat-form-field ::ng-deep .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-floating-label,
.bundle-category-card-header mat-form-field ::ng-deep .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-floating-label {
  top: 24px;
}
.add-category-row mat-form-field ::ng-deep .mdc-text-field--outlined .mdc-notched-outline--upgraded .mdc-floating-label--float-above,
.bundle-category-card-header mat-form-field ::ng-deep .mdc-text-field--outlined .mdc-notched-outline--upgraded .mdc-floating-label--float-above {
  --mat-mdc-form-field-label-transform: translateY(-30.75px) scale(var(--mat-mdc-form-field-floating-label-scale, 0.75));
  transform: var(--mat-mdc-form-field-label-transform);
}

.add-category-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}
.add-category-row .add-flows-header-btn {
  min-height: 48px;
  height: 48px;
  margin: 0 !important;
  align-self: center;
}

.bundle-category-card {
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
  background: rgba(0, 0, 0, 0.02);
}

.bundle-category-card-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
}
.bundle-category-card-header .category-name-field {
  flex: 1;
  margin-bottom: 0;
}
.bundle-category-card-header .category-name-field ::ng-deep .mat-mdc-form-field-subscript-wrapper {
  display: none;
}
.bundle-category-card-header .icon-button {
  flex-shrink: 0;
  align-self: center;
  color: #6b7280;
}
.bundle-category-card-header .icon-button:hover {
  color: #dc2626;
  background: #fee2e2;
}

.category-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  margin: 4px 0 12px;
}
.category-actions .category-action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 48px;
  height: 48px;
  padding: 12px 20px;
  margin: 0;
  border: none;
  border-radius: 8px;
  background: #5ea1d8;
  color: #fff;
  font-weight: 500;
  font-size: 14px;
  line-height: 1.2;
  white-space: nowrap;
  cursor: pointer;
  transition: background 0.2s;
  text-transform: none;
  box-sizing: border-box;
}
.category-actions .category-action-btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  line-height: 18px;
}
.category-actions .category-action-btn:hover {
  background: #4a8fc4;
  color: #fff;
}

.category-subsection {
  margin-top: 16px;
  padding-top: 12px;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
}
.category-subsection h6 {
  margin: 0 0 12px;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.3;
  color: #374151;
}

.journey-pane-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
}
.journey-pane-header h5 {
  margin: 0;
}
.journey-pane-header p {
  margin: 4px 0 0;
  color: #6b7280;
  font-size: 14px;
}

.add-flows-header-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  flex-shrink: 0;
  white-space: nowrap;
  min-height: 48px;
  height: 48px;
  padding: 12px 20px;
  border: none;
  border-radius: 8px;
  background: #5ea1d8;
  color: #fff;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.2s;
  text-transform: none;
  box-sizing: border-box;
}
.add-flows-header-btn mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  line-height: 20px;
}
.add-flows-header-btn:hover {
  background: #4a8fc4;
}

@media (max-width: 768px) {
  .journey-pane-header {
    flex-direction: column;
    align-items: stretch;
  }
  .add-flows-header-btn {
    width: 100%;
    justify-content: center;
  }
  .add-category-row {
    flex-direction: column;
    align-items: stretch;
  }
  .add-category-row .add-flows-header-btn {
    width: 100%;
    min-height: 48px;
    height: 48px;
  }
  .category-actions {
    flex-direction: column;
    align-items: stretch;
  }
  .category-actions .category-action-btn {
    width: 100%;
    justify-content: center;
  }
}
.flows-sequence-hint {
  margin: 8px 0 0;
  font-size: 14px;
  line-height: 1.4;
  color: #5ea1d8;
}
.flows-sequence-hint.muted {
  color: #666;
}

.bundle-flows-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 16px;
  margin-top: 20px;
  padding: 0;
}
@media (max-width: 768px) {
  .bundle-flows-grid {
    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
    gap: 12px;
  }
}

.bundle-flow-card {
  position: relative;
  background: #fff;
  border-radius: 12px;
  border: 1px solid #e0e0e0;
  overflow: hidden;
  transition: all 0.2s ease;
  cursor: pointer;
}
.bundle-flow-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}
.bundle-flow-card .flow-card-delete-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 10;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.6);
  border: none;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
}
.bundle-flow-card .flow-card-delete-btn:hover {
  background: rgba(0, 0, 0, 0.8);
  transform: scale(1.1);
}
.bundle-flow-card .flow-card-delete-btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.bundle-flow-card .flow-card-checkbox {
  position: absolute;
  top: 8px;
  left: 8px;
  z-index: 10;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 4px;
}
.bundle-flow-card .flow-locked-badge {
  position: absolute;
  top: 14px;
  left: 56px;
  right: 8px;
  z-index: 10;
  width: -moz-fit-content;
  width: fit-content;
  max-width: calc(100% - 64px);
  padding: 3px 8px;
  border-radius: 4px;
  background: rgba(17, 24, 39, 0.85);
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.bundle-flow-card.bundle-flow-card--locked {
  cursor: default;
}
.bundle-flow-card.bundle-flow-card--locked .flow-card-thumbnail,
.bundle-flow-card.bundle-flow-card--locked .flow-card-info {
  opacity: 0.55;
}
.bundle-flow-card.bundle-flow-card--locked:hover {
  box-shadow: none;
}
.bundle-flow-card .flow-card-thumbnail {
  position: relative;
  width: 100%;
  padding-top: 56.25%;
  overflow: hidden;
  background: #000;
  cursor: pointer;
}
.bundle-flow-card .flow-card-thumbnail .flow-thumbnail-image,
.bundle-flow-card .flow-card-thumbnail .flow-thumbnail-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.bundle-flow-card .flow-card-thumbnail .flow-thumbnail-video {
  background: #000;
}
.bundle-flow-card .flow-card-thumbnail .flow-seq-badge {
  position: absolute;
  top: 8px;
  left: 8px;
  z-index: 6;
  min-width: 24px;
  height: 24px;
  padding: 0 8px;
  border-radius: 999px;
  background: rgba(94, 161, 216, 0.95);
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
}
.bundle-flow-card .flow-card-thumbnail .flow-price-badge {
  position: absolute;
  bottom: 8px;
  right: 8px;
  background: rgba(0, 0, 0, 0.8);
  color: #fff;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  z-index: 5;
}
.bundle-flow-card .flow-card-thumbnail .flow-access-badge {
  position: absolute;
  bottom: 8px;
  left: 8px;
  background: rgba(30, 77, 114, 0.9);
  color: #fff;
  padding: 3px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  z-index: 5;
}
.bundle-flow-card .matching-access-toggle-row {
  margin: 0 0 12px;
}
.bundle-flow-card .flow-card-info {
  padding: 12px;
}
.bundle-flow-card .flow-card-info .flow-card-title {
  margin: 0 0 8px 0;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.4;
  color: #0f0f0f;
  cursor: pointer;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  min-height: 40px;
  transition: color 0.2s ease;
}
.bundle-flow-card .flow-card-info .flow-card-title:hover {
  color: #5ea1d8;
}
.bundle-flow-card .flow-card-info .flow-card-meta {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.bundle-flow-card .flow-card-info .flow-card-meta .flow-card-creator {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: opacity 0.2s ease;
}
.bundle-flow-card .flow-card-info .flow-card-meta .flow-card-creator:hover {
  opacity: 0.8;
}
.bundle-flow-card .flow-card-info .flow-card-meta .flow-card-creator .flow-creator-avatar {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  object-fit: cover;
}
.bundle-flow-card .flow-card-info .flow-card-meta .flow-card-creator .flow-creator-icon {
  width: 24px;
  height: 24px;
  font-size: 24px;
  color: #606060;
}
.bundle-flow-card .flow-card-info .flow-card-meta .flow-card-creator .flow-creator-name {
  font-size: 12px;
  color: #606060;
  font-weight: 400;
}
.bundle-flow-card .flow-card-info .flow-card-meta .flow-card-id {
  font-size: 12px;
  color: #909090;
  margin-left: 32px;
}

/* Create Bundle dark theme alignment (match create-flow modal look) */
:host-context(body.theme-dark) .upload-dialog {
  background: #0f172a !important;
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog .upload-header,
:host-context(body.theme-dark) .upload-dialog .upload-body,
:host-context(body.theme-dark) .upload-dialog .journey-content,
:host-context(body.theme-dark) .upload-dialog .section-card,
:host-context(body.theme-dark) .upload-dialog .journey-card,
:host-context(body.theme-dark) .upload-dialog .preview-card,
:host-context(body.theme-dark) .upload-dialog .cover-form-wrapper,
:host-context(body.theme-dark) .upload-dialog .flow-main-grid,
:host-context(body.theme-dark) .upload-dialog .flow-main-content,
:host-context(body.theme-dark) .upload-dialog .flow-sidebar.summary-preview-sidebar,
:host-context(body.theme-dark) .upload-dialog .step-navigation,
:host-context(body.theme-dark) .upload-dialog .step-panel-body,
:host-context(body.theme-dark) .upload-dialog .video-metadata,
:host-context(body.theme-dark) .upload-dialog .channel-info-section,
:host-context(body.theme-dark) .upload-dialog .upload-footer,
:host-context(body.theme-dark) .upload-dialog .mobile-footer,
:host-context(body.theme-dark) .upload-dialog .add-flows-popup-footer {
  background: #111827 !important;
  color: #f3f4f6 !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
  box-shadow: none !important;
}
:host-context(body.theme-dark) .upload-dialog .stage-banner {
  background: transparent !important;
  border-bottom-color: rgba(148, 163, 184, 0.18) !important;
  box-shadow: none !important;
}
:host-context(body.theme-dark) .upload-dialog .mat-mdc-tab-group,
:host-context(body.theme-dark) .upload-dialog .mat-mdc-tab-header,
:host-context(body.theme-dark) .upload-dialog .mat-mdc-tab-body-wrapper,
:host-context(body.theme-dark) .upload-dialog .mat-mdc-tab-body,
:host-context(body.theme-dark) .upload-dialog .mat-mdc-tab-body-content,
:host-context(body.theme-dark) .upload-dialog [role=tabpanel] {
  background: #111827 !important;
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog .mat-mdc-text-field-wrapper,
:host-context(body.theme-dark) .upload-dialog .mdc-text-field,
:host-context(body.theme-dark) .upload-dialog .mdc-text-field--outlined,
:host-context(body.theme-dark) .upload-dialog .mdc-text-field--filled,
:host-context(body.theme-dark) .upload-dialog input,
:host-context(body.theme-dark) .upload-dialog textarea,
:host-context(body.theme-dark) .upload-dialog select,
:host-context(body.theme-dark) .upload-dialog .ql-container,
:host-context(body.theme-dark) .upload-dialog .ql-toolbar,
:host-context(body.theme-dark) .upload-dialog .ql-editor {
  background: #111827 !important;
  color: #f9fafb !important;
  border-color: rgba(148, 163, 184, 0.35) !important;
}
:host-context(body.theme-dark) .upload-dialog .icon-circle,
:host-context(body.theme-dark) .upload-dialog .icon-button,
:host-context(body.theme-dark) .upload-dialog .upload-icon-btn {
  background: #1f2937 !important;
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog .icon-button:hover,
:host-context(body.theme-dark) .upload-dialog .upload-icon-btn:hover {
  background: #334155 !important;
}
:host-context(body.theme-dark) .upload-dialog .footer-btn.primary,
:host-context(body.theme-dark) .upload-dialog .btn.btn-primary,
:host-context(body.theme-dark) .upload-dialog .add-flows-header-btn,
:host-context(body.theme-dark) .upload-dialog .category-action-btn {
  background: #5ea1d8 !important;
  border-color: #5ea1d8 !important;
  color: #ffffff !important;
}
:host-context(body.theme-dark) .upload-dialog .footer-btn.secondary,
:host-context(body.theme-dark) .upload-dialog .footer-btn.ghost,
:host-context(body.theme-dark) .upload-dialog .btn.btn-secondary {
  background: #1f2937 !important;
  color: #f3f4f6 !important;
  border-color: rgba(148, 163, 184, 0.4) !important;
}
:host-context(body.theme-dark) .upload-dialog .bundle-category-card {
  background: rgba(255, 255, 255, 0.04) !important;
  border-color: rgba(148, 163, 184, 0.25) !important;
}
:host-context(body.theme-dark) .upload-dialog .nested-category-header h5,
:host-context(body.theme-dark) .upload-dialog .category-subsection h6 {
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) .upload-dialog .nested-category-header p {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .upload-dialog .nested-bundles-section {
  border-top-color: rgba(148, 163, 184, 0.2) !important;
}
:host-context(body.theme-dark) .upload-dialog .flow-card-title,
:host-context(body.theme-dark) .upload-dialog .flow-creator-name,
:host-context(body.theme-dark) .upload-dialog .flow-card-id,
:host-context(body.theme-dark) .upload-dialog .channel-name,
:host-context(body.theme-dark) .upload-dialog .channel-meta,
:host-context(body.theme-dark) .upload-dialog .document-name,
:host-context(body.theme-dark) .upload-dialog .link-name,
:host-context(body.theme-dark) .upload-dialog .mobile-section-title,
:host-context(body.theme-dark) .upload-dialog .mobile-section-description {
  color: #e5e7eb !important;
}

/* â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•
   Dark mode â€“ Create Bundle: comprehensive white-bg removal
   Base:     #111827  |  Elevated: #1e293b  |  Accent: #5ea1d8
   â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â• */
:host-context(body.theme-dark) .upload-dialog {
  background: #0f172a !important;
}
:host-context(body.theme-dark) .upload-header,
:host-context(body.theme-dark) .stage-banner {
  background: #111827 !important;
  border-color: rgba(148, 163, 184, 0.2) !important;
}
:host-context(body.theme-dark) .section-card,
:host-context(body.theme-dark) .cover-form-wrapper,
:host-context(body.theme-dark) .journey-card,
:host-context(body.theme-dark) .journey-content,
:host-context(body.theme-dark) .upload-footer,
:host-context(body.theme-dark) .add-flows-popup-footer {
  background: #111827 !important;
  border-color: rgba(148, 163, 184, 0.2) !important;
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .quill-wrapper {
  background: #111827 !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}
:host-context(body.theme-dark) .quill-wrapper ::ng-deep .ql-toolbar {
  background: #1e293b !important;
  border-color: rgba(148, 163, 184, 0.25) !important;
}
:host-context(body.theme-dark) .quill-wrapper ::ng-deep .ql-toolbar .ql-stroke {
  stroke: #94a3b8 !important;
}
:host-context(body.theme-dark) .quill-wrapper ::ng-deep .ql-toolbar .ql-fill {
  fill: #94a3b8 !important;
}
:host-context(body.theme-dark) .quill-wrapper ::ng-deep .ql-toolbar .ql-picker-label {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .quill-wrapper ::ng-deep .ql-container,
:host-context(body.theme-dark) .quill-wrapper ::ng-deep .ql-editor {
  background: #111827 !important;
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .quill-wrapper ::ng-deep .ql-editor.ql-blank::before {
  color: #64748b !important;
}
:host-context(body.theme-dark) .table-wrapper .table-inner {
  background: #1e293b !important;
  border-color: rgba(148, 163, 184, 0.25) !important;
}
:host-context(body.theme-dark) .table-wrapper .table-inner p.text-center {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .journey-content {
  scrollbar-color: #334155 #111827 !important;
}
:host-context(body.theme-dark) .journey-content::-webkit-scrollbar-track {
  background: #111827 !important;
}
:host-context(body.theme-dark) .journey-content::-webkit-scrollbar-thumb {
  background: #334155 !important;
}
:host-context(body.theme-dark) .journey-content::-webkit-scrollbar-thumb:hover {
  background: #475569 !important;
}
:host-context(body.theme-dark) .preview-card {
  background: #111827 !important;
  border-color: rgba(148, 163, 184, 0.2) !important;
}
:host-context(body.theme-dark) .mobile-section {
  background: #1e293b !important;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4) !important;
}
:host-context(body.theme-dark) .mobile-section .mobile-media.placeholder {
  background: #334155 !important;
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .mobile-section .mobile-section-title {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .mobile-section .mobile-section-description {
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .mobile-section .mobile-section-description p {
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .mobile-section .mobile-meta-row .info-badge {
  background: #334155 !important;
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .mobile-document-item,
:host-context(body.theme-dark) .mobile-link-item {
  background: #1e293b !important;
  border-color: rgba(148, 163, 184, 0.25) !important;
}
:host-context(body.theme-dark) .mobile-document-item .document-name,
:host-context(body.theme-dark) .mobile-document-item .link-name,
:host-context(body.theme-dark) .mobile-link-item .document-name,
:host-context(body.theme-dark) .mobile-link-item .link-name {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .preview-empty {
  color: #64748b !important;
}
:host-context(body.theme-dark) .preview-empty mat-icon {
  color: #475569 !important;
}
:host-context(body.theme-dark) .preview-empty p {
  color: #64748b !important;
}
:host-context(body.theme-dark) .add-flows-popup-dialog {
  background: #111827 !important;
  border: 1px solid rgba(148, 163, 184, 0.2) !important;
}
:host-context(body.theme-dark) .add-flows-popup-header {
  background: #111827 !important;
  border-bottom-color: rgba(148, 163, 184, 0.2) !important;
}
:host-context(body.theme-dark) .add-flows-popup-header h4 {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .add-flows-popup-header .icon-button:hover {
  background: #334155 !important;
}
:host-context(body.theme-dark) .add-flows-popup-header .icon-button mat-icon {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .add-flows-popup-body {
  background: #111827 !important;
}
:host-context(body.theme-dark) .bundle-flow-card,
:host-context(body.theme-dark) .flow-card-info {
  background: #1e293b !important;
  border-color: rgba(148, 163, 184, 0.25) !important;
}
:host-context(body.theme-dark) .flow-card-title {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .flow-creator-name,
:host-context(body.theme-dark) .flow-card-meta,
:host-context(body.theme-dark) .flow-card-id {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .thumbnail-dialog-card {
  background: #111827 !important;
  border: 1px solid rgba(148, 163, 184, 0.2) !important;
}
:host-context(body.theme-dark) .thumbnail-dialog-header {
  background: #111827 !important;
  border-bottom-color: rgba(148, 163, 184, 0.2) !important;
}
:host-context(body.theme-dark) .thumbnail-dialog-header h4 {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .thumbnail-dialog-header p {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .thumbnail-dialog-body {
  background: #111827 !important;
}
:host-context(body.theme-dark) .thumbnail-choice {
  background: #1e293b !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .thumbnail-choice.selected {
  background: rgba(94, 161, 216, 0.12) !important;
  border-color: #5ea1d8 !important;
}
:host-context(body.theme-dark) .thumbnail-choice .choice-icon {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .thumbnail-choice .choice-text strong,
:host-context(body.theme-dark) .thumbnail-choice .choice-text small {
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .upload-preview-compact,
:host-context(body.theme-dark) .upload-placeholder-compact,
:host-context(body.theme-dark) .upload-progress-compact {
  background: #1e293b !important;
  border-color: rgba(148, 163, 184, 0.25) !important;
}
:host-context(body.theme-dark) .upload-preview-compact mat-icon,
:host-context(body.theme-dark) .upload-placeholder-compact mat-icon,
:host-context(body.theme-dark) .upload-progress-compact mat-icon {
  color: #475569 !important;
}
:host-context(body.theme-dark) .upload-preview-compact span,
:host-context(body.theme-dark) .upload-placeholder-compact span,
:host-context(body.theme-dark) .upload-progress-compact span {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .upload-dialog .flow-title-sticky,
:host-context(body.theme-dark) .flow-title-sticky {
  background: #111827 !important;
  border-bottom-color: rgba(148, 163, 184, 0.2) !important;
  box-shadow: none !important;
}
:host-context(body.theme-dark) .upload-dialog .flow-title-sticky .video-title-sticky,
:host-context(body.theme-dark) .flow-title-sticky .video-title-sticky {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog .video-metadata .video-title,
:host-context(body.theme-dark) .flow-main-content .video-title {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog .action-item,
:host-context(body.theme-dark) .flow-main-content .action-item {
  background: #1e293b !important;
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .upload-dialog .action-item mat-icon,
:host-context(body.theme-dark) .flow-main-content .action-item mat-icon {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .upload-dialog .action-item span,
:host-context(body.theme-dark) .flow-main-content .action-item span {
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .upload-dialog .action-item:hover:not(.disabled),
:host-context(body.theme-dark) .flow-main-content .action-item:hover:not(.disabled) {
  background: #334155 !important;
}
:host-context(body.theme-dark) .upload-dialog .channel-info-section,
:host-context(body.theme-dark) .flow-main-content .channel-info-section {
  background: transparent !important;
  border-bottom-color: rgba(148, 163, 184, 0.2) !important;
}
:host-context(body.theme-dark) .upload-dialog .channel-info-section .channel-name,
:host-context(body.theme-dark) .flow-main-content .channel-info-section .channel-name {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog .channel-info-section .channel-meta,
:host-context(body.theme-dark) .upload-dialog .channel-info-section .subscriber-count,
:host-context(body.theme-dark) .flow-main-content .channel-info-section .channel-meta,
:host-context(body.theme-dark) .flow-main-content .channel-info-section .subscriber-count {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .upload-dialog .channel-info-section .material-icons,
:host-context(body.theme-dark) .flow-main-content .channel-info-section .material-icons {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .upload-dialog .description-section,
:host-context(body.theme-dark) .flow-main-content .description-section {
  background: #1e293b !important;
  border-radius: 12px !important;
}
:host-context(body.theme-dark) .upload-dialog .description-section h3,
:host-context(body.theme-dark) .upload-dialog .description-section .description-header h3,
:host-context(body.theme-dark) .flow-main-content .description-section h3,
:host-context(body.theme-dark) .flow-main-content .description-section .description-header h3 {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog .description-section .description-content,
:host-context(body.theme-dark) .flow-main-content .description-section .description-content {
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .upload-dialog .description-section .description-content *,
:host-context(body.theme-dark) .flow-main-content .description-section .description-content * {
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .upload-dialog .description-section .description-content p, :host-context(body.theme-dark) .upload-dialog .description-section .description-content span, :host-context(body.theme-dark) .upload-dialog .description-section .description-content div, :host-context(body.theme-dark) .upload-dialog .description-section .description-content li, :host-context(body.theme-dark) .upload-dialog .description-section .description-content ul, :host-context(body.theme-dark) .upload-dialog .description-section .description-content ol,
:host-context(body.theme-dark) .upload-dialog .description-section .description-content strong, :host-context(body.theme-dark) .upload-dialog .description-section .description-content em, :host-context(body.theme-dark) .upload-dialog .description-section .description-content a, :host-context(body.theme-dark) .upload-dialog .description-section .description-content blockquote, :host-context(body.theme-dark) .upload-dialog .description-section .description-content pre, :host-context(body.theme-dark) .upload-dialog .description-section .description-content code,
:host-context(body.theme-dark) .flow-main-content .description-section .description-content p,
:host-context(body.theme-dark) .flow-main-content .description-section .description-content span,
:host-context(body.theme-dark) .flow-main-content .description-section .description-content div,
:host-context(body.theme-dark) .flow-main-content .description-section .description-content li,
:host-context(body.theme-dark) .flow-main-content .description-section .description-content ul,
:host-context(body.theme-dark) .flow-main-content .description-section .description-content ol,
:host-context(body.theme-dark) .flow-main-content .description-section .description-content strong,
:host-context(body.theme-dark) .flow-main-content .description-section .description-content em,
:host-context(body.theme-dark) .flow-main-content .description-section .description-content a,
:host-context(body.theme-dark) .flow-main-content .description-section .description-content blockquote,
:host-context(body.theme-dark) .flow-main-content .description-section .description-content pre,
:host-context(body.theme-dark) .flow-main-content .description-section .description-content code {
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .upload-dialog .description-section .description-content a,
:host-context(body.theme-dark) .flow-main-content .description-section .description-content a {
  color: #7ab8e8 !important;
  text-decoration: underline !important;
}
:host-context(body.theme-dark) .upload-dialog .description-section .expand-description-btn,
:host-context(body.theme-dark) .flow-main-content .description-section .expand-description-btn {
  background: transparent !important;
  background-color: transparent !important;
  box-shadow: none !important;
  border: none !important;
  color: #5ea1d8 !important;
  font-weight: 500 !important;
}
:host-context(body.theme-dark) .upload-dialog .description-section .expand-description-btn:hover,
:host-context(body.theme-dark) .flow-main-content .description-section .expand-description-btn:hover {
  background: transparent !important;
  color: #93c5fd !important;
}
:host-context(body.theme-dark) .upload-dialog .description-section .supporting-docs-link a,
:host-context(body.theme-dark) .upload-dialog .description-section .supporting-docs-link .supportingdoc,
:host-context(body.theme-dark) .flow-main-content .description-section .supporting-docs-link a,
:host-context(body.theme-dark) .flow-main-content .description-section .supporting-docs-link .supportingdoc {
  color: #7ab8e8 !important;
}
:host-context(body.theme-dark) .upload-dialog .description-section .supporting-docs-link a:hover,
:host-context(body.theme-dark) .upload-dialog .description-section .supporting-docs-link .supportingdoc:hover,
:host-context(body.theme-dark) .flow-main-content .description-section .supporting-docs-link a:hover,
:host-context(body.theme-dark) .flow-main-content .description-section .supporting-docs-link .supportingdoc:hover {
  color: #93c5fd !important;
}
:host-context(body.theme-dark) .upload-dialog .flow-sidebar .step-btn,
:host-context(body.theme-dark) .flow-sidebar .step-btn {
  background: #1e293b !important;
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .upload-dialog .flow-sidebar .step-btn.active,
:host-context(body.theme-dark) .flow-sidebar .step-btn.active {
  background: #5ea1d8 !important;
  color: #ffffff !important;
}
:host-context(body.theme-dark) .upload-dialog .flow-sidebar .step-btn .step-title-text,
:host-context(body.theme-dark) .flow-sidebar .step-btn .step-title-text {
  color: inherit !important;
}
:host-context(body.theme-dark) .upload-dialog .recommendations-section,
:host-context(body.theme-dark) .flow-sidebar .recommendations-section {
  border-top-color: rgba(148, 163, 184, 0.2) !important;
}
:host-context(body.theme-dark) .upload-dialog .recommendations-section h2,
:host-context(body.theme-dark) .flow-sidebar .recommendations-section h2 {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog .recommendations-section .recommendation-item:hover,
:host-context(body.theme-dark) .flow-sidebar .recommendations-section .recommendation-item:hover {
  background: #1e293b !important;
}
:host-context(body.theme-dark) .upload-dialog .recommendations-section .recommendation-item .recommendation-title,
:host-context(body.theme-dark) .flow-sidebar .recommendations-section .recommendation-item .recommendation-title {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog .recommendations-section .recommendation-item .recommendation-meta,
:host-context(body.theme-dark) .flow-sidebar .recommendations-section .recommendation-item .recommendation-meta {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .upload-dialog ::ng-deep .standard-tab-group .mat-mdc-tab-header,
:host-context(body.theme-dark) ::ng-deep .standard-tab-group .mat-mdc-tab-header {
  background: #111827 !important;
  border-bottom-color: rgba(148, 163, 184, 0.2) !important;
}
:host-context(body.theme-dark) .upload-dialog ::ng-deep .standard-tab-group .mdc-tab__text-label,
:host-context(body.theme-dark) ::ng-deep .standard-tab-group .mdc-tab__text-label {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .upload-dialog ::ng-deep .standard-tab-group .mdc-tab--active .mdc-tab__text-label,
:host-context(body.theme-dark) ::ng-deep .standard-tab-group .mdc-tab--active .mdc-tab__text-label {
  color: #5ea1d8 !important;
}
:host-context(body.theme-dark) .upload-dialog ::ng-deep .standard-tab-group .mdc-tab-indicator__content--underline,
:host-context(body.theme-dark) ::ng-deep .standard-tab-group .mdc-tab-indicator__content--underline {
  border-color: #5ea1d8 !important;
}
:host-context(body.theme-dark) .upload-dialog ::ng-deep .standard-tab-group .mat-mdc-tab-body-wrapper,
:host-context(body.theme-dark) ::ng-deep .standard-tab-group .mat-mdc-tab-body-wrapper {
  background: #111827 !important;
}
:host-context(body.theme-dark) .tab-design-wrapper mat-label,
:host-context(body.theme-dark) .tab-design-wrapper ::ng-deep mat-label,
:host-context(body.theme-dark) .upload-dialog .tab-design-wrapper ::ng-deep .mdc-floating-label,
:host-context(body.theme-dark) .upload-dialog .tab-design-wrapper ::ng-deep mat-label {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .form-label-wrapper.upload-label-inline label,
:host-context(body.theme-dark) .form-label-wrapper.upload-label-inline .form-label,
:host-context(body.theme-dark) .upload-label-inline label {
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .example-box.document-row {
  background: #1e293b !important;
  border-color: rgba(148, 163, 184, 0.2) !important;
}
:host-context(body.theme-dark) .example-box.document-row:hover {
  border-color: #5ea1d8 !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35) !important;
}
:host-context(body.theme-dark) .example-box.document-row .doc-name {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .example-box.document-row .doc-url {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .example-box.document-row .doc-type-icon {
  color: #5ea1d8 !important;
}
:host-context(body.theme-dark) .example-box.document-row .doc-type-icon.link-icon {
  color: #a78bfa !important;
}
:host-context(body.theme-dark) .example-box.document-row .doc-action-btn.edit {
  color: #7ab8e8 !important;
}
:host-context(body.theme-dark) .example-box.document-row .doc-action-btn.edit:hover {
  background: rgba(94, 161, 216, 0.15) !important;
}
:host-context(body.theme-dark) .example-box.document-row .doc-action-btn.delete {
  color: #f87171 !important;
}
:host-context(body.theme-dark) .example-box.document-row .doc-action-btn.delete:hover {
  background: rgba(239, 68, 68, 0.15) !important;
}
:host-context(body.theme-dark) .tab-design-wrapper .addbtn .btn.btn-primary,
:host-context(body.theme-dark) .addbtn .btn.btn-primary {
  background: #5ea1d8 !important;
  color: #ffffff !important;
  border-color: #5ea1d8 !important;
}
:host-context(body.theme-dark) .tab-design-wrapper .addbtn .btn.btn-primary:disabled,
:host-context(body.theme-dark) .addbtn .btn.btn-primary:disabled {
  background: #334155 !important;
  color: #64748b !important;
  border-color: #334155 !important;
}
:host-context(body.theme-dark) .upload-icon-btn.light {
  background: #1e293b !important;
  color: #f3f4f6 !important;
  border: 1px solid rgba(148, 163, 184, 0.3) !important;
}
:host-context(body.theme-dark) .upload-icon-btn.light mat-icon {
  color: #5ea1d8 !important;
}
:host-context(body.theme-dark) .upload-icon-btn.light:hover {
  background: #334155 !important;
}
:host-context(body.theme-dark) .file-details {
  color: #7ab8e8 !important;
}
:host-context(body.theme-dark) .mobile-pricing-view .pricing-row {
  background: #1e293b !important;
  border-color: rgba(148, 163, 184, 0.2) !important;
}
:host-context(body.theme-dark) .mobile-pricing-view .pricing-label {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .mobile-pricing-view .pricing-value {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .mobile-pricing-view .pricing-value.price-amount {
  color: #4ade80 !important;
}
:host-context(body.theme-dark) .mobile-pricing-view .pricing-warning {
  color: #f87171 !important;
}
:host-context(body.theme-dark) .mobile-pricing-view .pricing-warning mat-icon {
  color: #f87171 !important;
}
:host-context(body.theme-dark) .mobile-flow-item {
  background: #1e293b !important;
  border-color: rgba(148, 163, 184, 0.25) !important;
}
:host-context(body.theme-dark) .mobile-flow-item:hover {
  border-color: #5ea1d8 !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.4) !important;
}
:host-context(body.theme-dark) .mobile-flow-thumbnail {
  background: #334155 !important;
}
:host-context(body.theme-dark) .mobile-flow-title {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .mobile-flow-meta,
:host-context(body.theme-dark) .mobile-flow-meta .flow-creator {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .mobile-flow-meta .flow-price {
  color: #4ade80 !important;
}
:host-context(body.theme-dark) .flows-count-badge {
  background: rgba(94, 161, 216, 0.15) !important;
  color: #7ab8e8 !important;
  border: 1px solid rgba(94, 161, 216, 0.3) !important;
}
:host-context(body.theme-dark) .upload-dialog .info-badge,
:host-context(body.theme-dark) .info-badge {
  background: #1e293b !important;
  color: #f3f4f6 !important;
  border-color: rgba(148, 163, 184, 0.25) !important;
}
:host-context(body.theme-dark) .upload-dialog .info-badge mat-icon,
:host-context(body.theme-dark) .info-badge mat-icon {
  color: #5ea1d8 !important;
}
:host-context(body.theme-dark) .media-size-recommendation {
  background: rgba(30, 41, 59, 0.8) !important;
  border-left-color: #5ea1d8 !important;
}
:host-context(body.theme-dark) .media-size-recommendation__icon {
  color: #5ea1d8 !important;
}
:host-context(body.theme-dark) .media-size-recommendation__title {
  color: #7ab8e8 !important;
}
:host-context(body.theme-dark) .media-size-recommendation__lines, :host-context(body.theme-dark) .media-size-recommendation__lines div {
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .transfer-toggle-section {
  background: #1e293b !important;
  border-color: rgba(148, 163, 184, 0.2) !important;
}
:host-context(body.theme-dark) .transfer-toggle-section .toggle-label {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .transfer-toggle-section .toggle-description {
  background: rgba(94, 161, 216, 0.1) !important;
  border-left-color: #5ea1d8 !important;
  color: #93c5fd !important;
}
:host-context(body.theme-dark) .transfer-toggle-section .toggle-description .info-icon {
  color: #5ea1d8 !important;
}
:host-context(body.theme-dark) .upload-dialog label {
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .upload-dialog .cover-form-wrapper h3 {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .item {
  background: #1e293b !important;
  border-color: rgba(148, 163, 184, 0.25) !important;
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .item p {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog [style*="background-color: #f0f7ff"],
:host-context(body.theme-dark) .upload-dialog [style*="background: #f0f7ff"],
:host-context(body.theme-dark) .upload-dialog [style*="background-color:#f0f7ff"],
:host-context(body.theme-dark) .upload-dialog [style*="background:#f0f7ff"] {
  background: rgba(30, 41, 59, 0.75) !important;
  background-color: rgba(30, 41, 59, 0.75) !important;
  border-left-color: #5ea1d8 !important;
}

.bundle-access-type-row {
  margin-bottom: 12px;
}

.bundle-access-type-options {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 8px;
}

.access-type-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 1px solid #cbd5e1;
  border-radius: 999px;
  background: #fff;
  color: #334155;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}
.access-type-btn mat-icon {
  width: 18px;
  height: 18px;
  font-size: 18px;
}
.access-type-btn.selected {
  border-color: #5ea1d8;
  background: #eef6fc;
  color: #1e4d72;
}
.access-type-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.access-type-check {
  font-size: 18px;
  width: 18px;
  height: 18px;
  margin-left: 2px;
}

::ng-deep .access-menu-current {
  margin-left: 8px;
  font-size: 11px;
  font-weight: 600;
  color: #1976d2;
}

.journey-access-type-row {
  margin-bottom: 16px;
  text-align: left;
  width: 100%;
  max-width: 100%;
}

.journey-access-option-list {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 10px;
  margin-top: 10px;
  width: 100%;
  max-width: 100%;
}
@media (min-width: 992px) {
  .journey-access-option-list {
    flex-direction: row;
    align-items: stretch;
    gap: 10px;
  }
}

.journey-access-option {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
  text-align: left;
  border: 1px solid #d7dee8;
  border-radius: 12px;
  background: #fff;
  color: #1e293b;
  padding: 14px 16px;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;
}
.journey-access-option:hover:not(:disabled) {
  border-color: #93c5e8;
  background: #f8fbfe;
}
.journey-access-option.selected {
  border-color: #5ea1d8;
  background: #eef6fc;
  box-shadow: inset 0 0 0 1px #5ea1d8;
}
.journey-access-option:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
@media (min-width: 992px) {
  .journey-access-option {
    flex: 1 1 0;
    min-width: 0;
    align-items: center;
    gap: 8px;
    padding: 12px 14px;
  }
}

.journey-access-option-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 24px;
  height: 24px;
  font-size: 24px;
  line-height: 24px;
  overflow: visible;
  color: #5ea1d8;
  margin-top: 0;
}

.journey-access-option-copy {
  flex: 1 1 auto;
  min-width: 0;
}
.journey-access-option-copy strong {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
  line-height: 24px;
}
.journey-access-option-copy p {
  margin: 4px 0 0;
  font-size: 13px;
  line-height: 1.4;
  color: #64748b;
}
@media (min-width: 992px) {
  .journey-access-option-copy strong {
    font-size: 13px;
    line-height: 24px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .journey-access-option-copy p {
    display: none;
  }
}

.journey-access-option-check {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 22px;
  height: 22px;
  font-size: 22px;
  line-height: 22px;
  overflow: visible;
  color: #5ea1d8;
  margin-top: 0;
}

.journey-restricted-panel {
  margin-top: 16px;
  width: 100%;
  max-width: 100%;
  text-align: left;
  max-height: none;
  overflow: visible;
  padding-bottom: 24px;
}

.access-journey-card .journey-content {
  width: 100%;
}
.access-journey-card .cover-form-wrapper.journey-access-type-row,
.access-journey-card .journey-restricted-panel,
.access-journey-card app-enhanced-restricted-access {
  display: block;
  width: 100%;
  max-width: 100%;
}

.preview-card .mobile-section.access-summary-preview,
.access-summary-preview {
  overflow: visible;
}
.preview-card .mobile-section.access-summary-preview .access-summary-badge,
.access-summary-preview .access-summary-badge {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}
.preview-card .mobile-section.access-summary-preview .access-summary-badge .access-summary-kicker,
.access-summary-preview .access-summary-badge .access-summary-kicker {
  display: block;
  margin-bottom: 0;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #94a3b8;
}
.preview-card .mobile-section.access-summary-preview .access-summary-badge .access-summary-title-row,
.access-summary-preview .access-summary-badge .access-summary-title-row {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  max-width: 100%;
  min-height: 22px;
}
.preview-card .mobile-section.access-summary-preview .access-summary-badge .access-summary-title-row mat-icon,
.access-summary-preview .access-summary-badge .access-summary-title-row mat-icon {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  flex: 0 0 20px;
  width: 20px !important;
  height: 20px !important;
  font-size: 20px !important;
  line-height: 20px !important;
  margin: 0 !important;
  padding: 0 !important;
  overflow: visible;
  color: #5ea1d8;
  /* Optical nudge: Material glyphs sit slightly high next to text */
  transform: translateY(1px);
}
.preview-card .mobile-section.access-summary-preview .access-summary-badge .access-summary-title-row strong,
.access-summary-preview .access-summary-badge .access-summary-title-row strong {
  display: inline-flex;
  align-items: center;
  min-width: 0;
  margin: 0;
  padding: 0;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  color: #0f172a;
}
.preview-card .mobile-section.access-summary-preview .access-summary-badge mat-icon,
.access-summary-preview .access-summary-badge mat-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  font-size: 20px;
  line-height: 20px;
  overflow: visible;
  color: #5ea1d8;
}
.preview-card .mobile-section.access-summary-preview .access-summary-badge strong,
.access-summary-preview .access-summary-badge strong {
  display: block;
  min-width: 0;
  font-size: 14px;
  line-height: 20px;
  color: #0f172a;
}
.preview-card .mobile-section.access-summary-preview .access-summary-badge p,
.access-summary-preview .access-summary-badge p {
  margin: 2px 0 0;
  font-size: 13px;
  color: #64748b;
  line-height: 1.4;
}
.preview-card .mobile-section.access-summary-preview .access-summary-original,
.access-summary-preview .access-summary-original {
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px solid #e2e8f0;
}
.preview-card .mobile-section.access-summary-preview .access-summary-original .access-summary-kicker,
.access-summary-preview .access-summary-original .access-summary-kicker {
  display: block;
  margin-bottom: 2px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #94a3b8;
}
.preview-card .mobile-section.access-summary-preview .access-summary-original strong,
.access-summary-preview .access-summary-original strong {
  display: block;
  font-size: 13px;
  color: #334155;
}
.preview-card .mobile-section.access-summary-preview .access-summary-original p,
.access-summary-preview .access-summary-original p {
  margin: 4px 0 0;
  font-size: 12px;
  color: #64748b;
  line-height: 1.4;
}
.preview-card .mobile-section.access-summary-preview .access-summary-original .access-restore-btn,
.access-summary-preview .access-summary-original .access-restore-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 10px;
  min-height: 40px;
  padding: 8px 16px;
  border: 1px solid #5ea1d8;
  border-radius: 8px;
  background: transparent;
  color: #5ea1d8;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.2;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
  text-transform: none;
  box-sizing: border-box;
}
.preview-card .mobile-section.access-summary-preview .access-summary-original .access-restore-btn mat-icon,
.access-summary-preview .access-summary-original .access-restore-btn mat-icon {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  flex: 0 0 16px;
  width: 16px !important;
  height: 16px !important;
  font-size: 16px !important;
  line-height: 16px !important;
  margin: 0 !important;
  padding: 0 !important;
  overflow: visible;
}
.preview-card .mobile-section.access-summary-preview .access-summary-original .access-restore-btn:hover,
.access-summary-preview .access-summary-original .access-restore-btn:hover {
  background: #5ea1d8;
  color: #fff;
}
.preview-card .mobile-section.access-summary-preview .access-summary-meta,
.access-summary-preview .access-summary-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 12px;
}
.preview-card .mobile-section.access-summary-preview .access-summary-meta span,
.access-summary-preview .access-summary-meta span {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 999px;
  background: #eef6fc;
  color: #1e4d72;
  font-size: 12px;
  font-weight: 600;
}

.flows-sequence-hint.muted {
  margin-top: 8px;
  color: #6b7280;
  font-size: 13px;
  text-align: left;
}

.access-original-inline {
  display: none;
  margin-top: 16px;
  padding: 14px 16px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
}
.access-original-inline .access-summary-kicker {
  display: block;
  margin-bottom: 4px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #94a3b8;
}
.access-original-inline .access-summary-title-row {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  max-width: 100%;
}
.access-original-inline .access-summary-title-row mat-icon {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  flex: 0 0 20px;
  width: 20px !important;
  height: 20px !important;
  font-size: 20px !important;
  line-height: 20px !important;
  margin: 0 !important;
  padding: 0 !important;
  overflow: visible;
  color: #5ea1d8;
  transform: translateY(1px);
}
.access-original-inline .access-summary-title-row strong {
  display: inline-flex;
  align-items: center;
  min-width: 0;
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  color: #0f172a;
}
.access-original-inline > p {
  margin: 4px 0 0;
  font-size: 13px;
  line-height: 1.4;
  color: #64748b;
}
.access-original-inline .access-summary-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
}
.access-original-inline .access-summary-meta span {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 999px;
  background: #eef6fc;
  color: #1e4d72;
  font-size: 12px;
  font-weight: 600;
}
.access-original-inline .access-restore-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 12px;
  min-height: 40px;
  padding: 8px 16px;
  border: 1px solid #5ea1d8;
  border-radius: 8px;
  background: transparent;
  color: #5ea1d8;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.2;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
  text-transform: none;
  box-sizing: border-box;
}
.access-original-inline .access-restore-btn mat-icon {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  flex: 0 0 16px;
  width: 16px !important;
  height: 16px !important;
  font-size: 16px !important;
  line-height: 16px !important;
  margin: 0 !important;
  padding: 0 !important;
  overflow: visible;
}
.access-original-inline .access-restore-btn:hover {
  background: #5ea1d8;
  color: #fff;
}

@media (max-width: 768px) {
  .access-original-inline {
    display: block;
  }
}
.creator-access-notice .upgrade-free-link {
  margin-left: 4px;
  border: none;
  background: none;
  padding: 0;
  color: #5ea1d8;
  font-weight: 700;
  font-size: 0.85rem;
  cursor: pointer;
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/createbundle/createbundle.component.scss","webpack://./src/app/shared/styles/_publishing-state.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACChB;EACE,oBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;ADCF;ACCE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;ADCJ;ACCI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;ADCN;ACEI;EACE,mBAAA;EACA,yBAAA;EACA,cAAA;ADAN;ACCM;EAAW,cAAA;ADEjB;ACCI;EACE,mBAAA;EACA,yBAAA;EACA,cAAA;ADCN;ACAM;EAAW,cAAA;ADGjB;ACCE;EAAU,OAAA;ADEZ;ACAE;EACE,cAAA;EACA,eAAA;EACA,YAAA;ADEJ;ACCE;EACE,iBAAA;EACA,8BAAA;EACA,uBAAA;EACA,cAAA;EACA,oBAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,mBAAA;ADCJ;ACCI;EAAa,YAAA;EAAc,eAAA;ADG/B;;ACEA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;ADCF;ACCE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;ADCJ;ACEE;EAEE,kCAAA;ADDJ;;ACKA;EACE,cAAA;ADFF;;ACME;EACE,mCAAA;EACA,qCAAA;EACA,cAAA;ADHJ;ACII;EAAW,cAAA;ADDf;ACGE;EACE,mCAAA;EACA,qCAAA;EACA,cAAA;ADDJ;ACEI;EAAW,cAAA;ADCf;;AAvGA;EACE,mBAAA;AA0GF;;AAtGA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,gBAAA;AAyGF;;AAtGA;EACE,UAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,4CAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;AAyGF;;AAtGA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,gCAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;AAyGF;;AAtGA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAyGF;AAvGE;EALF;IAMI,SAAA;EA0GF;AACF;;AAvGA;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;AA0GF;;AAvGA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AA0GF;AAxGE;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AA0GJ;AAvGE;EAlBF;IAmBI,WAAA;IACA,YAAA;EA0GF;EAxGE;IACE,eAAA;IACA,WAAA;IACA,YAAA;IACA,iBAAA;EA0GJ;AACF;;AArGE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;AAwGJ;AAtGI;EACE,cAAA;AAwGN;AAtGM;EAHF;IAII,aAAA;EAyGN;AACF;AAtGI;EACE,aAAA;AAwGN;AAtGM;EAHF;IAII,cAAA;EAyGN;AACF;AArGE;EACE,eAAA;EACA,cAAA;AAuGJ;AArGI;EAJF;IAKI,aAAA;EAwGJ;AACF;AArGE;EACE,eAAA;EACA,cAAA;AAuGJ;;AAnGA;EACE,YAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,qDAAA;EACA,kBAAA;EACA,cAAA;AAsGF;AArGE;EACE,eAAA;AAuGJ;AArGE;EACE,mBAAA;EACA,2BAAA;AAuGJ;;AAnGA;EACE,qBAAA;EACA,gBAAA;EACA,gCAAA;EACA,cAAA;AAsGF;;AAnGA;EACE,aAAA;EACA,mBAAA;EACA,MAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;AAsGF;;AAnGA;EACE,uBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,MAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,2BAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,wCAAA;EAEA,kBAAA;AAqGF;AApGE;EACE,eAAA;EACA,mCAAA;EACA,cAAA;EACA,oBAAA;EACA,gBAAA;AAsGJ;AAnGE;EAGE,wBAAA;EACA,2BAAA;AAmGJ;AAhGE;EAGE,aAAA;EACA,gBAAA;AAgGJ;AA7FE;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;AA+FJ;;AA3FA;EACE,cAAA;AA8FF;AA7FE;EACE,qBAAA;EACA,mCAAA;EACA,cAAA;AA+FJ;;AA3FA;EACE,cAAA;AA8FF;AA7FE;EACE,qBAAA;EACA,kCAAA;EACA,cAAA;AA+FJ;;AA3FA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AA8FF;AA7FE;EACE,eAAA;AA+FJ;;AA3FA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,iBAAA;EACA,mBAAA;EACA,8BAAA;EACA,uBAAA;EACA,cAAA;AA8FF;;AA3FA;;EAEE,oBAAA;EACA,mBAAA;EACA,mBAAA;AA8FF;;AA3FA,qCAAA;AACA;EAoIE,yDAAA;EAkBA,0EAAA;EAeA,sDAAA;EAgBA,yDAAA;EAmBA,mDAAA;EAkBA,qEAAA;EA0CA,mCAAA;EAoBA,yBAAA;EASA,0DAAA;EA8BA,wDAAA;AAvNF;AAvGE;EACE,8BAAA;EACA,yBAAA;AAyGJ;AAtGE;;;;;;EAME,8BAAA;EACA,yBAAA;EACA,kDAAA;AAwGJ;AApGE;EACE,kCAAA;EACA,yDAAA;AAsGJ;AAnGE;;;;;;EAME,yBAAA;AAqGJ;AAlGE;;EAEE,yBAAA;AAoGJ;AAjGE;;EAEE,8BAAA;EACA,yBAAA;AAmGJ;AAhGE;EACE,8BAAA;AAkGJ;AA9FE;;EAEE,+CAAA;AAgGJ;AA7FE;;EAEE,8BAAA;AA+FJ;AA3FE;;EAEE,kCAAA;EACA,2BAAA;AA6FJ;AAzFE;;EAEE,yBAAA;AA2FJ;AAzFI;;EACE,gCAAA;EACA,kCAAA;EACA,yBAAA;AA4FN;AAzFI;;;;EAEE,yBAAA;AA6FN;AAxFE;;EAEE,yBAAA;AA0FJ;AAxFI;;EACE,+CAAA;EACA,yBAAA;EACA,gCAAA;AA2FN;AAxFI;;;;EAEE,yBAAA;AA4FN;AAvFE;;EAEE,yBAAA;AAyFJ;AAvFI;;EACE,8CAAA;EACA,yBAAA;EACA,gCAAA;AA0FN;AAvFI;;;;;;EAGE,yBAAA;AA4FN;AAxFE;;;;;;EAME,yBAAA;AA0FJ;AAvFE;;;EAGE,iDAAA;AAyFJ;AArFE;;;;;;;;;;;;;;EAcE,yBAAA;AAuFJ;AAnFE;EACE,yBAAA;EACA,qCAAA;EACA,eAAA;AAqFJ;AAnFI;EACE,yBAAA;AAqFN;AAlFI;EACE,yBAAA;AAoFN;AA/EE;;;;;;;;;;;EAWE,kCAAA;EACA,2BAAA;AAiFJ;AA7EE;;;;;;;;;;;;;;;EAeE,yBAAA;AA+EJ;AA3EE;;;;;;;;EAQE,kCAAA;EACA,wCAAA;AA6EJ;AA1EE;;EAEE,kCAAA;AA4EJ;AAxEE;;;;;;;EAOE,8BAAA;EACA,yBAAA;AA0EJ;AAvEE;;;;;;EAME,8BAAA;AAyEJ;AAtEE;;;;;;;EAOE,oCAAA;EACA,yBAAA;EACA,kDAAA;AAwEJ;AArEE;;;;EAIE,oCAAA;EACA,yBAAA;EACA,gCAAA;AAuEJ;AAnEE;;;;;;;;;;EAUE,8BAAA;EACA,yBAAA;EACA,kDAAA;AAqEJ;AAlEE;EACE,yBAAA;AAoEJ;AAhEE;;;;EAIE,8BAAA;EACA,sDAAA;AAkEJ;AA9DE;;;;;;;;EAQE,8BAAA;EACA,yBAAA;AAgEJ;AA7DE;;;;;;;;;;;;EAYE,8BAAA;EACA,oCAAA;EACA,yBAAA;AA+DJ;AA3DE;;;;;;;;;;;;;;EAcE,8BAAA;EACA,yBAAA;EACA,kDAAA;AA6DJ;;AAzDA;EACE,qBAAA;EACA,cAAA;EACA,kCAAA;AA4DF;;AAzDA;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA4DF;;AAzDA;EACE,eAAA;EACA,oBAAA;AA4DF;;AAzDA;EACE,OAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;AA4DF;;AAzDA;EACE,mBAAA;AA4DF;;AAzDA;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;AA4DF;AA1DE;EACE,UAAA;AA4DJ;AAzDE;EACE,mBAAA;EACA,kBAAA;AA2DJ;AAxDE;EACE,mBAAA;EACA,kBAAA;AA0DJ;AAxDI;EACE,mBAAA;AA0DN;;AArDA;EACE,kBAAA;EACA,6BAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;EACA,8BAAA;EACA,8CAAA;EACA,cAAA;AAwDF;AAtDE;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAwDJ;;AApDA;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,yBAAA;EACA,eAAA;EACA,mBAAA;AAuDF;;AApDA,yFAAA;AACA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;AAuDF;;AApDA;;EAEE,oBAAA;AAuDF;;AApDA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAuDF;AArDE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAuDJ;AApDE;EAEE,cAAA;EACA,mCAAA;AAqDJ;;AAjDA;EACE,kBAAA;EACA,6BAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,SAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,mBAAA;EACA,sBAAA;AAoDF;AAlDE;EACE,mBAAA;EACA,WAAA;EACA,qBAAA;AAoDJ;AAlDI;EACE,mBAAA;AAoDN;AAhDE;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;AAkDJ;AAhDI;EACE,mBAAA;AAkDN;AA9CE;EACE,uBAAA;EACA,cAAA;EACA,qBAAA;AAgDJ;AA9CI;EACE,oCAAA;AAgDN;AA5CE;EACE,cAAA;EACA,qBAAA;AA8CJ;AA5CI;EACE,mBAAA;AA8CN;AA1CE;EACE,aAAA;EACA,mBAAA;AA4CJ;;AAxCA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AA2CF;AAzCE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AA2CJ;AAxCE;EACE,mBAAA;EACA,cAAA;AA0CJ;AAvCE;EAEE,mBAAA;EACA,cAAA;AAwCJ;AArCE;EACE,mBAAA;EACA,cAAA;AAuCJ;;AAlCE;EACE,mBAAA;EACA,cAAA;AAqCJ;AAnCI;EACE,iCAAA;EACA,cAAA;AAqCN;AAlCI;EAEE,oCAAA;EACA,cAAA;AAmCN;AAhCI;EACE,mCAAA;EACA,cAAA;AAkCN;AA9BE;EACE,cAAA;EACA,oCAAA;AAgCJ;;AA5BA;EACE,eAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;AA+BF;AA7BE;EACE,cAAA;EACA,eAAA;AA+BJ;AA5BE;EACE,aAAA;EACA,YAAA;EACA,eAAA;AA8BJ;;AA1BA;EACE,eAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AA6BF;AA3BE;EACE,eAAA;EACA,gBAAA;AA6BJ;;AAzBA;EACE,gBAAA;EACA,mBAAA;EACA,yBAAA;EASA,aAAA;EACA,8CAAA;AAoBF;AA5BE;EACE,gBAAA;EACA,YAAA;EACA,uBAAA;EACA,UAAA;EACA,gBAAA;AA8BJ;AAzBE;EACE,UAAA;EACA,aAAA;EACA,sBAAA;EACA,OAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;AA2BJ;;AAvBA;EACE,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;AA0BF;AAxBE;EACE,UAAA;AA0BJ;AAvBE;EACE,mBAAA;EACA,kBAAA;AAyBJ;AAtBE;EACE,mBAAA;EACA,kBAAA;AAwBJ;AAtBI;EACE,mBAAA;AAwBN;;AAnBA;EACE,gBAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;AAsBF;AApBE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,UAAA;EACA,YAAA;EACA,oBAAA;EACA,iBAAA;EACA,iBAAA;AAsBJ;AAnBE;EACE,gBAAA;EACA,aAAA;AAqBJ;AAnBI;EACE,cAAA;EACA,eAAA;AAqBN;AAhBM;EACE,aAAA;AAkBR;AAfM;EACE,aAAA;AAiBR;AAZE;EACE,gBAAA;EACA,mBAAA;EACA,UAAA;EACA,cAAA;EACA,eAAA;AAcJ;AAZI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;AAcN;AAZM;EACE,eAAA;AAcR;AATE;EACE,WAAA;EACA,gBAAA;EACA,mBAAA;AAWJ;AAPM;EACE,kBAAA;AASR;AANM;EACE,0BAAA;AAQR;AALM;EACE,0BAAA;AAOR;AAJM;EACE,kBAAA;AAMR;AAHM;;EAEE,kBAAA;AAKR;AAFM;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAIR;AACE;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;AACJ;AACI;EACE,wBAAA;EACA,2BAAA;AACN;AAEQ;EACE,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,qBAAA;AAAV;AAGQ;EACE,aAAA;EACA,iBAAA;EACA,QAAA;EACA,WAAA;EACA,aAAA;EACA,yBAAA;AADV;AAIQ;EACE,iBAAA;EACA,WAAA;EACA,SAAA;AAFV;AAKQ;EACE,aAAA;AAHV;AAQI;EACE,eAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,QAAA;EACA,WAAA;AANN;AAQM;EACE,gBAAA;EACA,YAAA;AANR;AASM;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;AAPR;AASQ;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;AAPV;AASU;EACE,cAAA;AAPZ;AAUU;EACE,eAAA;AARZ;AAeE;EACE,eAAA;EACA,mBAAA;AAbJ;AAeI;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,yBAAA;AAbN;AAeM;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;AAbR;AAeQ;EACE,cAAA;AAbV;AAgBQ;EACE,eAAA;AAdV;AAoBE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;AAlBJ;AAoBI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,cAAA;AAlBN;AAqBI;EACE,aAAA;EACA,gBAAA;EACA,UAAA;EACA,cAAA;EACA,kBAAA;AAnBN;AAqBM;EACE,cAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AAnBR;AAuBI;EACE,aAAA;EACA,cAAA;AArBN;AAwBI;EACE,OAAA;EACA,YAAA;EACA,cAAA;AAtBN;AAyBI;EACE,OAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,8BAAA;EACA,sBAAA;AAvBN;AAyBM;EACE,aAAA;EACA,uBAAA;EACA,QAAA;AAvBR;AA0BM;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;AAxBR;AA2BM;EACE,OAAA;EACA,YAAA;AAzBR;AA4BM;EACE,cAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AA1BR;AA6BM;EACE,eAAA;EACA,WAAA;EACA,gBAAA;AA3BR;AA6BQ;EACE,kBAAA;AA3BV;AA6BU;EACE,gBAAA;AA3BZ;AAiCI;EAlGF;IAmGI,SAAA;IACA,uBAAA;EA9BJ;EAgCI;IACE,YAAA;EA9BN;AACF;AAkCE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,gBAAA;EACA,UAAA;EACA,iBAAA;AAhCJ;AAkCI;;EAEE,aAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAhCN;AAmCI;EACE,SAAA;EACA,cAAA;AAjCN;AAqCE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,gBAAA;EACA,UAAA;AAnCJ;AAqCI;;EAEE,SAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAnCN;AAsCI;EACE,SAAA;AApCN;AAwCE;EACE,eAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAtCJ;AAuCI;EACE,YAAA;EACA,WAAA;AArCN;AA0CE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;EACA,gBAAA;AAxCJ;AA0CI;EACE,OAAA;EACA,WAAA;EACA,oCAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AAxCN;AA0CM;EACE,YAAA;EACA,4DAAA;EACA,kBAAA;EACA,mDAAA;EACA,kBAAA;EACA,gBAAA;AAxCR;AA0CQ;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,sFAAA;EAMA,gCAAA;AA7CV;AAkDI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,iCAAA;AAhDN;AAoDE;EACE;IACE,4BAAA;EAlDJ;EAoDE;IACE,2BAAA;EAlDJ;AACF;AAqDE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,2CAAA;EACA,kDAAA;AAnDJ;AAqDI;EACE,mBAAA;EACA,cAAA;EACA,kDAAA;AAnDN;AAsDI;EACE,2BAAA;EACA,+CAAA;AApDN;AAuDI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AArDN;AAwDI;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;AAtDN;AA0DE;EACE,mBAAA;AAxDJ;AA0DI;EACE,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;AAxDN;AA0DM;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;AAxDR;AA2DM;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;AAzDR;AA4DM;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;AA1DR;AA+DE;EACE,WAAA;EACA,gBAAA;AA7DJ;AA+DI;EACE,cAAA;EACA,eAAA;AA7DN;AAiEE;EACE,cAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,UAAA;EACA,gBAAA;AA/DJ;AAkEE;EACE,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,8CAAA;AAhEJ;AAkEI;EACE,qBAAA;EACA,6BAAA;AAhEN;AAmEI;EACE,qBAAA;AAjEN;AAoEI;EACE,YAAA;EACA,gCAAA;EACA,gBAAA;EACA,kBAAA;AAlEN;AAqEI;EACE,uBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,mDAAA;AAnEN;AAsEI;EACE,iBAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,aAAA;AApEN;AAuEI;EACE,cAAA;EACA,kBAAA;EACA,eAAA;AArEN;;AA0EA;EACE,kBAAA;EACA,0DAAA;EACA,mBAAA;AAvEF;;AA2EA;EACE,WAAA;EACA,UAAA;EACA,SAAA;AAxEF;AA0EE;EACE,aAAA;EACA,2CAAA;EACA,SAAA;EACA,eAAA;EACA,SAAA;EACA,kBAAA;AAxEJ;AA0EI;EARF;IASI,iBAAA;IACA,cAAA;IACA,kBAAA;EAvEJ;AACF;AAyEI;EAdF;IAeI,0BAAA;IACA,SAAA;IACA,aAAA;EAtEJ;AACF;AAwEI;EApBF;IAqBI,aAAA;IACA,SAAA;EArEJ;AACF;;AAyEA;EACE,YAAA;AAtEF;AAwEE;EACE,mBAAA;EACA,gCAAA;EACA,qBAAA;EACA,kBAAA;EACA,uCAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,8BAAA;AAtEJ;AAwEI;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,WAAA;EACA,kCAAA;EACA,OAAA;EACA,YAAA;AAtEN;AA0EE;EACE,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AAxEJ;AA0EI;EACE,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;AAxEN;AA0EM;;EAEE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;AAxER;AA2EM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,mBAAA;EACA,gBAAA;AAzER;AA8EE;EACE,eAAA;EACA,gCAAA;EACA,mBAAA;AA5EJ;AA8EI;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;EACA,8BAAA;AA5EN;AA8EM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;AA5ER;AA+EM;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;AA7ER;AAiFI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,kBAAA;AA/EN;AAiFM;EACE,WAAA;AA/ER;AAkFM;EACE,8BAAA;EACA,kBAAA;AAhFR;AAmFM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;AAjFR;AAmFQ;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,2BAAA;EACA,mBAAA;EACA,cAAA;AAjFV;AAmFU;EACE,mBAAA;AAjFZ;AAoFU;EACE,eAAA;AAlFZ;AAyFE;EACE,eAAA;EACA,gCAAA;EACA,mBAAA;AAvFJ;AAyFI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAvFN;AAyFM;EACE,cAAA;AAvFR;AAyFQ;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AAvFV;AA0FQ;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;AAxFV;AA4FM;EACE,OAAA;EACA,YAAA;AA1FR;AA4FQ;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AA1FV;AA4FU;EACE,cAAA;AA1FZ;AA8FQ;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;AA5FV;AA8FU;EACE,gBAAA;EACA,cAAA;EACA,eAAA;AA5FZ;AAiGM;EACE,aAAA;EACA,eAAA;EACA,SAAA;AA/FR;AAiGQ;;EAEE,oBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;AA/FV;AAkGQ;EACE,mBAAA;EACA,WAAA;AAhGV;AAmGQ;EACE,mBAAA;EACA,WAAA;AAjGV;AAuGE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AArGJ;AAuGI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,+BAAA;AArGN;AAuGM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AArGR;AAyGI;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,gCAAA;AAvGN;AAyGM;EACE,gBAAA;AAvGR;AA0GM;EACE,gBAAA;AAxGR;AA0GQ;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;AAxGV;AA0GU;EACE,0BAAA;AAxGZ;AA8GI;EACE,eAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,UAAA;AA5GN;AA8GM;EACE,cAAA;AA5GR;;AAkHA;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;AA/GF;AAiHE;EAVF;IAWI,WAAA;IACA,eAAA;IACA,eAAA;EA9GF;AACF;AAgHE;EACE,gBAAA;EACA,SAAA;EACA,wBAAA;EAAA,mBAAA;AA9GJ;AAiHE;EACE,mBAAA;EACA,cAAA;EACA,aAAA;AA/GJ;AAiHI;EACE,iBAAA;EACA,gBAAA;AA/GN;AAkHI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAhHN;AAmHI;EACE,YAAA;EACA,oCAAA;EACA,kBAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAjHN;AAmHM;EACE,mBAAA;EACA,WAAA;AAjHR;AAoHM;EACE,eAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AAlHR;AAqHM;EACE,gBAAA;AAnHR;AAsHM;EACE,OAAA;EACA,gBAAA;AApHR;AAyHE;EACE,cAAA;EACA,cAAA;EACA,6BAAA;EACA,sBAAA;EACA,WAAA;AAvHJ;AAyHI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAvHN;AA0HI;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;AAxHN;AA2HI;EACE,aAAA;EACA,QAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,2BAAA;EACA,gBAAA;AAzHN;AA2HM;EACE,mBAAA;AAzHR;AA4HM;EACE,cAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AA1HR;AA4HQ;;EAEE,WAAA;EACA,YAAA;EACA,iBAAA;AA1HV;AA8HM;EACE,OAAA;EACA,YAAA;AA5HR;AA8HQ;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;AA5HV;AA+HQ;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AA7HV;AA+HU;EACE,cAAA;AA7HZ;AAgIU;EACE,cAAA;AA9HZ;AAkIQ;EACE,cAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAhIV;AAuIE;EACE;IACE,wBAAA;EArIJ;AACF;;AA0IA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AAvIF;;AA0IA;EACE,gBAAA;EACA,mBAAA;EACA,UAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,yCAAA;AAvIF;;AA0IA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,gCAAA;AAvIF;AAyIE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAvIJ;AA0IE;EACE,uBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,2BAAA;AAxIJ;AA0II;EACE,mBAAA;AAxIN;AA2II;EACE,cAAA;AAzIN;;AA8IA;EACE,aAAA;EACA,OAAA;EACA,gBAAA;AA3IF;AA6IE;EACE,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;AA3IJ;AA6II;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AA3IN;;AAgJA;EACE,kBAAA;EACA,6BAAA;EACA,aAAA;EACA,yBAAA;AA7IF;AA+IE;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;AA7IJ;AA+II;EACE,mBAAA;EACA,YAAA;EACA,YAAA;AA7IN;AA+IM;EACE,mBAAA;AA7IR;;AAkJA;EACE,wBAAA;AA/IF;;AAiJA;EACE,yBAAA;AA9IF;;AAgJA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,UAAA;EACA,cAAA;EACA,eAAA;EACA,uBAAA;EACA,gBAAA;AA7IF;AA+IE;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AA7IJ;AAiJI;EACE,sBAAA;AA/IN;AAkJI;EACE,yBAAA;AAhJN;;AAqJA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,mCAAA;EACA,0CAAA;AAlJF;AAoJE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;AAlJJ;AAqJE;EACE,+BAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,sBAAA;EACA,uBAAA;EACA,0BAAA;EACA,4BAAA;EACA,oBAAA;EACA,qBAAA;EACA,iBAAA;EACA,cAAA;EACA,0BAAA;AAnJJ;AAsJE;EACE,SAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AApJJ;AAuJE;EACE,SAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AArJJ;AAwJE;EACE,qBAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,0BAAA;AAtJJ;;AA0JA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,8BAAA;AAvJF;AAwJE;EACE,kCAAA;EACA,gBAAA;EACA,6BAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,iDAAA;EACA,kBAAA;AAtJJ;AAyJE;EACE,gCAAA;AAvJJ;AA0JE;EACE,0BAAA;EACA,sBAAA;AAxJJ;AA2JI;EACE,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,2BAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAzJN;AA0JM;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;AAxJR;AA0JM;EACE,WAAA;EACA,YAAA;AAxJR;AA4JI;EACE,yBAAA;EACA,2BAAA;EACA,aAAA;EACA,iBAAA;AA1JN;AA6JE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;AA3JJ;AA8JE;EACE,yBAAA;EACA,YAAA;AA5JJ;AA8JE;EACE,6BAAA;AA5JJ;AA+JE;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;AA7JJ;AA+JI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AA7JN;AA+JM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,WAAA;AA7JR;AA+JQ;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AA7JV;AAkKI;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,8BAAA;EACA,aAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;AAhKN;AAkKM;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AAhKR;AAoKE;EACE,kBAAA;EACA,aAAA;EACA,UAAA;EACA,eAAA;EACA,QAAA;EACA,MAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;AAlKJ;AAqKE;EACE;IACE,gBAAA;EAnKJ;EAqKE;IACE,UAAA;EAnKJ;AACF;;AAuKA;EACE;IACE,2BAAA;EApKF;EAqKE;IACE,mCAAA;IACA,gCAAA;EAnKJ;AACF;AAsKA;EAEI;IACE,iBAAA;IACA,iBAAA;EArKJ;EAsKI;IACE,iBAAA;EApKN;EAsKI;IACE,iBAAA;EApKN;AACF;AAyKA,6DAAA;AACA;EACE;IACE,0BAAA;EAvKF;EAyKA;IACE,0BAAA;EAvKF;EA0KA,qCAAA;EACA;IACE,0BAAA;IACA,cAAA;EAxKF;EA2KA,kCAAA;EACA;IACE,oBAAA;IACA,eAAA;IACA,QAAA;EAzKF;EA4KA,qEAAA;EACA;IACE,yBAAA;IACA,cAAA;IACA,WAAA;IACA,iBAAA;IACA,eAAA;EA1KF;EA6KA;IACE,oBAAA;IACA,mBAAA;IACA,QAAA;IACA,iBAAA;IACA,eAAA;EA3KF;AACF;AA8KA;EACE,aAAA;EACA,0CAAA;EACA,gBAAA;EACA,UAAA;AA5KF;;AA+KA;EACE,2CAAA;AA5KF;;AA+KA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;AA5KF;AA+KI;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;AA7KN;AA+KM;EACE,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,iBAAA;AA7KR;AA+KQ;EACE,sBAAA;EACA,uBAAA;EACA,0BAAA;EACA,4BAAA;EACA,iBAAA;AA7KV;AAiLM;EACE,oBAAA;AA/KR;;AAqLA;EACE,qBAAA;EACA,cAAA;EACA,uBAAA;EACA,iBAAA;EACA,aAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAlLF;;AAqLA;EACE;IACE,qBAAA;IACA,gBAAA;EAlLF;EAuLI;IACE,mBAAA;IACA,SAAA;EArLN;AACF;AA0LA;EACE,iBAAA;AAxLF;;AA0LA,0BAAA;AAEE;EACE,uBAAA;EACA,gBAAA;EACA,0BAAA;EACA,uBAAA;AAxLJ;AAyLI;EACE,iBAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;AAxLN;AA2LI;EACE,sBAAA;AAzLN;AA2LI;EACE,sBAAA;AAzLN;AA2LI;EACE,WAAA;EACA,cAAA;EACA,iDAAA;EACA,0BAAA;EACA,YAAA;AAzLN;AA4LE;EACE,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,oBAAA;AA1LJ;AA4LE;EACE,YAAA;EACA,qBAAA;EACA,4BAAA;EACA,2BAAA;EAEA,iCAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,8CAAA;AA3LJ;AA4LI;EACE,kBAAA;EACA,SAAA;EACA,SAAA;EACA,YAAA;EACA,0BAAA;AA1LN;AA4LI;EACE,gBAAA;AA1LN;AA6LI;EACE,sBAAA;EACA,mCAAA;EACA,wBAAA;EACA,2BAAA;EACA,sBAAA;EACA,iBAAA;AA3LN;AA6LI;EACE,aAAA;AA3LN;AA4LM;EACE,sBAAA;EACA,uBAAA;EACA,8BAAA;AA1LR;AA+LE;EACE,kBAAA;EACA,QAAA;EACA,UAAA;AA7LJ;AA8LI;EACE,0CAAA;AA5LN;;AAiMA;EAGM;IACE,4BAAA;EAhMN;AACF;AAqMA;EAEI;IACE,sBAAA;IACA,aAAA;IACA,8BAAA;EApMJ;EAsME;IACE,qBAAA;IACA,sBAAA;EApMJ;AACF;AAuMA;EAEI;IACE,sBAAA;IACA,aAAA;IACA,6BAAA;EAtMJ;EAwME;IACE,qBAAA;IACA,sBAAA;EAtMJ;AACF;AA0MA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;AAxMF;AAyME;EACE,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AAvMJ;;AA2MA;EACE,aAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;AAxMF;AAyME;EACE,QAAA;AAvMJ;AAyME;EACE,QAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;AAvMJ;AAyME;EACE,QAAA;AAvMJ;AAyMI;EACE,aAAA;EACA,uBAAA;AAvMN;AAyMM;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,gBAAA;EACA,UAAA;AAvMR;AAyMQ;EACE,SAAA;EACA,mBAAA;AAvMV;AA0MQ;EACE,SAAA;AAxMV;AA6ME;EACE,QAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AA3MJ;AA6MI;;EAEE,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;AA3MN;AA8ME;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;EACA,mBAAA;AA5MJ;;AAgNA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;AA7MF;AAgNE;EACE,cAAA;EACA,eAAA;AA9MJ;AAiNE;EACE,cAAA;EACA,eAAA;EACA,mBAAA;AA/MJ;AAkNM;EACE,kBAAA;AAhNR;AAmNM;EACE,0BAAA;AAjNR;AAoNM;EACE,0BAAA;AAlNR;AAqNM;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAnNR;AAyNE;EACE,yBAAA;EACA,0BAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;AAvNJ;AA0NE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,gBAAA;EACA,UAAA;EACA,mBAAA;AAxNJ;AA0NI;EACE,SAAA;EACA,mBAAA;AAxNN;AA2NI;EACE,SAAA;AAzNN;AA6NE;EACE,yBAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,wBAAA;EACA,mBAAA;EACA,qBAAA;AA3NJ;AA6NI;;EAEE,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;AA3NN;AAgOI;EACE,cAAA;EACA,eAAA;AA9NN;AAiOI;EACE,cAAA;EACA,kBAAA;EACA,QAAA;AA/NN;AAkOE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;EACA,mBAAA;AAhOJ;AAmOE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,0DAAA;EACA,YAAA;AAjOJ;AAmOI;EACE,qBAAA;EACA,4CAAA;AAjON;AAoOI;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAlON;AAoOM;EAAc,cAAA;AAjOpB;AAoOI;EACE,OAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AAlON;AAqOI;EACE,OAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAnON;AAqOM;EACE,UAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAnOR;AAsOM;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AApOR;AAwOI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;AAtON;AAyOI;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,uBAAA;EACA,mDAAA;AAvON;AAyOM;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAvOR;AA0OM;EACE,cAAA;AAxOR;AAyOQ;EAAU,mCAAA;AAtOlB;AAyOM;EACE,cAAA;AAvOR;AAwOQ;EAAU,kCAAA;AArOlB;;AA0OA;EACE,6BAAA;EACA,uBAAA;EACA,wBAAA;EAEA,qBAAA;AAxOF;AA0OE;EACE,uBAAA;EACA,wBAAA;EACA,qBAAA;AAxOJ;;AA4OE;EACE,mBAAA;EACA,cAAA;AAzOJ;AA2OE;EACE,WAAA;AAzOJ;;AA4OA;EACE,gBAAA;AAzOF;;AA2OA;EACE,cAAA,EAAA,eAAA;EACA,eAAA,EAAA,4BAAA;EACA,0BAAA,EAAA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;AAxOF;;AA2OA;EACE,cAAA,EAAA,0BAAA;AAxOF;;AA2OA,8CAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,QAAA;EACA,eAAA;AAxOF;;AA2OA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;AAxOF;;AA2OA;EACE,mBAAA;AAxOF;;AA2OA;EACE,mBAAA;AAxOF;;AA2OA;EACE,WAAA;EACA,gBAAA;AAxOF;;AAgQA;EACE,gBAAA;EACA,wBAAA;EACA,YAAA,EAAA,uBAAA;EACA,yBAAA,EAAA,yCAAA;EACA,mBAAA,EAAA,iDAAA;EACA,gBAAA,EAAA,oDAAA;EACA,YAAA,EAAA,0CAAA;AA7PF;;AAgQA;EACE,yBAAA,EAAA,yCAAA;AA7PF;;AAgQA;EACE,yBAAA,EAAA,qCAAA;AA7PF;;AAgQA;EACE,yBAAA,EAAA,gDAAA;AA7PF;;AAiQA;EACE;IACE,sBAAA;EA9PF;EAgQA;IACE,mBAAA;IACA,eAAA;EA9PF;AACF;AAiQA;EACE;IACE,UAAA;EA/PF;EAiQA;IACE,WAAA;IACA,aAAA;IACA,iBAAA;IACA,gBAAA;EA/PF;EAiQA;;IAEE,aAAA;EA/PF;EAiQA;IACE,aAAA;EA/PF;EAiQA;IACE,aAAA;EA/PF;EAmQA;IACE,2BAAA;IACA,kBAAA;IACA,iCAAA;IACA,qBAAA;IACA,gBAAA;IACA,eAAA;IACA,mBAAA;EAjQF;EAmQE;IACE,aAAA;EAjQJ;EAsQA;IACE,yBAAA;IACA,cAAA;IACA,eAAA;IACA,WAAA;IACA,aAAA;IACA,kBAAA;EApQF;EAuQA;IACE,cAAA;IACA,kBAAA;IAEA,8BAAA;EAtQF;EAyQA;IACE,eAAA;IACA,sBAAA;EAvQF;EA2QA;IACE,aAAA;IACA,kBAAA;EAzQF;EA4QA;IACE,WAAA;IACA,eAAA;EA1QF;EA6QA;;;;IAIE,eAAA;EA3QF;EA+QA;IACE,cAAA;IACA,eAAA;EA7QF;EA+QA;IACE,eAAA;IACA,gBAAA;EA7QF;EAkRA;IACE,cAAA;IACA,kBAAA;EAhRF;EAmRA;IAEE,wBAAA;IACA,eAAA;IACA,OAAA;IACA,QAAA;IACA,SAAA;IACA,cAAA;IACA,iBAAA;IACA,qDAAA;IACA,QAAA;IACA,iBAAA;IACA,mBAAA;EAlRF;EAsRA;IACE,wDAAA;EApRF;EAwRA;;IAEE,WAAA;IACA,YAAA;EAtRF;EAyRA;IACE,WAAA;EAvRF;EA0RA;IACE,aAAA;IACA,iBAAA;IACA,QAAA;IACA,wBAAA;EAxRF;EA2RA;;;IAGE,WAAA;IACA,YAAA;IACA,aAAA;EAzRF;EA4RA;IACE,WAAA;IACA,WAAA;IACA,gBAAA;IACA,iBAAA;IACA,eAAA;IACA,sBAAA;EA1RF;EA6RA,8EAAA;EACA;IACE,cAAA;IACA,WAAA;IACA,YAAA;IACA,UAAA;IACA,kBAAA;IACA,yBAAA;IACA,gBAAA;IACA,cAAA;IACA,oBAAA;IACA,mBAAA;IACA,uBAAA;IACA,eAAA;EA3RF;EA6RE;IACE,eAAA;IACA,WAAA;IACA,YAAA;IACA,iBAAA;EA3RJ;EA+RA;IACE,mBAAA;IACA,qBAAA;IACA,cAAA;EA7RF;EAsSE;IACE,wBAAA;EApSJ;EAuSE;IACE,2BAAA;IACA,6BAAA;IACA,iCAAA;IACA,mBAAA;IACA,qBAAA;EArSJ;EAuSI;IACE,aAAA;EArSN;EA0SE;IACE,0BAAA;IACA,kBAAA;EAxSJ;EA2SE;IACE,kBAAA;IACA,iBAAA;EAzSJ;EA6SE;IACE,uBAAA;EA3SJ;AACF;AAgTA;EACE,aAAA;EACA,gCAAA;AA9SF;AAgTE;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AA9SJ;AAiTE;EACE,SAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AA/SJ;;AAqTE;EACE,yBAAA;AAlTJ;AAqTE;EACE,yBAAA;AAnTJ;AAsTE;EACE,yBAAA;AApTJ;;AA2TI;EAIE,yBAAA;AA3TN;;AAmUI;EAEE,yBAAA;AAjUN;AAuUM;EAGE,yBAAA;AAvUR;;AA+UE;EACE,iBAAA;EACA,gBAAA;AA5UJ;AA8UI;EACE,UAAA;AA5UN;AA+UI;EACE,mBAAA;EACA,kBAAA;AA7UN;AAgVI;EACE,mBAAA;EACA,kBAAA;AA9UN;AAgVM;EACE,mBAAA;AA9UR;AAmVE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAjVJ;AAoVE;EACE,mBAAA;EACA,mBAAA;EACD,6CAAA;EACC,gBAAA;EACA,mBAAA;AAlVJ;AAoVI;EACE,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAlVN;AAoVM;;EAEE,WAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;AAlVR;AAqVM;EACE,cAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,mBAAA;AAnVR;AAqVQ;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAnVV;AAsVQ;EACE,SAAA;EACA,eAAA;AApVV;AAyVI;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAvVN;AA0VI;EACE,eAAA;EACA,gBAAA;EACA,SAAA;EACA,cAAA;EACA,gBAAA;AAxVN;AA2VI;EACE,cAAA;EACA,gBAAA;EACA,eAAA;AAzVN;AA2VM;EACE,mBAAA;AAzVR;AA6VI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,eAAA;AA3VN;AA6VM;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AA3VR;AA6VQ;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AA3VV;AAiWE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;AA/VJ;AAiWI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;AA/VN;AAkWI;EACE,SAAA;EACA,eAAA;EACA,cAAA;AAhWN;AAqWE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAnWJ;AAsWE;;EAEE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AApWJ;AAuWE;;EAEE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;AArWJ;AAuWI;;EACE,qBAAA;EACA,yCAAA;AApWN;AAuWI;;;;EAEE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;AAnWN;AAsWI;;;;EAEE,OAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAlWN;AAoWM;;;;;;;;EAEE,eAAA;EACA,gBAAA;EACA,cAAA;AA5VR;AA+VM;;;;;;;;EAEE,eAAA;EACA,cAAA;EACA,qBAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;AAvVR;AAyVQ;;;;;;;;EACE,0BAAA;AAhVV;AAmVQ;;;;;;;;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA1UV;AAkVI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAhVN;AAmVI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;AAjVN;AAmVM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAjVR;AAoVM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAlVR;AAoVQ;EACE,cAAA;EACA,eAAA;AAlVV;AAsVM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AApVR;AAsVQ;EACE,eAAA;EACA,WAAA;EACA,YAAA;AApVV;AA0VE;EAEI;IACE,sBAAA;IACA,uBAAA;IACA,2BAAA;IACA,QAAA;EAzVN;AACF;AA8VE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AA5VJ;AA8VI;EACE,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AA5VN;AA+VI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AA7VN;AAgWI;EACE,aAAA;EACA,SAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AA9VN;AAgWM;EACE,qBAAA;EACA,yCAAA;EACA,2BAAA;AA9VR;AAiWM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA/VR;AAiWQ;;EAEE,WAAA;EACA,YAAA;EACA,iBAAA;AA/VV;AAkWQ;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAhWV;AAkWU;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAhWZ;AAqWM;EACE,OAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,uBAAA;AAnWR;AAqWQ;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;AAnWV;AAsWQ;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;AApWV;AAsWU;EACE,OAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AApWZ;AAuWU;EACE,gBAAA;EACA,cAAA;AArWZ;;AA8WA;EACE,gBAAA;EACA,UAAA;EACA,uBAAA;AA3WF;;AA8WA;EACE,mBAAA;AA3WF;AA6WE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;AA3WJ;AA8WE;EACE,eAAA;EACA,cAAA;EACA,SAAA;EACA,iBAAA;AA5WJ;;AAgXA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;AA7WF;;AAgXA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,+BAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AA7WF;;AAgXA;EACE,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,6CAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AA7WF;;AAgXA;EACE,kBAAA;EACA,gCAAA;EACA,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;EACA,cAAA;AA7WF;AA+WE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;AA7WJ;AAgXE;EACE,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AA9WJ;AAiXE;EACE,cAAA;AA/WJ;;AAmXA;EACE,aAAA;EACA,gBAAA;AAhXF;AAkXE;EAJF;IAKI,aAAA;EA/WF;AACF;;AAkXA;EACE,OAAA;EACA,gBAAA;EACA,0BAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;EACA,8DAAA;EACA,eAAA;EACA,cAAA;AA/WF;AAiXE;EACE,yBAAA;EACA,kCAAA;AA/WJ;AAkXE;EACE,YAAA;EACA,eAAA;AAhXJ;;AAoXA;EACE,eAAA;EACA,cAAA;AAjXF;;AAoXA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;AAjXF;AAmXE;EACE,gBAAA;EACA,eAAA;AAjXJ;AAoXE;EACE,eAAA;EACA,cAAA;AAlXJ;;AAsXA;EACE,aAAA;EACA,mBAAA;AAnXF;AAqXE;EACE,mBAAA;AAnXJ;;AAuXA;EACE,mBAAA;AApXF;AAsXE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AApXJ;AAuXE;EACE,iBAAA;EACA,eAAA;EACA,cAAA;AArXJ;;AAyXA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,yBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,8DAAA;AAtXF;AAwXE;EACE,mBAAA;AAtXJ;AAyXE;EACE,cAAA;EACA,qBAAA;EACA,mBAAA;AAvXJ;AA0XE;EACE,mBAAA;EACA,WAAA;EACA,qBAAA;AAxXJ;AA0XI;EACE,mBAAA;EACA,qBAAA;AAxXN;AA4XE;EACE,eAAA;AA1XJ;;AA+XA;EACE,mBAAA;AA5XF;;AA+XA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AA5XF;;AA+XA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;AA5XF;;AA+XA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,qEAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AA5XF;;AA+XA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AA5XF;;AA+XA;EACE,OAAA;EACA,WAAA;EACA,oCAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;AA5XF;AA8XE;EACE,wBAAA;UAAA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;AA5XJ;AA+XE;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;AA7XJ;;AAiYA;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;AA9XF;;AAiYA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,oCAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,gCAAA;AA9XF;AAgYE;EACE,gBAAA;AA9XJ;AAiYE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA/XJ;;AAmYA;EACE,aAAA;EACA,QAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,oCAAA;AAhYF;AAkYE;EACE,WAAA;AAhYJ;AAmYE;EACE,uBAAA;AAjYJ;AAoYE;EACE,mBAAA;EACA,kBAAA;AAlYJ;AAoYI;EACE,mBAAA;AAlYN;;AAuYA;EACE,kBAAA;EACA,YAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,6BAAA;EACA,mCAAA;EACA,gBAAA;AApYF;AAsYE;EACE,qBAAA;AApYJ;AAuYE;EACE,qBAAA;EACA,iBAAA;AArYJ;AAwYE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;AAtYJ;;AA0YA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAvYF;AAyYE;EACE,WAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AAvYJ;;AA2YA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AAxYF;;AA2YA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AAxYF;;AA2YA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AAxYF;;AA2YA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;AAxYF;;AA2YA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;AAxYF;;AA2YA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;AAxYF;AA0YE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAxYJ;AA2YE;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AAzYJ;;AA6YA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,mBAAA;AA1YF;AA4YE;EACE,eAAA;EACA,cAAA;AA1YJ;;AA8YA;EACE,gBAAA;AA3YF;;AA8YA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;AA3YF;AA6YE;EACE,gBAAA;AA3YJ;;AA+YA;EACE,gBAAA;EACA,iBAAA;EACA,yCAAA;AA5YF;;AA+YA;EACE,eAAA;EACA,mBAAA;AA5YF;AA8YE;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AA5YJ;AA+YE;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AA7YJ;;AAiZA;EACE,gBAAA;EACA,gBAAA;AA9YF;;AAmZE;;EACE,cAAA;EACA,sBAAA;EACA,YAAA;EACA,oBAAA;AA/YJ;AAiZI;;EACE,aAAA;AA9YN;AAiZI;;EACE,gBAAA;EACA,iBAAA;EACA,oBAAA;AA9YN;AAiZI;;EACE,SAAA;AA9YN;AAiZI;;EACE,sHAAA;EACA,oDAAA;AA9YN;;AAmZA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AAhZF;AAkZE;EACE,gBAAA;EACA,YAAA;EACA,oBAAA;EACA,kBAAA;AAhZJ;;AAoZA;EACE,oCAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,+BAAA;AAjZF;;AAoZA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AAjZF;AAmZE;EACE,OAAA;EACA,gBAAA;AAjZJ;AAmZI;EACE,aAAA;AAjZN;AAqZE;EACE,cAAA;EACA,kBAAA;EACA,cAAA;AAnZJ;AAqZI;EACE,cAAA;EACA,mBAAA;AAnZN;;AAwZA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AArZF;AAuZE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,2BAAA;EACA,oBAAA;EACA,sBAAA;AArZJ;AAuZI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AArZN;AAwZI;EACE,mBAAA;EACA,WAAA;AAtZN;;AA2ZA;EACE,gBAAA;EACA,iBAAA;EACA,yCAAA;AAxZF;AA0ZE;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AAxZJ;;AA4ZA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;AAzZF;AA2ZE;EACE,SAAA;AAzZJ;AA4ZE;EACE,eAAA;EACA,cAAA;EACA,eAAA;AA1ZJ;;AA8ZA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,2BAAA;EACA,oBAAA;EACA,sBAAA;AA3ZF;AA6ZE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AA3ZJ;AA8ZE;EACE,mBAAA;AA5ZJ;;AAgaA;EACE;IACE,sBAAA;IACA,oBAAA;EA7ZF;EAgaA;IACE,WAAA;IACA,uBAAA;EA9ZF;EAiaA;IACE,sBAAA;IACA,oBAAA;EA/ZF;EAiaE;IACE,WAAA;IACA,gBAAA;IACA,YAAA;EA/ZJ;EAmaA;IACE,sBAAA;IACA,oBAAA;EAjaF;EAmaE;IACE,WAAA;IACA,uBAAA;EAjaJ;AACF;AAqaA;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAnaF;AAqaE;EACE,WAAA;AAnaJ;;AAwaA;EACE,aAAA;EACA,4DAAA;EACA,SAAA;EACA,gBAAA;EACA,UAAA;AAraF;AAuaE;EAPF;IAQI,4DAAA;IACA,SAAA;EApaF;AACF;;AAuaA;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,yBAAA;EACA,eAAA;AApaF;AAsaE;EACE,yCAAA;EACA,2BAAA;AApaJ;AAuaE;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,8BAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,yBAAA;AAraJ;AAuaI;EACE,8BAAA;EACA,qBAAA;AAraN;AAwaI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAtaN;AA0aE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,oCAAA;EACA,kBAAA;AAxaJ;AA2aE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;EACA,uBAAA;EAAA,kBAAA;EACA,4BAAA;EACA,gBAAA;EACA,kBAAA;EACA,kCAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAzaJ;AA4aE;EACE,eAAA;AA1aJ;AA4aI;;EAEE,aAAA;AA1aN;AA6aI;EACE,gBAAA;AA3aN;AA+aE;EACE,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AA7aJ;AA+aI;;EAEE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AA7aN;AAgbI;EACE,gBAAA;AA9aN;AAibI;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,oBAAA;EACA,oCAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,yCAAA;AA/aN;AAkbI;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,8BAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;AAhbN;AAmbI;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,kCAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;AAjbN;AAqbE;EACE,gBAAA;AAnbJ;AAsbE;EACE,aAAA;AApbJ;AAsbI;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,2BAAA;AApbN;AAsbM;EACE,cAAA;AApbR;AAwbI;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAtbN;AAwbM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,6BAAA;AAtbR;AAwbQ;EACE,YAAA;AAtbV;AAybQ;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAvbV;AA0bQ;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;AAxbV;AA2bQ;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AAzbV;AA6bM;EACE,eAAA;EACA,cAAA;EACA,iBAAA;AA3bR;;AAicA,sEAAA;AAEE;EACE,8BAAA;EACA,yBAAA;AA/bJ;AAkcE;;;;;;;;;;;;;;;;;EAiBE,8BAAA;EACA,yBAAA;EACA,kDAAA;EACA,2BAAA;AAhcJ;AAocE;EACE,kCAAA;EACA,yDAAA;EACA,2BAAA;AAlcJ;AAqcE;;;;;;EAME,8BAAA;EACA,yBAAA;AAncJ;AAscE;;;;;;;;;;EAUE,8BAAA;EACA,yBAAA;EACA,kDAAA;AApcJ;AAucE;;;EAGE,8BAAA;EACA,yBAAA;AArcJ;AAwcE;;EAEE,8BAAA;AAtcJ;AAycE;;;;EAIE,8BAAA;EACA,gCAAA;EACA,yBAAA;AAvcJ;AA0cE;;;EAGE,8BAAA;EACA,yBAAA;EACA,iDAAA;AAxcJ;AA2cE;EACE,gDAAA;EACA,kDAAA;AAzcJ;AA4cE;;EAEE,yBAAA;AA1cJ;AA6cE;EACE,yBAAA;AA3cJ;AA8cE;EACE,qDAAA;AA5cJ;AA+cE;;;;;;;;;EASE,yBAAA;AA7cJ;;AAidA;;;8MAAA;AAOE;EACE,8BAAA;AAjdJ;AAodE;;EAEE,8BAAA;EACA,iDAAA;AAldJ;AAqdE;;;;;;EAME,8BAAA;EACA,iDAAA;EACA,yBAAA;AAndJ;AAudE;EACE,8BAAA;EACA,iDAAA;AArdJ;AAudI;EACE,8BAAA;EACA,kDAAA;AArdN;AAudM;EAAa,0BAAA;AApdnB;AAqdM;EAAa,wBAAA;AAldnB;AAmdM;EAAmB,yBAAA;AAhdzB;AAmdI;;EAEE,8BAAA;EACA,yBAAA;AAjdN;AAodI;EACE,yBAAA;AAldN;AAudE;EACE,8BAAA;EACA,kDAAA;AArdJ;AAudI;EACE,yBAAA;AArdN;AA0dE;EACE,2CAAA;AAxdJ;AA0dI;EAA6B,8BAAA;AAvdjC;AAwdI;EACE,8BAAA;AAtdN;AAudM;EAAU,8BAAA;AApdhB;AAydE;EACE,8BAAA;EACA,iDAAA;AAvdJ;AA0dE;EACE,8BAAA;EACA,oDAAA;AAxdJ;AA0dI;EACE,8BAAA;EACA,yBAAA;AAxdN;AA2dI;EACE,yBAAA;AAzdN;AA4dI;EACE,yBAAA;AA1dN;AA2dM;EAAI,yBAAA;AAxdV;AA2dI;EACE,8BAAA;EACA,yBAAA;AAzdN;AA6dE;;EAEE,8BAAA;EACA,kDAAA;AA3dJ;AA6dI;;;;EAEE,yBAAA;AAzdN;AA6dE;EACE,yBAAA;AA3dJ;AA6dI;EAAW,yBAAA;AA1df;AA2dI;EAAW,yBAAA;AAxdf;AA4dE;EACE,8BAAA;EACA,qDAAA;AA1dJ;AA6dE;EACE,8BAAA;EACA,wDAAA;AA3dJ;AA6dI;EAAK,yBAAA;AA1dT;AA6dM;EAAU,8BAAA;AA1dhB;AA2dM;EAAW,yBAAA;AAxdjB;AA4dE;EACE,8BAAA;AA1dJ;AA8dE;;EAEE,8BAAA;EACA,kDAAA;AA5dJ;AA+dE;EAAoB,yBAAA;AA5dtB;AA6dE;;;EAEoB,yBAAA;AA1dtB;AA6dE;EACE,8BAAA;EACA,qDAAA;AA3dJ;AA8dE;EACE,8BAAA;EACA,wDAAA;AA5dJ;AA8dI;EAAK,yBAAA;AA3dT;AA4dI;EAAK,yBAAA;AAzdT;AA4dE;EACE,8BAAA;AA1dJ;AA6dE;EACE,8BAAA;EACA,iDAAA;EACA,yBAAA;AA3dJ;AA6dI;EACE,+CAAA;EACA,gCAAA;AA3dN;AA8dI;EAAe,yBAAA;AA3dnB;AA4dI;;EACqB,yBAAA;AAzdzB;AA4dE;;;EAGE,8BAAA;EACA,kDAAA;AA1dJ;AA4dI;;;EAAW,yBAAA;AAvdf;AAwdI;;;EAAW,yBAAA;AAndf;AAydE;;EAEE,8BAAA;EACA,wDAAA;EACA,2BAAA;AAvdJ;AAydI;;EAAsB,yBAAA;AArd1B;AAydE;;EAEE,yBAAA;AAvdJ;AA0dE;;EAEE,8BAAA;EACA,yBAAA;AAxdJ;AA0dI;;EAAW,yBAAA;AAtdf;AAudI;;EAAW,yBAAA;AAndf;AAqdI;;EAAyB,8BAAA;AAjd7B;AAqdE;;EAEE,kCAAA;EACA,wDAAA;AAndJ;AAqdI;;EAAqB,yBAAA;AAjdzB;AAkdI;;;;EACqB,yBAAA;AA7czB;AA8cI;;EAAqB,yBAAA;AA1czB;AA8cE;;EAEE,8BAAA;EACA,8BAAA;AA5cJ;AA+cI;;;;EAEE,yBAAA;AA3cN;AA+cI;;EACE,yBAAA;AA5cN;AA8cM;;EACE,yBAAA;AA3cR;AA8cM;;;;;;;;;;;;;;EAEE,yBAAA;AAhcR;AAmcM;;EACE,yBAAA;EACA,qCAAA;AAhcR;AAqcI;;EACE,kCAAA;EACA,wCAAA;EACA,2BAAA;EACA,uBAAA;EACA,yBAAA;EACA,2BAAA;AAlcN;AAocM;;EACE,kCAAA;EACA,yBAAA;AAjcR;AAscI;;;;EAEE,yBAAA;AAlcN;AAocM;;;;EAAU,yBAAA;AA9bhB;AAmcE;;EAEE,8BAAA;EACA,yBAAA;AAjcJ;AAmcI;;EACE,8BAAA;EACA,yBAAA;AAhcN;AAmcI;;EAAmB,yBAAA;AA/bvB;AAmcE;;EAEE,qDAAA;AAjcJ;AAmcI;;EAAK,yBAAA;AA/bT;AAkcM;;EAAU,8BAAA;AA9bhB;AAgcM;;EAAwB,yBAAA;AA5b9B;AA6bM;;EAAwB,yBAAA;AAzb9B;AAgcE;;EAEE,8BAAA;EACA,wDAAA;AA9bJ;AAicE;;EAEE,yBAAA;AA/bJ;AAkcE;;EAEE,yBAAA;AAhcJ;AAmcE;;EAEE,gCAAA;AAjcJ;AAocE;;EAEE,8BAAA;AAlcJ;AAscE;;;;EAIE,yBAAA;AApcJ;AAucE;;;EAGE,yBAAA;AArcJ;AAycE;EACE,8BAAA;EACA,iDAAA;AAvcJ;AAycI;EACE,gCAAA;EACA,oDAAA;AAvcN;AA0cI;EAAiB,yBAAA;AAvcrB;AAwcI;EAAiB,yBAAA;AArcrB;AAscI;EAAiB,yBAAA;AAncrB;AAmcgD;EAAc,yBAAA;AAhc9D;AAmcM;EAAU,yBAAA;AAhchB;AAgc2C;EAAU,+CAAA;AA7brD;AA8bM;EAAW,yBAAA;AA3bjB;AA2b4C;EAAU,8CAAA;AAxbtD;AA6bE;;EAEE,8BAAA;EACA,yBAAA;EACA,gCAAA;AA3bJ;AA6bI;;EACE,8BAAA;EACA,yBAAA;EACA,gCAAA;AA1bN;AA+bE;EACE,8BAAA;EACA,yBAAA;EACA,qDAAA;AA7bJ;AA+bI;EAAW,yBAAA;AA5bf;AA8bI;EAAU,8BAAA;AA3bd;AA+bE;EACE,yBAAA;AA7bJ;AAocI;EACE,8BAAA;EACA,iDAAA;AAlcN;AAqcI;EACE,yBAAA;AAncN;AAscI;EACE,yBAAA;AApcN;AAscM;EACE,yBAAA;AApcR;AAwcI;EACE,yBAAA;AAtcN;AAwcM;EAAW,yBAAA;AArcjB;AA2cE;EACE,8BAAA;EACA,kDAAA;AAzcJ;AA2cI;EACE,gCAAA;EACA,mDAAA;AAzcN;AA6cE;EACE,8BAAA;AA3cJ;AA8cE;EAAqB,yBAAA;AA3cvB;AA6cE;;EACkC,yBAAA;AA1cpC;AA4cE;EAAgC,yBAAA;AAzclC;AA2cE;EACE,+CAAA;EACA,yBAAA;EACA,oDAAA;AAzcJ;AA6cE;;EAEE,8BAAA;EACA,yBAAA;EACA,kDAAA;AA3cJ;AA6cI;;EAAW,yBAAA;AAzcf;AA6cE;EACE,4CAAA;EACA,qCAAA;AA3cJ;AA6cI;EAAU,yBAAA;AA1cd;AA4cI;EAAW,yBAAA;AAzcf;AA2cI;EACe,yBAAA;AAzcnB;AA6cE;EACE,8BAAA;EACA,iDAAA;AA3cJ;AA6cI;EAAgB,yBAAA;AA1cpB;AA4cI;EACE,8CAAA;EACA,qCAAA;EACA,yBAAA;AA1cN;AA4cM;EAAa,yBAAA;AAzcnB;AA8cE;EACE,yBAAA;AA5cJ;AA+cE;EACE,yBAAA;AA7cJ;AAidE;EACE,8BAAA;EACA,kDAAA;EACA,yBAAA;AA/cJ;AAidI;EAAI,yBAAA;AA9cR;AAkdE;;;;EAIE,6CAAA;EACA,mDAAA;EACA,qCAAA;AAhdJ;;AAodA;EACE,mBAAA;AAjdF;;AAodA;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,eAAA;AAjdF;;AAodA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,yBAAA;EACA,oBAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AAjdF;AAmdE;EACE,WAAA;EACA,YAAA;EACA,eAAA;AAjdJ;AAodE;EACE,qBAAA;EACA,mBAAA;EACA,cAAA;AAldJ;AAqdE;EACE,aAAA;EACA,mBAAA;AAndJ;;AAudA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AApdF;;AAudA;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AApdF;;AAwdA;EACE,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;AArdF;;AAwdA;EACE,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,SAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;AArdF;AAudE;EATF;IAUI,mBAAA;IACA,oBAAA;IACA,SAAA;EApdF;AACF;;AAudA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,iFAAA;AApdF;AAsdE;EACE,qBAAA;EACA,mBAAA;AApdJ;AAudE;EACE,qBAAA;EACA,mBAAA;EACA,mCAAA;AArdJ;AAwdE;EACE,aAAA;EACA,mBAAA;AAtdJ;AAydE;EA9BF;IA+BI,WAAA;IACA,YAAA;IACA,mBAAA;IACA,QAAA;IACA,kBAAA;EAtdF;AACF;;AAydA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;AAtdF;;AAydA;EACE,cAAA;EACA,YAAA;AAtdF;AAwdE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AAtdJ;AAydE;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAvdJ;AA0dE;EACE;IACE,eAAA;IACA,iBAAA;IACA,mBAAA;IACA,gBAAA;IACA,uBAAA;EAxdJ;EA2dE;IACE,aAAA;EAzdJ;AACF;;AA6dA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;AA1dF;;AA6dA;EACE,gBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;AA1dF;;AA8dE;EACE,WAAA;AA3dJ;AA8dE;;;EAGE,cAAA;EACA,WAAA;EACA,eAAA;AA5dJ;;AAgeA;;EAEE,iBAAA;AA7dF;AA+dE;;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;AA5dJ;AA8dI;;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;AA3dN;AA8dI;;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AA3dN;AA6dM;;EACE,+BAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,sBAAA;EACA,uBAAA;EACA,0BAAA;EACA,4BAAA;EACA,oBAAA;EACA,qBAAA;EACA,iBAAA;EACA,cAAA;EACA,kEAAA;EACA,0BAAA;AA1dR;AA6dM;;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AA1dR;AA8dI;;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;AA3dN;AA8dI;;EACE,cAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AA3dN;AA8dI;;EACE,eAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AA3dN;AA+dE;;EACE,gBAAA;EACA,iBAAA;EACA,6BAAA;AA5dJ;AA8dI;;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;AA3dN;AA8dI;;EACE,cAAA;EACA,eAAA;EACA,cAAA;AA3dN;AA8dI;;EACE,eAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AA3dN;AA8dI;;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,yCAAA;EACA,oBAAA;EACA,sBAAA;AA3dN;AA6dM;;EACE,+BAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,sBAAA;EACA,uBAAA;EACA,0BAAA;EACA,4BAAA;EACA,oBAAA;EACA,qBAAA;EACA,iBAAA;AA1dR;AA6dM;;EACE,mBAAA;EACA,WAAA;AA1dR;AA+dE;;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,gBAAA;AA5dJ;AA8dI;;EACE,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AA3dN;;AAgeA;EACE,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AA7dF;;AAgeA;EACE,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;AA7dF;AA+dE;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;AA7dJ;AAgeE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;AA9dJ;AAgeI;EACE,+BAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,sBAAA;EACA,uBAAA;EACA,0BAAA;EACA,4BAAA;EACA,oBAAA;EACA,qBAAA;EACA,iBAAA;EACA,cAAA;EACA,0BAAA;AA9dN;AAieI;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AA/dN;AAmeE;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAjeJ;AAoeE;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,gBAAA;AAleJ;AAoeI;EACE,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAleN;AAseE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,yCAAA;EACA,oBAAA;EACA,sBAAA;AApeJ;AAseI;EACE,+BAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,sBAAA;EACA,uBAAA;EACA,0BAAA;EACA,4BAAA;EACA,oBAAA;EACA,qBAAA;EACA,iBAAA;AApeN;AAueI;EACE,mBAAA;EACA,WAAA;AAreN;;AA0eA;EACE;IACE,cAAA;EAveF;AACF;AA2eE;EACE,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,0BAAA;AAzeJ","sourcesContent":["@import \"../../shared/styles/publishing-state\";\n\n.mat-badge-content {\n  background: #5ea1d8;\n}\n\n// Main Upload Dialog Styles (matching create-flow)\n.upload-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.8);\n  z-index: 10000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  overflow: hidden;\n}\n\n.upload-dialog {\n  width: 90%;\n  max-width: 1380px;\n  height: 90vh;\n  max-height: 90vh;\n  background: #fff;\n  border-radius: 22px;\n  box-shadow: 0 35px 70px rgba(7, 8, 10, 0.35);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  margin: auto;\n  z-index: 10000;\n}\n\n.upload-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 5px 10px;\n  background: #fff;\n  color: #111827;\n  border-bottom: 1px solid #e4e8f0;\n  position: relative;\n  z-index: 10008;\n  isolation: isolate;\n}\n\n.header-left {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n\n  @media (max-width: 768px) {\n    gap: 12px;\n  }\n}\n\n.header-right {\n  position: relative;\n  z-index: 10009;\n  isolation: isolate;\n}\n\n.icon-circle {\n  width: 54px;\n  height: 54px;\n  border-radius: 50%;\n  background: #f3f4f6;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  \n  mat-icon {\n    color: #5ea1d8;\n    font-size: 24px;\n    width: 24px;\n    height: 24px;\n    line-height: 24px;\n  }\n\n  @media (max-width: 768px) {\n    width: 40px;\n    height: 40px;\n    \n    mat-icon {\n      font-size: 20px;\n      width: 20px;\n      height: 20px;\n      line-height: 20px;\n    }\n  }\n}\n\n.header-copy {\n  p {\n    margin: 0;\n    font-size: 20px;\n    font-weight: 600;\n    \n    .desktop-title {\n      display: block;\n      \n      @media (max-width: 768px) {\n        display: none;\n      }\n    }\n    \n    .mobile-title {\n      display: none;\n      \n      @media (max-width: 768px) {\n        display: block;\n      }\n    }\n  }\n  \n  .header-description {\n    font-size: 14px;\n    color: #6b7280;\n    \n    @media (max-width: 768px) {\n      display: none;\n    }\n  }\n  \n  span {\n    font-size: 14px;\n    color: #6b7280;\n  }\n}\n\n.icon-button {\n  border: none;\n  background: #f3f4f6;\n  color: inherit;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 0.2s ease, transform 0.2s ease;\n  position: relative;\n  z-index: 10007;\n  mat-icon {\n    font-size: 22px;\n  }\n  &:hover {\n    background: #e5e7eb;\n    transform: translateY(-1px);\n  }\n}\n\n.stage-banner {\n  padding: 1px 10px 1px;\n  background: #fff;\n  border-bottom: 1px solid #edf1f7;\n  flex-shrink: 0;\n}\n\n.journey-progress {\n  display: flex;\n  align-items: center;\n  gap: 0;\n  padding: 16px 0 0;\n  margin-top: 12px;\n  flex-shrink: 0;\n  overflow-x: hidden;\n  flex-wrap: nowrap;\n  width: 100%;\n  position: relative;\n}\n\n.journey-step {\n  background: transparent;\n  border: none;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 0;\n  min-width: auto;\n  flex-shrink: 0;\n  cursor: pointer;\n  color: #9ca3af;\n  transition: color 0.2s ease;\n  white-space: nowrap;\n  outline: none;\n  box-shadow: none;\n  -webkit-tap-highlight-color: transparent;\n  // Ensure button aligns properly with connector\n  align-self: center;\n  .tab-count {\n    font-size: 11px;\n    background: rgba(37, 99, 235, 0.08);\n    color: #2563eb;\n    border-radius: 999px;\n    padding: 2px 8px;\n  }\n\n  &:focus,\n  &:focus-visible,\n  &:active {\n    outline: none !important;\n    box-shadow: none !important;\n  }\n\n  &:focus .step-label,\n  &:focus-visible .step-label,\n  &:active .step-label {\n    outline: none;\n    box-shadow: none;\n  }\n\n  &:disabled {\n    opacity: 0.45;\n    cursor: not-allowed;\n    pointer-events: auto;\n  }\n}\n\n.journey-step.active {\n  color: #5ea1d8;\n  .step-label {\n    border-color: #5ea1d8;\n    background: rgba(94, 161, 216, 0.1);\n    color: #5ea1d8;\n  }\n}\n\n.journey-step.complete {\n  color: #16a34a;\n  .step-label {\n    border-color: #16a34a;\n    background: rgba(22, 163, 74, 0.1);\n    color: #16a34a;\n  }\n}\n\n.step-indicator {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  border: 2px solid currentColor;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  font-size: 14px;\n  flex-shrink: 0;\n  mat-icon {\n    font-size: 20px;\n  }\n}\n\n.step-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  line-height: 1.2;\n  white-space: nowrap;\n  font-size: 13px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  padding: 8px 16px;\n  border-radius: 35px;\n  border: 2px solid currentColor;\n  background: transparent;\n  flex-shrink: 0;\n}\n\n.step-label .step-count,\n.step-label .label-text {\n  display: inline-flex;\n  align-items: center;\n  white-space: nowrap;\n}\n\n/* Dark mode pass for create-bundle */\n:host-context(body.theme-dark) {\n  .upload-dialog {\n    background: #0f172a !important;\n    color: #e5e7eb !important;\n  }\n\n  .upload-header,\n  .upload-body,\n  .section-card,\n  .journey-card,\n  .secondary-pane,\n  .primary-pane {\n    background: #111827 !important;\n    color: #e5e7eb !important;\n    border-color: rgba(148, 163, 184, 0.25) !important;\n  }\n\n  // Stage banner blends with dialog â€” no separate card appearance\n  .stage-banner {\n    background: transparent !important;\n    border-bottom-color: rgba(148, 163, 184, 0.18) !important;\n  }\n\n  .header-copy p,\n  .header-copy p span,\n  .header-copy .desktop-title,\n  .header-copy .mobile-title,\n  .journey-pane-header h5,\n  .stage-title-row {\n    color: #f8fafc !important;\n  }\n\n  .header-description,\n  .journey-pane-header p {\n    color: #cbd5e1 !important;\n  }\n\n  .icon-circle,\n  .icon-button {\n    background: #1f2937 !important;\n    color: #e5e7eb !important;\n  }\n\n  .icon-button:hover {\n    background: #334155 !important;\n  }\n\n  // Step connector â€” dimmed line between pills (matches create-flow)\n  .upload-dialog .step-connector,\n  .step-connector {\n    background: rgba(148, 163, 184, 0.2) !important;\n  }\n\n  .upload-dialog .step-connector.fill,\n  .step-connector.fill {\n    background: #16a34a !important;\n  }\n\n  // All journey-step buttons: never show a surface bg\n  .upload-dialog .journey-step,\n  .journey-step {\n    background: transparent !important;\n    box-shadow: none !important;\n  }\n\n  // Inactive step pill â€” muted (matches create-flow #64748b)\n  .upload-dialog .journey-step:not(.active):not(.complete),\n  .journey-step:not(.active):not(.complete) {\n    color: #64748b !important;\n\n    .step-label {\n      border-color: #64748b !important;\n      background: transparent !important;\n      color: #64748b !important;\n    }\n\n    .step-count,\n    .label-text {\n      color: #64748b !important;\n    }\n  }\n\n  // Active step pill â€” blue tint (matches create-flow)\n  .upload-dialog .journey-step.active,\n  .journey-step.active {\n    color: #5ea1d8 !important;\n\n    .step-label {\n      background: rgba(94, 161, 216, 0.15) !important;\n      color: #93c5fd !important;\n      border-color: #5ea1d8 !important;\n    }\n\n    .step-count,\n    .label-text {\n      color: #93c5fd !important;\n    }\n  }\n\n  // Complete step pill â€” green tint (matches create-flow)\n  .upload-dialog .journey-step.complete,\n  .journey-step.complete {\n    color: #4ade80 !important;\n\n    .step-label {\n      background: rgba(22, 163, 74, 0.15) !important;\n      color: #4ade80 !important;\n      border-color: #16a34a !important;\n    }\n\n    .step-count,\n    .label-text,\n    .label-check {\n      color: #4ade80 !important;\n    }\n  }\n\n  ::ng-deep .mat-mdc-form-field .mdc-text-field--outlined,\n  ::ng-deep .mat-mdc-select-value,\n  ::ng-deep .mat-mdc-input-element,\n  textarea,\n  input,\n  select {\n    color: #e5e7eb !important;\n  }\n\n  ::ng-deep .mat-mdc-form-field .mdc-notched-outline__leading,\n  ::ng-deep .mat-mdc-form-field .mdc-notched-outline__notch,\n  ::ng-deep .mat-mdc-form-field .mdc-notched-outline__trailing {\n    border-color: rgba(148, 163, 184, 0.4) !important;\n  }\n\n  /* Ensure readable text across all create-bundle panels */\n  .upload-dialog h1,\n  .upload-dialog h2,\n  .upload-dialog h3,\n  .upload-dialog h4,\n  .upload-dialog h5,\n  .upload-dialog h6,\n  .upload-dialog p,\n  .upload-dialog span,\n  .upload-dialog label,\n  .upload-dialog li,\n  .upload-dialog small,\n  .upload-dialog .mat-mdc-form-field-hint,\n  .upload-dialog .mat-mdc-form-field-error,\n  .upload-dialog .mdc-floating-label {\n    color: #e5e7eb !important;\n  }\n\n  /* Rephrase / AI action links â€” keep hyperlink appearance in dark mode */\n  .upload-dialog .clickable-text {\n    color: #5ea1d8 !important;\n    text-decoration: underline !important;\n    cursor: pointer;\n\n    &:hover {\n      color: #93c5fd !important;\n    }\n\n    .material-icons {\n      color: inherit !important;\n    }\n  }\n\n  /* Remove unnecessary panel backgrounds in dark mode */\n  .upload-body,\n  .primary-pane,\n  .secondary-pane,\n  .journey-content,\n  .cover-form-wrapper,\n  .section-card,\n  .journey-card,\n  .summary-card,\n  .preview-card,\n  .mobile-section,\n  .main-content {\n    background: transparent !important;\n    box-shadow: none !important;\n  }\n\n  /* Force white readable text across create bundle views */\n  .upload-dialog,\n  .upload-dialog .video-title,\n  .upload-dialog .video-title-sticky,\n  .upload-dialog .mobile-section-title,\n  .upload-dialog .mobile-section-description,\n  .upload-dialog .flow-card-title,\n  .upload-dialog .flow-creator-name,\n  .upload-dialog .channel-name,\n  .upload-dialog .channel-meta,\n  .upload-dialog .document-name,\n  .upload-dialog .link-name,\n  .upload-dialog [style*=\"color: #333\"],\n  .upload-dialog [style*=\"color:#333\"],\n  .upload-dialog [style*=\"color: #666\"],\n  .upload-dialog [style*=\"color:#666\"] {\n    color: #ffffff !important;\n  }\n\n  /* Remove leftover white backgrounds in dark mode */\n  .upload-dialog [style*=\"background: #fff\"],\n  .upload-dialog [style*=\"background:#fff\"],\n  .upload-dialog [style*=\"background: #ffffff\"],\n  .upload-dialog [style*=\"background:#ffffff\"],\n  .upload-dialog [style*=\"background-color: #fff\"],\n  .upload-dialog [style*=\"background-color:#fff\"],\n  .upload-dialog [style*=\"background-color: #ffffff\"],\n  .upload-dialog [style*=\"background-color:#ffffff\"] {\n    background: transparent !important;\n    background-color: transparent !important;\n  }\n\n  ::ng-deep .mat-mdc-form-field .mdc-text-field--outlined,\n  ::ng-deep .mat-mdc-form-field-focus-overlay {\n    background: transparent !important;\n  }\n\n  /* Fix white UI surfaces: textarea, cover image containers, buttons */\n  textarea,\n  input,\n  .mat-mdc-input-element,\n  .mat-mdc-text-field-wrapper,\n  .mdc-text-field,\n  .mdc-text-field--outlined,\n  .mdc-text-field--filled {\n    background: #111827 !important;\n    color: #ffffff !important;\n  }\n\n  .cover-upload-placeholder,\n  .cover-preview,\n  .table-inner,\n  .img-and-video-sec,\n  .step-preview,\n  .pending-image-preview {\n    background: #111827 !important;\n  }\n\n  button:not(.btn-primary):not(.footer-btn):not(.add-flows-header-btn):not(.category-action-btn):not(.access-restore-btn),\n  .btn:not(.btn-primary),\n  .btn-secondary,\n  .square_btn,\n  .upload-icon-btn,\n  .action-item,\n  .icon-button {\n    background-color: #1f2937 !important;\n    color: #ffffff !important;\n    border-color: rgba(148, 163, 184, 0.35) !important;\n  }\n\n  .btn-primary,\n  .footer-btn.primary,\n  .add-flows-header-btn,\n  .category-action-btn {\n    background-color: #5ea1d8 !important;\n    color: #ffffff !important;\n    border-color: #5ea1d8 !important;\n  }\n\n  /* Description area dark-mode fix */\n  .description-section,\n  .description-content,\n  .summary-description,\n  .step-description,\n  .cover-details-display,\n  .quill-wrapper,\n  .quill-field,\n  ::ng-deep .ql-container,\n  ::ng-deep .ql-toolbar,\n  ::ng-deep .ql-editor {\n    background: #111827 !important;\n    color: #ffffff !important;\n    border-color: rgba(148, 163, 184, 0.35) !important;\n  }\n\n  ::ng-deep .ql-editor.ql-blank::before {\n    color: #94a3b8 !important;\n  }\n\n  /* Footer dark-mode fix */\n  .upload-footer,\n  .quick-create-footer,\n  .mobile-footer,\n  .add-flows-popup-footer {\n    background: #111827 !important;\n    border-top-color: rgba(148, 163, 184, 0.28) !important;\n  }\n\n  /* Hardening: no white surfaces on any tab/panel content */\n  .upload-dialog .mat-mdc-tab-group,\n  .upload-dialog .mat-mdc-tab-header,\n  .upload-dialog .mat-mdc-tab-body-wrapper,\n  .upload-dialog .mat-mdc-tab-body,\n  .upload-dialog .mat-mdc-tab-body-content,\n  .upload-dialog [role=\"tabpanel\"],\n  .upload-dialog .journey-content,\n  .upload-dialog .quick-create-body {\n    background: #111827 !important;\n    color: #ffffff !important;\n  }\n\n  .upload-dialog *[style*=\"background: white\"],\n  .upload-dialog *[style*=\"background:white\"],\n  .upload-dialog *[style*=\"background-color: white\"],\n  .upload-dialog *[style*=\"background-color:white\"],\n  .upload-dialog *[style*=\"background: #fff\"],\n  .upload-dialog *[style*=\"background:#fff\"],\n  .upload-dialog *[style*=\"background: #ffffff\"],\n  .upload-dialog *[style*=\"background:#ffffff\"],\n  .upload-dialog *[style*=\"background-color: #fff\"],\n  .upload-dialog *[style*=\"background-color:#fff\"],\n  .upload-dialog *[style*=\"background-color: #ffffff\"],\n  .upload-dialog *[style*=\"background-color:#ffffff\"] {\n    background: #111827 !important;\n    background-color: #111827 !important;\n    color: #ffffff !important;\n  }\n\n  /* Explicit tab fixes: Flows/Items(Steps-like)/Summary */\n  .upload-dialog .journey-content,\n  .upload-dialog .bundle-flows-grid,\n  .upload-dialog .bundle-flow-card,\n  .upload-dialog .flow-card-info,\n  .upload-dialog .flow-card-meta,\n  .upload-dialog .preview-card,\n  .upload-dialog .summary-card,\n  .upload-dialog .mobile-section,\n  .upload-dialog .mobile-section-body,\n  .upload-dialog .flow-main-grid,\n  .upload-dialog .flow-main-content,\n  .upload-dialog .flow-sidebar.summary-preview-sidebar,\n  .upload-dialog .step-navigation,\n  .upload-dialog .step-panel-body {\n    background: #111827 !important;\n    color: #ffffff !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n  }\n}\n\n.step-label.complete {\n  border-color: #16a34a;\n  color: #16a34a;\n  background: rgba(22, 163, 74, 0.1);\n}\n\n.step-label .label-check {\n  font-size: 18px;\n  width: 18px;\n  height: 18px;\n}\n\n.step-label.complete .label-check {\n  font-size: 18px;\n  margin-left: 0.15rem;\n}\n\n.step-connector {\n  flex: 1;\n  min-width: 20px;\n  height: 2px;\n  background: #e5e7eb;\n  flex-shrink: 0;\n  align-self: center;\n  margin: 0;\n  position: relative;\n  z-index: 0;\n  top: -10px;\n}\n\n.step-connector.fill {\n  background: #16a34a;\n}\n\n.upload-body {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 24px;\n  padding: 10px;\n  background: #fdfdff;\n  overflow-y: auto;\n  overflow-x: hidden;\n  min-height: 0;\n  flex: 1 1 auto;\n\n  &::-webkit-scrollbar {\n    width: 8px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: #f1f1f1;\n    border-radius: 4px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: #c1c1c1;\n    border-radius: 4px;\n\n    &:hover {\n      background: #a8a8a8;\n    }\n  }\n}\n\n.upload-footer {\n  padding: 20px 32px;\n  border-top: 1px solid #e4e8f0;\n  background: #fff;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n  align-items: center;\n  justify-content: space-between;\n  box-shadow: 0 -6px 18px rgba(15, 23, 42, 0.05);\n  flex-shrink: 0;\n\n  .footer-step {\n    flex: 1 1 220px;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n  }\n}\n\n.footer-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  justify-content: flex-end;\n  flex: 2 1 320px;\n  align-items: center;\n}\n\n/* Disabled buttons swallow hover, so the tooltip with the reason lives on this wrapper */\n.take-public-group {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.take-public-wrap,\n.publish-wrap {\n  display: inline-flex;\n}\n\n.take-public-info {\n  flex: 0 0 auto;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  border: none;\n  border-radius: 50%;\n  background: transparent;\n  color: #6b7280;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n\n  mat-icon {\n    font-size: 20px;\n    width: 20px;\n    height: 20px;\n    line-height: 20px;\n  }\n\n  &:hover,\n  &:focus-visible {\n    color: #5ea1d8;\n    background: rgba(94, 161, 216, 0.1);\n  }\n}\n\n.footer-btn {\n  border-radius: 8px;\n  border: 1px solid transparent;\n  padding: 10px 20px;\n  font-size: 14px;\n  font-weight: 500;\n  letter-spacing: 0;\n  text-transform: none;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  min-height: 44px;\n  margin: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  white-space: nowrap;\n  box-sizing: border-box;\n\n  &.primary {\n    background: #5ea1d8;\n    color: #fff;\n    border-color: #5ea1d8;\n\n    &:hover:not(:disabled) {\n      background: #4c8ec2;\n    }\n  }\n\n  &.secondary {\n    background: #f4f6fb;\n    color: #1f2937;\n    border-color: #d1d5db;\n\n    &:hover:not(:disabled) {\n      background: #e8edf5;\n    }\n  }\n\n  &.ghost {\n    background: transparent;\n    color: #5ea1d8;\n    border-color: #5ea1d8;\n\n    &:hover:not(:disabled) {\n      background: rgba(94, 161, 216, 0.08);\n    }\n  }\n\n  &.danger {\n    color: #b42318;\n    border-color: #fda29b;\n\n    &:hover:not(:disabled) {\n      background: #fef3f2;\n    }\n  }\n\n  &:disabled {\n    opacity: 0.45;\n    cursor: not-allowed;\n  }\n}\n\n.approval-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  align-self: center;\n  max-width: 260px;\n  padding: 6px 12px;\n  border-radius: 999px;\n  background: #eef6fc;\n  color: #1565c0;\n  font-size: 12px;\n  font-weight: 600;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n\n  mat-icon {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n  }\n\n  &[data-state=\"InReview\"] {\n    background: #fff4e5;\n    color: #b54708;\n  }\n\n  &[data-state=\"Approved\"],\n  &[data-state=\"Published\"] {\n    background: #e8f7ee;\n    color: #067647;\n  }\n\n  &[data-state=\"Rejected\"] {\n    background: #fdecec;\n    color: #b42318;\n  }\n}\n\n:host-context(body.theme-dark) {\n  .approval-pill {\n    background: #1a2c3d;\n    color: #7ec8f0;\n\n    &[data-state=\"InReview\"] {\n      background: rgba(181, 71, 8, 0.2);\n      color: #fdba74;\n    }\n\n    &[data-state=\"Approved\"],\n    &[data-state=\"Published\"] {\n      background: rgba(18, 183, 106, 0.16);\n      color: #75e0a7;\n    }\n\n    &[data-state=\"Rejected\"] {\n      background: rgba(240, 68, 56, 0.16);\n      color: #fda29b;\n    }\n  }\n\n  .footer-btn.danger {\n    color: #fda29b;\n    border-color: rgba(240, 68, 56, 0.4);\n  }\n}\n\n.primary-pane {\n  flex: 2 1 640px;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  min-height: 0;\n  max-height: 100%;\n  overflow: hidden;\n\n  &.full-width {\n    flex: 1 1 100%;\n    max-width: 100%;\n  }\n\n  &.access-primary-pane {\n    flex: 3.2 1 0;\n    min-width: 0;\n    max-width: none;\n  }\n}\n\n.secondary-pane {\n  flex: 1 1 320px;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n\n  &.access-secondary-pane {\n    flex: 0 0 280px;\n    max-width: 300px;\n  }\n}\n\n.section-card {\n  background: #fff;\n  border-radius: 18px;\n  border: 1px solid #e4e8f0;\n\n  &.full-screen-summary {\n    border-radius: 0;\n    border: none;\n    background: transparent;\n    padding: 0;\n    box-shadow: none;\n  }\n  padding: 24px;\n  box-shadow: 0 20px 45px rgba(15, 23, 42, 0.08);\n\n  &.journey-card {\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    min-height: 0;\n    max-height: 100%;\n    overflow: hidden;\n  }\n}\n\n.journey-content {\n  padding: 24px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  flex: 1 1 0;\n  min-height: 0;\n  max-height: 100%;\n\n  &::-webkit-scrollbar {\n    width: 8px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: #f1f1f1;\n    border-radius: 4px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: #c1c1c1;\n    border-radius: 4px;\n\n    &:hover {\n      background: #a8a8a8;\n    }\n  }\n}\n\n.cover-form-wrapper {\n  background: #fff;\n  border-radius: 0;\n  padding: 0;\n  max-width: 100%;\n\n  h3 {\n    font-size: 14px;\n    font-weight: 400;\n    color: #030303;\n    margin: 0 0 8px 0;\n    padding: 0;\n    border: none;\n    text-transform: none;\n    letter-spacing: 0;\n    line-height: 20px;\n  }\n\n  .example-form {\n    margin-bottom: 0;\n    margin-top: 0;\n\n    &.field-anchor {\n      margin-left: 0;\n      margin-right: 0;\n    }\n\n    // First form in the wrapper should not have top margin\n    &:first-child {\n      mat-form-field {\n        margin-top: 0;\n      }\n\n      .form-label-wrapper {\n        margin-top: 0;\n      }\n    }\n  }\n\n  .form-label-wrapper {\n    margin-top: 20px;\n    margin-bottom: 10px;\n    padding: 0;\n    margin-left: 0;\n    margin-right: 0;\n\n    .form-label {\n      font-size: 16px;\n      font-weight: 500;\n      color: #000000;\n      display: block;\n      margin-bottom: 0;\n\n      &.font16 {\n        font-size: 16px;\n      }\n    }\n  }\n\n  mat-form-field {\n    width: 100%;\n    margin-top: 20px;\n    margin-bottom: 10px;\n\n    ::ng-deep {\n      // Make input boxes rounded on all corners\n      .mdc-notched-outline {\n        border-radius: 8px;\n      }\n\n      .mdc-notched-outline__leading {\n        border-radius: 8px 0 0 8px;\n      }\n\n      .mdc-notched-outline__trailing {\n        border-radius: 0 8px 8px 0;\n      }\n\n      .mat-mdc-text-field-input-wrapper {\n        border-radius: 8px;\n      }\n\n      input.mat-mdc-input-element,\n      input[matInput] {\n        border-radius: 8px;\n      }\n\n      mat-label {\n        color: #000000;\n        font-size: 16px;\n        font-weight: 500;\n      }\n    }\n  }\n\n  .title-field-container {\n    position: relative;\n    width: 100%;\n    margin-bottom: 0;\n    margin-top: 0;\n\n    .title-field-with-rephrase {\n      margin-top: 0 !important;\n      margin-bottom: 0 !important;\n\n      ::ng-deep {\n        .mat-mdc-form-field-subscript-wrapper {\n          margin-top: 0;\n          padding-bottom: 0;\n          min-height: auto;\n          display: flex;\n          flex-direction: column;\n          align-items: flex-end;\n        }\n\n        .mat-mdc-form-field-hint-wrapper {\n          margin-top: 0;\n          padding-bottom: 0;\n          order: 1;\n          width: 100%;\n          display: flex;\n          justify-content: flex-end;\n        }\n\n        .mat-mdc-form-field-hint {\n          text-align: right;\n          width: auto;\n          margin: 0;\n        }\n\n        .mat-mdc-form-field-hint-spacer {\n          display: none;\n        }\n      }\n    }\n\n    .title-rephrase-wrapper-inline {\n      margin-top: 4px;\n      margin-bottom: 0;\n      padding: 0;\n      padding-left: 0;\n      padding-right: 0;\n      display: flex;\n      flex-direction: column;\n      align-items: flex-end;\n      gap: 4px;\n      width: 100%;\n\n      .title-rephrase-progress {\n        margin-bottom: 0;\n        width: 200px;\n      }\n\n      .title-rephrase-buttons {\n        display: flex;\n        gap: 16px;\n        align-items: center;\n        justify-content: flex-end;\n        flex-wrap: wrap;\n\n        .clickable-text {\n          display: inline-flex;\n          align-items: center;\n          gap: 6px;\n          color: #065fd4;\n          font-size: 14px;\n          cursor: pointer;\n          font-weight: 500;\n          transition: color 0.2s;\n          margin-right: 13px;\n\n          &:hover {\n            color: #0d47a1;\n          }\n\n          .material-icons {\n            font-size: 18px;\n          }\n        }\n      }\n    }\n  }\n\n  .commonlintbtn-wrapper {\n    margin-top: 8px;\n    margin-bottom: 24px;\n\n    .commonlintbtn-parent {\n      display: flex;\n      gap: 16px;\n      align-items: center;\n      justify-content: flex-end;\n\n      .clickable-text {\n        display: inline-flex;\n        align-items: center;\n        gap: 6px;\n        color: #065fd4;\n        font-size: 14px;\n        cursor: pointer;\n        font-weight: 500;\n        transition: color 0.2s;\n        margin-right: 13px;\n\n        &:hover {\n          color: #0d47a1;\n        }\n\n        .material-icons {\n          font-size: 18px;\n        }\n      }\n    }\n  }\n\n  .upload-icon-row {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 16px;\n    margin-top: 20px;\n    margin-bottom: 10px;\n    flex-wrap: nowrap;\n    width: 100%;\n\n    .upload-icon-stack {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: center;\n      gap: 4px;\n      flex-shrink: 0;\n    }\n\n    .form-label-wrapper {\n      margin-top: 0;\n      margin-bottom: 0;\n      padding: 0;\n      flex-shrink: 0;\n      text-align: center;\n\n      .required-hint {\n        display: block;\n        font-size: 11px;\n        color: #b45309;\n        margin-top: 2px;\n      }\n    }\n\n    .upload-icon-btn {\n      margin-top: 0;\n      flex-shrink: 0;\n    }\n\n    .flow-upload-progress {\n      flex: 1;\n      min-width: 0;\n      flex-shrink: 1;\n    }\n\n    .media-size-recommendation {\n      flex: 1;\n      min-width: 0;\n      margin-top: 0;\n      padding: 12px;\n      background-color: #f0f7ff;\n      border-radius: 6px;\n      border-left: 3px solid #1d67a3;\n      box-sizing: border-box;\n\n      &__inner {\n        display: flex;\n        align-items: flex-start;\n        gap: 8px;\n      }\n\n      &__icon {\n        color: #1d67a3;\n        font-size: 20px;\n        width: 20px;\n        height: 20px;\n        flex-shrink: 0;\n        margin-top: 2px;\n      }\n\n      &__body {\n        flex: 1;\n        min-width: 0;\n      }\n\n      &__title {\n        color: #1d67a3;\n        font-size: 13px;\n        display: block;\n        margin-bottom: 4px;\n        font-weight: 600;\n      }\n\n      &__lines {\n        font-size: 12px;\n        color: #333;\n        line-height: 1.6;\n\n        div {\n          margin-bottom: 4px;\n\n          &:last-child {\n            margin-bottom: 0;\n          }\n        }\n      }\n    }\n\n    @media (max-width: 767px) {\n      gap: 12px;\n      align-items: flex-start;\n\n      .form-label-wrapper {\n        min-width: 0;\n      }\n    }\n  }\n\n  .upload-label-inline {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 12px;\n    margin-top: 0;\n    margin-bottom: 0;\n    padding: 0;\n    flex-wrap: nowrap;\n\n    label,\n    .form-label {\n      margin-top: 0;\n      margin-bottom: 0;\n      color: #000000;\n      font-size: 16px;\n      font-weight: 500;\n      white-space: nowrap;\n    }\n\n    .upload-icon-btn {\n      margin: 0;\n      flex-shrink: 0;\n    }\n  }\n\n  .form-label-wrapper.upload-label-inline {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 12px;\n    margin-top: 0;\n    margin-bottom: 0;\n    padding: 0;\n\n    label,\n    .form-label {\n      margin: 0;\n      white-space: nowrap;\n      color: #000000;\n      font-size: 16px;\n      font-weight: 500;\n    }\n\n    .upload-icon-btn {\n      margin: 0;\n    }\n  }\n\n  .upload-progress-inline {\n    font-size: 13px;\n    color: #64748b;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    progress {\n      width: 120px;\n      height: 6px;\n    }\n  }\n\n  // Flow-style upload progress\n  .flow-upload-progress {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 8px 0;\n    min-width: 200px;\n\n    .flow-progress-bar-container {\n      flex: 1;\n      height: 4px;\n      background-color: rgba(0, 0, 0, 0.1);\n      border-radius: 2px;\n      overflow: hidden;\n      position: relative;\n      min-width: 120px;\n      max-width: 300px;\n\n      .flow-progress-bar {\n        height: 100%;\n        background: linear-gradient(90deg, #065fd4 0%, #0d96ff 100%);\n        border-radius: 2px;\n        transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n        position: relative;\n        overflow: hidden;\n\n        &::after {\n          content: \"\";\n          position: absolute;\n          top: 0;\n          left: 0;\n          bottom: 0;\n          right: 0;\n          background: linear-gradient(\n            90deg,\n            transparent,\n            rgba(255, 255, 255, 0.3),\n            transparent\n          );\n          animation: shimmer 1.5s infinite;\n        }\n      }\n    }\n\n    .flow-progress-text {\n      font-size: 12px;\n      font-weight: 500;\n      color: #065fd4;\n      min-width: 40px;\n      text-align: right;\n      font-family: \"Roboto\", sans-serif;\n    }\n  }\n\n  @keyframes shimmer {\n    0% {\n      transform: translateX(-100%);\n    }\n    100% {\n      transform: translateX(100%);\n    }\n  }\n\n  .upload-icon-btn {\n    width: 56px;\n    height: 56px;\n    border-radius: 20px;\n    background: #e0f2fe;\n    color: #0369a1;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    position: relative;\n    transition: transform 0.2s, box-shadow 0.2s;\n    box-shadow: inset 0 0 0 1px rgba(3, 105, 161, 0.1);\n\n    &.light {\n      background: #f8fafc;\n      color: #475569;\n      box-shadow: inset 0 0 0 1px rgba(15, 23, 42, 0.08);\n    }\n\n    &:hover {\n      transform: translateY(-2px);\n      box-shadow: 0 10px 20px rgba(3, 105, 161, 0.15);\n    }\n\n    mat-icon {\n      font-size: 28px;\n      width: 28px;\n      height: 28px;\n    }\n\n    input {\n      position: absolute;\n      inset: 0;\n      opacity: 0;\n      cursor: pointer;\n    }\n  }\n\n  .table-wrapper {\n    margin-bottom: 24px;\n\n    .table-inner {\n      border: 1px solid #e0e0e0;\n      border-radius: 4px;\n      background: #f9f9f9;\n      min-height: 200px;\n      max-height: 400px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      position: relative;\n      overflow: hidden;\n\n      img.img-display {\n        max-width: 100%;\n        max-height: 100%;\n        object-fit: contain;\n      }\n\n      video.video-display {\n        width: 100%;\n        height: 100%;\n        max-height: 400px;\n        object-fit: contain;\n      }\n\n      p.text-center {\n        color: #606060;\n        font-size: 13px;\n        text-align: center;\n        padding: 20px;\n        margin: 0;\n      }\n    }\n  }\n\n  .quill-field {\n    width: 100%;\n    margin-bottom: 0;\n\n    &.field-anchor {\n      margin-left: 0;\n      margin-right: 0;\n    }\n  }\n\n  .quill-label {\n    display: block;\n    color: #000000;\n    font-size: 16px;\n    font-weight: 500;\n    margin-top: 20px;\n    margin-bottom: 10px;\n    padding: 0;\n    line-height: 1.5;\n  }\n\n  .quill-wrapper {\n    margin: 10px 0px;\n    border: 1px solid #dadce0;\n    border-radius: 8px;\n    background: #fff;\n    overflow: hidden;\n    transition: border-color 0.2s, box-shadow 0.2s;\n\n    &:focus-within {\n      border-color: #1a73e8;\n      box-shadow: 0 0 0 1px #1a73e8;\n    }\n\n    &:hover:not(:focus-within) {\n      border-color: #80868b;\n    }\n\n    ::ng-deep .ql-toolbar {\n      border: none;\n      border-bottom: 1px solid #e0e0e0;\n      background: #fff;\n      padding: 10px 12px;\n    }\n\n    ::ng-deep .ql-container {\n      border: none !important;\n      font-size: 14px;\n      min-height: 220px;\n      background: #fff;\n      font-family: \"Roboto\", \"Helvetica Neue\", sans-serif;\n    }\n\n    ::ng-deep .ql-editor {\n      min-height: 220px;\n      font-size: 14px;\n      color: #030303;\n      line-height: 20px;\n      padding: 16px;\n    }\n\n    ::ng-deep .ql-editor.ql-blank::before {\n      color: #80868b;\n      font-style: normal;\n      font-size: 14px;\n    }\n  }\n}\n\n.field-anchor {\n  position: relative;\n  transition: box-shadow 0.25s ease, border-color 0.25s ease;\n  border-radius: 16px;\n}\n\n// Flow-style layout for summary\n.flow-layout-container {\n  width: 100%;\n  padding: 0;\n  margin: 0;\n\n  .flow-main-grid {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) 402px;\n    gap: 24px;\n    max-width: 100%;\n    margin: 0;\n    padding: 16px 24px;\n\n    @media (min-width: 1920px) {\n      max-width: 1920px;\n      margin: 0 auto;\n      padding: 24px 48px;\n    }\n\n    @media (max-width: 1024px) {\n      grid-template-columns: 1fr;\n      gap: 16px;\n      padding: 16px;\n    }\n\n    @media (max-width: 768px) {\n      padding: 12px;\n      gap: 12px;\n    }\n  }\n}\n\n.flow-main-content {\n  min-width: 0;\n\n  .flow-title-sticky {\n    background: #ffffff;\n    border-bottom: 1px solid #e0e0e0;\n    padding: 16px 0 8px 0;\n    margin-bottom: 8px;\n    box-shadow: 0 1px 0 rgba(0, 0, 0, 0.04);\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex-wrap: wrap;\n    justify-content: space-between;\n\n    .video-title-sticky {\n      font-size: 20px;\n      font-weight: 600;\n      line-height: 1.3;\n      color: #0f0f0f;\n      margin: 4px;\n      font-family: \"Raleway\", sans-serif;\n      flex: 1;\n      min-width: 0;\n    }\n  }\n\n  .video-player-section {\n    background: #000;\n    border-radius: 12px;\n    overflow: hidden;\n    margin-bottom: 16px;\n    position: relative;\n\n    .img-wrap {\n      width: 100%;\n      position: relative;\n      padding-bottom: 56.25%;\n      height: 0;\n      overflow: hidden;\n      background: #000;\n\n      img,\n      video {\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        object-fit: contain;\n        background: #000;\n      }\n\n      .main-video-player {\n        width: 100%;\n        height: 100%;\n        position: absolute;\n        top: 0;\n        left: 0;\n        object-fit: contain;\n        background: #000;\n      }\n    }\n  }\n\n  .video-metadata {\n    padding: 16px 0;\n    border-bottom: 1px solid #e0e0e0;\n    margin-bottom: 16px;\n\n    .step-header {\n      display: flex;\n      align-items: flex-start;\n      gap: 16px;\n      margin-bottom: 12px;\n      flex-wrap: wrap;\n      justify-content: space-between;\n\n      .step-header-main {\n        display: flex;\n        align-items: center;\n        gap: 12px;\n        flex: 1;\n        min-width: 0;\n      }\n\n      .video-title {\n        font-size: 20px;\n        font-weight: 500;\n        line-height: 28px;\n        color: #0f0f0f;\n        margin: 0;\n        flex: 1;\n        min-width: 0;\n      }\n    }\n\n    .video-actions-bar {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      overflow-x: auto;\n      overflow-y: hidden;\n\n      &::-webkit-scrollbar {\n        height: 6px;\n      }\n\n      &::-webkit-scrollbar-thumb {\n        background: rgba(0, 0, 0, 0.2);\n        border-radius: 4px;\n      }\n\n      .action-buttons {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        flex-wrap: nowrap;\n        width: max-content;\n\n        .action-item {\n          display: flex;\n          align-items: center;\n          gap: 8px;\n          padding: 8px 16px;\n          border-radius: 18px;\n          cursor: pointer;\n          transition: background 0.2s;\n          background: #f2f2f2;\n          flex: 0 0 auto;\n\n          &:hover:not(.disabled) {\n            background: #e5e5e5;\n          }\n\n          mat-icon {\n            font-size: 18px;\n          }\n        }\n      }\n    }\n  }\n\n  .channel-info-section {\n    padding: 16px 0;\n    border-bottom: 1px solid #e0e0e0;\n    margin-bottom: 16px;\n\n    .channel-header {\n      display: flex;\n      align-items: center;\n      gap: 16px;\n\n      .channel-avatar {\n        flex-shrink: 0;\n\n        img {\n          width: 48px;\n          height: 48px;\n          border-radius: 50%;\n          object-fit: cover;\n          cursor: pointer;\n        }\n\n        .material-icons {\n          font-size: 48px;\n          width: 48px;\n          height: 48px;\n          color: #606060;\n          cursor: pointer;\n        }\n      }\n\n      .channel-details {\n        flex: 1;\n        min-width: 0;\n\n        .channel-name {\n          font-size: 16px;\n          font-weight: 500;\n          color: #0f0f0f;\n          cursor: pointer;\n          margin-bottom: 4px;\n\n          &:hover {\n            color: #606060;\n          }\n        }\n\n        .channel-meta {\n          display: flex;\n          align-items: center;\n          gap: 8px;\n          flex-wrap: wrap;\n          font-size: 14px;\n          color: #606060;\n\n          .price-tag {\n            font-weight: 600;\n            color: #d32f2f;\n            cursor: pointer;\n          }\n        }\n      }\n\n      .channel-actions {\n        display: flex;\n        flex-wrap: wrap;\n        gap: 12px;\n\n        .follow-btn,\n        .purchase-btn {\n          border-radius: 999px;\n          padding: 6px 16px;\n          font-size: 14px;\n          font-weight: 500;\n          border: none;\n          cursor: pointer;\n        }\n\n        .follow-btn {\n          background: #5ea1d8;\n          color: #fff;\n        }\n\n        .purchase-btn {\n          background: #111827;\n          color: #fff;\n        }\n      }\n    }\n  }\n\n  .description-section {\n    padding: 16px;\n    background: #f9f9f9;\n    border-radius: 12px;\n    margin-bottom: 16px;\n\n    .description-header {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      margin-bottom: -16px !important;\n\n      h3 {\n        font-size: 16px;\n        font-weight: 500;\n        color: #0f0f0f;\n        margin: 0;\n      }\n    }\n\n    .description-content {\n      font-size: 14px;\n      line-height: 20px;\n      color: #0f0f0f;\n      max-height: 60px;\n      overflow: hidden;\n      transition: max-height 0.3s ease;\n\n      &.expanded {\n        max-height: none;\n      }\n\n      .supporting-docs-link {\n        margin-top: 12px;\n\n        a {\n          color: #5ea1d8;\n          text-decoration: none;\n          font-weight: 500;\n\n          &:hover {\n            text-decoration: underline;\n          }\n        }\n      }\n    }\n\n    .expand-description-btn {\n      margin-top: 8px;\n      background: none;\n      border: none;\n      color: #606060;\n      font-size: 14px;\n      font-weight: 500;\n      cursor: pointer;\n      padding: 0;\n\n      &:hover {\n        color: #0f0f0f;\n      }\n    }\n  }\n}\n\n.flow-sidebar {\n  width: 402px;\n  min-width: 402px;\n  max-width: 402px;\n  position: relative;\n  z-index: 10;\n  overflow-x: hidden;\n  display: flex;\n  flex-direction: column;\n\n  @media (max-width: 1024px) {\n    width: 100%;\n    min-width: 100%;\n    max-width: 100%;\n  }\n\n  &.summary-preview-sidebar {\n    position: sticky;\n    top: 24px;\n    height: fit-content;\n  }\n\n  .step-navigation {\n    margin-bottom: 24px;\n    flex: 0 0 auto;\n    min-height: 0;\n\n    .step-scroll {\n      max-height: 320px;\n      overflow: hidden;\n    }\n\n    .steps-list {\n      display: flex;\n      flex-direction: column;\n      gap: 12px;\n    }\n\n    .step-btn {\n      border: none;\n      background: rgba(240, 240, 240, 0.8);\n      padding: 10px 16px;\n      border-radius: 6px !important;\n      display: flex;\n      align-items: center;\n      gap: 12px;\n      cursor: pointer;\n\n      &.active {\n        background: #5ea1d8;\n        color: #fff;\n      }\n\n      .step-icon {\n        font-size: 14px;\n        line-height: 1;\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n      }\n\n      .step-number {\n        font-weight: 600;\n      }\n\n      .step-title-text {\n        flex: 1;\n        text-align: left;\n      }\n    }\n  }\n\n  .recommendations-section {\n    flex: 0 0 auto;\n    padding-top: 0;\n    border-top: 1px solid #e0e0e0;\n    align-self: flex-start;\n    width: 100%;\n\n    h2 {\n      font-size: 16px;\n      font-weight: 500;\n      color: #0f0f0f;\n      margin-bottom: 16px;\n    }\n\n    .recommendations-list {\n      display: flex;\n      flex-direction: column;\n      gap: 8px;\n      overflow-x: hidden;\n    }\n\n    .recommendation-item {\n      display: flex;\n      gap: 8px;\n      cursor: pointer;\n      padding: 8px;\n      border-radius: 8px;\n      transition: background 0.2s;\n      overflow: hidden;\n\n      &:hover {\n        background: #f9f9f9;\n      }\n\n      .recommendation-thumbnail {\n        flex-shrink: 0;\n        width: 168px;\n        height: 94px;\n        border-radius: 4px;\n        overflow: hidden; \n        background: #000;\n        \n        img,\n        video {\n          width: 100%;\n          height: 100%;\n          object-fit: cover;\n        }\n      }\n\n      .recommendation-info {\n        flex: 1;\n        min-width: 0;\n\n        .recommendation-title {\n          font-size: 14px;\n          font-weight: 500;\n          color: #0f0f0f;\n          margin: 0 0 4px 0;\n          line-height: 20px;\n          white-space: normal;\n          word-break: break-word;\n          overflow: hidden;\n        }\n\n        .recommendation-meta {\n          display: flex;\n          flex-direction: column;\n          gap: 2px;\n          font-size: 12px;\n          color: #606060;\n          flex-wrap: wrap;\n\n          .recommendation-creator {\n            color: #606060;\n          }\n\n          .recommendation-id {\n            color: #909090;\n          }\n        }\n\n        .recommendation-price {\n          display: block;\n          margin-top: 4px;\n          font-size: 14px;\n          font-weight: 500;\n          color: #e83e8c;\n        }\n      }\n    }\n  }\n\n  // Hide recommendations section in sidebar on mobile\n  @media (max-width: 1024px) {\n    .recommendations-section {\n      display: none !important;\n    }\n  }\n}\n\n// Add Flows Popup Styles\n.add-flows-popup-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  z-index: 10050 !important;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n}\n\n.add-flows-popup-dialog {\n  background: #fff;\n  border-radius: 12px;\n  width: 90%;\n  max-width: 1200px;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);\n}\n\n.add-flows-popup-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  border-bottom: 1px solid #e5e7eb;\n\n  h4 {\n    margin: 0;\n    font-size: 20px;\n    font-weight: 600;\n    color: #111827;\n  }\n\n  .icon-button {\n    background: transparent;\n    border: none;\n    cursor: pointer;\n    padding: 8px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 4px;\n    transition: background 0.2s;\n\n    &:hover {\n      background: #f3f4f6;\n    }\n\n    mat-icon {\n      color: #6b7280;\n    }\n  }\n}\n\n.add-flows-popup-body {\n  padding: 24px;\n  flex: 1;\n  overflow-y: auto;\n\n  .flow-search-input {\n    width: 100%;\n    padding: 12px 16px;\n    border: 1px solid #d1d5db;\n    border-radius: 8px;\n    font-size: 16px;\n    margin-bottom: 16px;\n\n    &:focus {\n      outline: none;\n      border-color: #5ea1d8;\n      box-shadow: 0 0 0 3px rgba(94, 161, 216, 0.1);\n    }\n  }\n}\n\n.add-flows-popup-footer {\n  padding: 16px 24px;\n  border-top: 1px solid #e5e7eb;\n  display: flex;\n  justify-content: flex-end;\n\n  .btn {\n    padding: 10px 24px;\n    border-radius: 6px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.2s;\n\n    &.btn-primary {\n      background: #5ea1d8;\n      color: white;\n      border: none;\n\n      &:hover {\n        background: #4a8fc4;\n      }\n    }\n  }\n}\ninput {\n  outline: none !important;\n}\nlabel {\n  color: #212427 !important;\n}\n.label-button {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 0;\n  margin-top: 20px;\n  padding: 0;\n  margin-left: 0;\n  margin-right: 0;\n  background: transparent;\n  border-radius: 0;\n\n  label {\n    margin: 0;\n    color: #000000;\n    font-size: 16px;\n    font-weight: 500;\n  }\n\n  ::ng-deep .mat-mdc-slide-toggle {\n    .mdc-switch__track {\n      background-color: #ccc;\n    }\n\n    &.mat-checked .mdc-switch__track {\n      background-color: #5ea1d8;\n    }\n  }\n}\n\n.creator-paid-only-notice {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n  margin-top: 0.75rem;\n  padding: 0.85rem 1rem;\n  border-radius: 10px;\n  background: rgba(94, 161, 216, 0.1);\n  border: 1px solid rgba(94, 161, 216, 0.28);\n\n  .notice-title-row {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    min-width: 0;\n    max-width: 100%;\n  }\n\n  .notice-icon {\n    display: inline-flex !important;\n    align-items: center;\n    justify-content: center;\n    flex: 0 0 18px;\n    width: 18px !important;\n    height: 18px !important;\n    font-size: 18px !important;\n    line-height: 18px !important;\n    margin: 0 !important;\n    padding: 0 !important;\n    overflow: visible;\n    color: #5ea1d8;\n    transform: translateY(1px);\n  }\n\n  .notice-lead {\n    margin: 0;\n    min-width: 0;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 20px;\n    color: #334155;\n  }\n\n  .notice-detail {\n    margin: 0;\n    padding-left: 26px;\n    font-size: 14px;\n    line-height: 20px;\n    color: #334155;\n  }\n\n  .upgrade-free-link {\n    display: inline-block;\n    margin-top: 0.35rem;\n    margin-left: 26px;\n    border: none;\n    background: none;\n    padding: 0;\n    color: #5ea1d8;\n    font-weight: 700;\n    font-size: 0.85rem;\n    line-height: 1.3;\n    cursor: pointer;\n    text-decoration: underline;\n  }\n}\n\n.main-div {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 89vh;\n  background: #efeeee !important;\n  .main-content {\n    border-radius: 10px 10px 10px 10px;\n    background: #fff;\n    padding: 20px 20px !important;\n    width: 90%;\n    max-width: 600px;\n    max-height: auto;\n    width: 100%;\n    position: relative;\n    padding: 0px;\n    border: 1px solid #ddd;\n    box-shadow: -2px 2px 7px rgb(200 193 193 / 50%);\n    text-align: center;\n    // border: 0.5px solid lightgrey;\n  }\n  .mat-form-field-appearance-legacy .mat-form-field-underline {\n    background: lightgray !important;\n  }\n\n  .font16 {\n    font-size: 14px !important;\n    font-family: \"Raleway\";\n  }\n  .table-wrapper {\n    .table-inner {\n      border-radius: 5px;\n      max-height: 300px;\n      height: 100%;\n      position: relative;\n      overflow: hidden;\n      min-height: 300px;\n      border: 1px solid lightgray;\n      background: #fff;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      img.img-display {\n        max-width: 100%;\n        max-height: 250px;\n        object-fit: contain;\n      }\n      video.video-display {\n        width: 100%;\n        height: 100%;\n      }\n    }\n\n    p {\n      color: #212427 !important;\n      text-align: left !important;\n      padding: 10px;\n      line-height: 20px;\n    }\n  }\n  button.close {\n    position: absolute;\n    top: -2px;\n    right: 6px;\n    z-index: 10;\n  }\n\n  .btn-primary {\n    background-color: #5ea1d8;\n    border: none;\n  }\n  .flowbycat {\n    background-color: transparent;\n  }\n\n  .transfer-toggle-section {\n    margin: 20px 0;\n    padding: 16px;\n    background: #f8f9fa;\n    border-radius: 8px;\n    border: 1px solid #e9ecef;\n\n    .transfer-toggle {\n      display: flex;\n      align-items: center;\n      gap: 12px;\n\n      .toggle-label {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        font-weight: 500;\n        color: #333;\n\n        .toggle-icon {\n          color: #5ea1d8;\n          font-size: 20px;\n          width: 20px;\n          height: 20px;\n        }\n      }\n    }\n\n    .toggle-description {\n      margin-top: 12px;\n      padding: 12px;\n      background: #e3f2fd;\n      border-radius: 6px;\n      border-left: 4px solid #5ea1d8;\n      display: flex;\n      align-items: flex-start;\n      gap: 8px;\n      font-size: 14px;\n      color: #1976d2;\n\n      .info-icon {\n        color: #5ea1d8;\n        font-size: 18px;\n        width: 18px;\n        height: 18px;\n        margin-top: 1px;\n      }\n    }\n  }\n  .hide_file {\n    position: absolute;\n    z-index: 1000;\n    opacity: 0;\n    cursor: pointer;\n    right: 0;\n    top: 0;\n    height: 100%;\n    font-size: 24px;\n    width: 100%;\n  }\n\n  @media only screen and (max-width: 1024px) and (min-width: 768px) {\n    .main-div {\n      min-height: 92vh;\n    }\n    .main-content {\n      width: 75%;\n    }\n  }\n}\n\n@media only screen and (max-width: 767px) and (min-width: 320px) {\n  .main-div {\n    background: #fff !important;\n    .main-content {\n      width: calc(100% - 30px) !important;\n      padding: 5px 5px 20px !important;\n    }\n  }\n}\n@media (max-width: 460px) {\n  .main-div {\n    .table-wrapper .table-inner {\n      max-height: 150px;\n      min-height: 150px;\n      img.img-display {\n        max-height: 100px;\n      }\n      .video-display {\n        max-height: 100px;\n      }\n    }\n  }\n}\n\n/* Mobile refinements to prevent overlaps and align content */\n@media (max-width: 460px) {\n  h3 {\n    font-size: 16px !important;\n  }\n  .font16 {\n    font-size: 12px !important;\n  }\n\n  /* Align icon and text; shrink icon */\n  .clickable-text .material-icons {\n    font-size: 18px !important;\n    line-height: 1;\n  }\n\n  /* Quill toolbar: allow wrapping */\n  .ql-toolbar .ql-formats {\n    display: inline-flex;\n    flex-wrap: wrap;\n    gap: 2px;\n  }\n\n  /* Title character counter: override inline margin to avoid overlap */\n  .main-div .mat-hint.font16 {\n    margin-left: 0 !important;\n    display: block;\n    width: 100%;\n    text-align: right;\n    margin-top: 6px;\n  }\n\n  .fileExplorer.btn {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 6px 10px;\n    font-size: 12px;\n  }\n}\n\n.card {\n  height: 100px;\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);\n  transition: 0.3s;\n  width: 30%;\n}\n\n.card:hover {\n  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);\n}\n\n.add-flow-card-wrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  margin-top: 20px;\n  margin-bottom: 20px;\n\n  .card.add-flow-card-centered {\n    .container {\n      padding: 16px;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: center;\n      gap: 8px;\n      width: 100%;\n      height: 100%;\n\n      h4 {\n        margin: 0 !important;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        width: 100%;\n        overflow: visible;\n\n        mat-icon {\n          width: 50px !important;\n          height: 50px !important;\n          font-size: 50px !important;\n          line-height: 50px !important;\n          overflow: visible;\n        }\n      }\n\n      p {\n        margin: 0 !important;\n      }\n    }\n  }\n}\n\n.add-flow-card-centered {\n  width: 22% !important;\n  margin: 0 auto;\n  height: auto !important;\n  min-height: 120px;\n  padding: 16px;\n  overflow: visible;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n@media (max-width: 768px) {\n  .add-flow-card-centered {\n    width: 90% !important;\n    min-height: 90px;\n  }\n\n  .add-flow-card-wrapper {\n    .card.add-flow-card-centered {\n      .container {\n        flex-direction: row;\n        gap: 12px;\n      }\n    }\n  }\n}\n\n.container {\n  padding: 2px 16px;\n}\n/* new design starta here*/\n.createBund {\n  .card {\n    width: calc(50% - 30px);\n    box-shadow: none;\n    margin: 40px auto 0px auto;\n    height: auto !important;\n    .container {\n      padding: 5px 16px;\n\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      flex-direction: column;\n    }\n\n    h4 {\n      margin: 0px !important;\n    }\n    p {\n      margin: 0px !important;\n    }\n    .mat-icon {\n      width: auto;\n      color: #212427;\n      text-shadow: 0px 2px 2px rgb(186 183 183 / 40%);\n      font-size: 35px !important;\n      height: auto;\n    }\n  }\n  form + .row {\n    text-align: center;\n    width: 100%;\n    margin: 0px !important;\n    display: flex;\n    align-items: center;\n    justify-content: end;\n  }\n  .item {\n    padding: 5px;\n    width: 31% !important;\n    margin-right: 0px !important;\n    margin-left: 0px !important;\n\n    border: 1px solid #ddd !important;\n    margin: 5px !important;\n    overflow: hidden;\n    background: #fff;\n    position: relative;\n    box-shadow: -2px 2px 7px hsl(0deg 6% 77% / 50%);\n    .example-margin {\n      position: absolute;\n      top: -4px;\n      left: 0px;\n      color: black;\n      font-size: 24px !important;\n    }\n    p {\n      text-align: left;\n    }\n\n    img {\n      border: 1px solid #ddd;\n      width: calc(100% - 10px) !important;\n      height: 150px !important;\n      border-radius: 0 !important;\n      margin: 5px !important;\n      object-fit: cover;\n    }\n    .with-icon {\n      display: flex;\n      img {\n        width: 30px !important;\n        height: 30px !important;\n        border-radius: 20px !important;\n      }\n    }\n  }\n\n  .mat-checkbox {\n    position: absolute;\n    top: 5px;\n    right: 5px;\n    .mat-checkbox-frame {\n      border-color: rgb(94, 161, 216) !important;\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .createBund {\n    .main-div {\n      .table-wrapper .table-inner {\n        min-height: 210px !important;\n      }\n    }\n  }\n}\n\n@media (max-width: 460px) {\n  .createBund {\n    form + .row {\n      width: 100% !important;\n      display: flex;\n      justify-content: space-between;\n    }\n    .item {\n      width: 47% !important;\n      margin: 5px !important;\n    }\n  }\n}\n@media only screen and (min-width: 461px) and (max-width: 1024px) {\n  .createBund {\n    form + .row {\n      width: 100% !important;\n      display: flex;\n      justify-content: space-evenly;\n    }\n    .item {\n      width: 31% !important;\n      margin: 5px !important;\n    }\n  }\n}\n\n.bundleIcon {\n  position: absolute;\n  bottom: 10px;\n  right: 10px;\n  z-index: 10;\n  width: 25px;\n  height: 25px;\n  img {\n    width: 100% !important;\n    height: auto !important;\n    object-fit: contain;\n    border: none;\n  }\n}\n\n.upload-tab-item {\n  display: flex;\n  padding: 0px;\n  margin-top: 10px;\n  flex-wrap: wrap;\n  align-items: center;\n  .inputfield {\n    order: 1;\n  }\n  .file-details {\n    order: 4;\n    display: block;\n    width: 100%;\n    text-align: left;\n    padding: 0px 10px;\n  }\n  .item-field {\n    order: 2;\n\n    &.upload-field-inline {\n      display: flex;\n      align-items: flex-start;\n\n      .form-label-wrapper.upload-label-inline {\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        gap: 12px;\n        margin-top: 0;\n        margin-bottom: 0;\n        padding: 0;\n\n        label {\n          margin: 0;\n          white-space: nowrap;\n        }\n\n        .upload-icon-btn {\n          margin: 0;\n        }\n      }\n    }\n  }\n  .addbtn {\n    order: 3;\n    height: auto;\n    display: flex;\n    align-items: center;\n\n    .btn,\n    .btn-primary {\n      min-height: 48px;\n      height: 48px;\n      padding: 12px 24px;\n      border-radius: 8px;\n      font-size: 14px;\n      font-weight: 500;\n      text-transform: none;\n    }\n  }\n  .example-list {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    margin-top: 12px;\n    margin-bottom: 20px;\n  }\n}\n\n.tab-design-wrapper {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  margin-top: 0;\n  padding: 20px 0;\n  // display: none !important;\n\n  &.field-anchor {\n    margin-left: 0;\n    margin-right: 0;\n  }\n\n  mat-form-field {\n    margin-left: 0;\n    margin-right: 0;\n    margin-bottom: 12px;\n\n    ::ng-deep {\n      .mdc-notched-outline {\n        border-radius: 8px;\n      }\n\n      .mdc-notched-outline__leading {\n        border-radius: 8px 0 0 8px;\n      }\n\n      .mdc-notched-outline__trailing {\n        border-radius: 0 8px 8px 0;\n      }\n\n      mat-label {\n        color: #000000;\n        font-size: 16px;\n        font-weight: 500;\n      }\n    }\n  }\n\n  // Upload + Add row: override bootstrap col widths so they sit side-by-side cleanly\n  .item-field.upload-field-inline {\n    flex: 0 0 auto !important;\n    max-width: none !important;\n    width: auto !important;\n    display: flex;\n    align-items: center;\n    padding: 0 !important;\n    margin-right: 12px;\n  }\n\n  .upload-label-inline {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 12px;\n    margin-top: 0;\n    margin-bottom: 0;\n    padding: 0;\n    white-space: nowrap;\n\n    label {\n      margin: 0;\n      white-space: nowrap;\n    }\n\n    .upload-icon-btn {\n      margin: 0;\n    }\n  }\n\n  .addbtn {\n    flex: 0 0 auto !important;\n    max-width: none !important;\n    width: auto !important;\n    height: auto !important;\n    display: flex !important;\n    align-items: center;\n    padding: 0 !important;\n\n    .btn,\n    .btn-primary {\n      white-space: nowrap;\n      min-height: 48px;\n      height: 48px;\n      padding: 12px 24px;\n      border-radius: 8px;\n      font-size: 14px;\n      font-weight: 500;\n      text-transform: none;\n    }\n  }\n\n  .tab-design-item {\n    &.field-anchor {\n      margin-left: 0;\n      margin-right: 0;\n    }\n\n    &:last-child {\n      display: block;\n      position: relative;\n      order: 4;\n    }\n  }\n  .example-list {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    margin-top: 12px;\n    margin-bottom: 20px;\n  }\n\n  .example-box.document-row {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 10px 14px;\n    border: 1px solid #e2e8f0;\n    border-radius: 10px;\n    background: #f8fafc;\n    transition: box-shadow 0.15s ease, border-color 0.15s ease;\n    cursor: grab;\n\n    &:hover {\n      border-color: #cbd5e1;\n      box-shadow: 0 2px 8px rgba(15, 23, 42, 0.07);\n    }\n\n    .doc-type-icon {\n      flex-shrink: 0;\n      font-size: 22px;\n      width: 22px;\n      height: 22px;\n      color: #5ea1d8;\n\n      &.link-icon { color: #8b5cf6; }\n    }\n\n    .doc-name {\n      flex: 1;\n      font-size: 14px;\n      font-weight: 500;\n      color: #1e293b;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      min-width: 0;\n    }\n\n    .doc-name-group {\n      flex: 1;\n      min-width: 0;\n      display: flex;\n      flex-direction: column;\n      gap: 2px;\n\n      .doc-name {\n        flex: none;\n        font-size: 14px;\n        font-weight: 500;\n        color: #1e293b;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n      }\n\n      .doc-url {\n        font-size: 12px;\n        color: #64748b;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n      }\n    }\n\n    .doc-actions {\n      display: flex;\n      align-items: center;\n      gap: 4px;\n      flex-shrink: 0;\n    }\n\n    .doc-action-btn {\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n      width: 32px;\n      height: 32px;\n      border: none;\n      border-radius: 6px;\n      cursor: pointer;\n      background: transparent;\n      transition: background 0.15s ease, color 0.15s ease;\n\n      mat-icon {\n        font-size: 18px;\n        width: 18px;\n        height: 18px;\n      }\n\n      &.edit {\n        color: #5ea1d8;\n        &:hover { background: rgba(94, 161, 216, 0.1); }\n      }\n\n      &.delete {\n        color: #ef4444;\n        &:hover { background: rgba(239, 68, 68, 0.1); }\n      }\n    }\n  }\n}\n.img-div-left.small-spinner {\n  position: absolute !important;\n  width: 100px !important;\n  height: 100px !important;\n\n  top: 100px !important;\n\n  img {\n    width: 100px !important;\n    height: 100px !important;\n    top: unset !important;\n  }\n}\n.quill-wrapper {\n  .fl-left {\n    margin-bottom: 10px;\n    display: block;\n  }\n  quill-editor {\n    width: 100%;\n  }\n}\n.fileExplorer {\n  margin-top: 20px;\n}\n.clickable-text {\n  color: #007bff; /* Link color */\n  cursor: pointer; /* Pointer cursor on hover */\n  text-decoration: underline; /* Underline text */\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.clickable-text:hover {\n  color: #0056b3; /* Darker shade on hover */\n}\n\n/* Ensure action links wrap and keep spacing */\n.commonlintbtn-parent {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.file-upload {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 20px;\n}\n\ninput[type=\"file\"] {\n  margin-bottom: 10px;\n}\n\nbutton {\n  margin-bottom: 20px;\n}\n\nmat-progress-bar {\n  width: 100%;\n  margin-top: 10px;\n}\n\n// progress {\n//   appearance: none;\n//   -webkit-appearance: none;\n//   width: 100%; /* Optional: Set the width of the progress bar */\n//   height: 20px; /* Optional: Set the height of the progress bar */\n//   border: none; /* Optional: Remove any borders */\n//   background-color: #e0e0e0; /* Background color of the progress bar */\n// }\n\n// progress::-webkit-progress-bar {\n//   background-color: #e0e0e0; /* Background color of the progress bar */\n// }\n\n// progress::-webkit-progress-value {\n//   background-color: #5ea1d8; /* The color of the actual progress */\n// }\n\n// progress::-moz-progress-bar {\n//   background-color: #5ea1d8; /* The color of the actual progress in Firefox */\n// }\n\nprogress {\n  appearance: none;\n  -webkit-appearance: none;\n  border: none; /* Remove any borders */\n  background-color: #e0e0e0; /* Background color of the progress bar */\n  border-radius: 10px; /* Curve the corners of the entire progress bar */\n  overflow: hidden; /* Ensure inner elements respect the border radius */\n  height: 20px; /* Optional: adjust the height if needed */\n}\n\nprogress::-webkit-progress-bar {\n  background-color: #e0e0e0; /* Background color of the progress bar */\n}\n\nprogress::-webkit-progress-value {\n  background-color: #5ea1d8; /* The color of the actual progress */\n}\n\nprogress::-moz-progress-bar {\n  background-color: #5ea1d8; /* The color of the actual progress in Firefox */\n}\n\n// Responsive styles matching create-flow\n@media (max-width: 1200px) {\n  .upload-body {\n    flex-direction: column;\n  }\n  .secondary-pane {\n    flex-direction: row;\n    flex-wrap: wrap;\n  }\n}\n\n@media (max-width: 768px) {\n  .upload-backdrop {\n    padding: 0;\n  }\n  .upload-dialog {\n    width: 100%;\n    height: 100vh;\n    max-height: 100vh;\n    border-radius: 0;\n  }\n  .upload-header,\n  .stage-banner {\n    padding: 20px;\n  }\n  .upload-body {\n    padding: 20px;\n  }\n  .section-card {\n    padding: 18px;\n  }\n\n  // Mobile: make the top journey step list horizontally scrollable\n  .journey-progress {\n    overflow-x: auto !important;\n    overflow-y: hidden;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: none; // Firefox\n    padding-top: 8px;\n    margin-top: 8px;\n    touch-action: pan-x;\n\n    &::-webkit-scrollbar {\n      display: none;\n    }\n  }\n\n  // Mobile: show connectors with fixed width for better mobile experience\n  .step-connector {\n    display: block !important;\n    flex: 0 0 16px; // Fixed width instead of flex: 1 for mobile\n    min-width: 16px;\n    height: 2px;\n    margin: 0 4px;\n    align-self: center; // Ensure proper vertical alignment\n  }\n\n  .journey-step {\n    flex: 0 0 auto;\n    padding-right: 8px;\n    // Disabled tabs get `touch-action: none` inline from MDC; override so user can swipe-scroll.\n    touch-action: pan-x !important;\n  }\n\n  .step-label {\n    font-size: 12px;\n    letter-spacing: 0.02em;\n  }\n\n  // Mobile: prevent horizontal overflow in forms/fields\n  .journey-content {\n    padding: 16px;\n    overflow-x: hidden;\n  }\n\n  mat-form-field {\n    width: 100%;\n    max-width: 100%;\n  }\n\n  .cover-form-wrapper,\n  .cover-form-wrapper .row,\n  .cover-form-wrapper .col-12,\n  .cover-form-wrapper [class*=\"col-\"] {\n    max-width: 100%;\n  }\n\n  // Avoid nested grid padding causing horizontal scroll\n  .cover-form-wrapper .row {\n    margin-left: 0;\n    margin-right: 0;\n  }\n  .cover-form-wrapper [class*=\"col-\"] {\n    padding-left: 0;\n    padding-right: 0;\n  }\n\n  // Mobile: keep footer actions visible (pin to bottom) + account for safe area\n  // Also fix mobile browser \"vh\" quirks by using dynamic viewport height.\n  .upload-dialog {\n    height: 100dvh;\n    max-height: 100dvh;\n  }\n\n  .upload-footer {\n    // Override global mobile CSS in `styles.scss` that hides all `footer` elements.\n    display: flex !important;\n    position: fixed;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 10010;\n    padding: 8px 12px;\n    padding-bottom: max(8px, env(safe-area-inset-bottom));\n    gap: 8px;\n    flex-wrap: nowrap;\n    align-items: center;\n  }\n\n  // Prevent content from being hidden behind the fixed footer\n  .upload-body {\n    padding-bottom: calc(20px + 60px + env(safe-area-inset-bottom));\n  }\n\n  // Mobile footer button layout: 2-column, compact height\n  .upload-footer .footer-step,\n  .upload-footer .footer-actions {\n    flex: 1 1 0;\n    min-width: 0;\n  }\n\n  .upload-footer .footer-step .footer-btn {\n    width: 100%;\n  }\n\n  .upload-footer .footer-actions {\n    display: flex;\n    flex-wrap: nowrap;\n    gap: 8px;\n    justify-content: stretch;\n  }\n\n  .upload-footer .footer-actions .take-public-group,\n  .upload-footer .footer-actions .take-public-wrap,\n  .upload-footer .footer-actions .publish-wrap {\n    flex: 1 1 0;\n    min-width: 0;\n    display: flex;\n  }\n\n  .upload-footer .footer-actions .footer-btn {\n    flex: 1 1 0;\n    width: 100%;\n    min-height: 36px; // compact (was 44px)\n    padding: 6px 12px;\n    font-size: 12px;\n    letter-spacing: 0.02em;\n  }\n\n  /* Secondary actions sit in the ⋮ menu; the button keeps a fixed square size */\n  .upload-footer .footer-actions .footer-more-btn {\n    flex: 0 0 36px;\n    width: 36px;\n    height: 36px;\n    padding: 0;\n    border-radius: 50%;\n    border: 1px solid #d0d7de;\n    background: #fff;\n    color: #374151;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n\n    mat-icon {\n      font-size: 22px;\n      width: 22px;\n      height: 22px;\n      line-height: 22px;\n    }\n  }\n\n  :host-context(body.theme-dark) .upload-footer .footer-actions .footer-more-btn {\n    background: #1b1f27;\n    border-color: #2f3542;\n    color: #e2e8f0;\n  }\n\n  // Mobile: Angular Material tab headers (Attachments / HyperLink) should scroll horizontally\n  // instead of overflowing out of the box.\n  //\n  // NOTE: MatTabGroup renders its header inside Angular Material templates, so we need\n  // ::ng-deep here to pierce view encapsulation.\n  :host ::ng-deep .standard-tab-group {\n    .mat-mdc-tab-header-pagination {\n      display: none !important;\n    }\n\n    .mat-mdc-tab-label-container {\n      overflow-x: auto !important;\n      overflow-y: hidden !important;\n      -webkit-overflow-scrolling: touch;\n      touch-action: pan-x;\n      scrollbar-width: none;\n\n      &::-webkit-scrollbar {\n        display: none;\n      }\n    }\n\n    // Material uses translateX(...) for pagination; disable it so native scroll works.\n    .mat-mdc-tab-list {\n      transform: none !important;\n      width: max-content;\n    }\n\n    .mat-mdc-tab-labels {\n      width: max-content;\n      flex-wrap: nowrap;\n    }\n\n    // Your tab label template uses inline `min-width: 120px`; override on mobile so it can fit.\n    .mdc-tab__text-label > span {\n      min-width: 0 !important;\n    }\n  }\n}\n\n// Confirm menu styles\n.confirm-menu {\n  padding: 16px;\n  border-bottom: 1px solid #e4e8f0;\n\n  h5 {\n    margin: 0 0 8px 0;\n    font-size: 16px;\n    font-weight: 600;\n    color: #111827;\n  }\n\n  p {\n    margin: 0;\n    font-size: 14px;\n    color: #64748b;\n    line-height: 1.5;\n  }\n}\n\n// Ensure mat-menu overlays are above everything\n::ng-deep .upload-backdrop {\n  .cdk-overlay-pane {\n    z-index: 10030 !important;\n  }\n\n  .cdk-overlay-backdrop {\n    z-index: 10029 !important;\n  }\n\n  .mat-mdc-menu-panel {\n    z-index: 10031 !important;\n  }\n}\n\n// Global override for mat-menu when inside upload-backdrop\n::ng-deep .cdk-overlay-container {\n  .cdk-overlay-pane {\n    &[data-mat-menu-panel],\n    &[class*=\"menu\"],\n    &:has(.mat-mdc-menu-panel),\n    &:has(.mat-menu-panel) {\n      z-index: 10030 !important;\n    }\n  }\n}\n\n// Ensure mat-menu triggered from upload-dialog is on top\n::ng-deep body {\n  .cdk-overlay-pane {\n    &:has(.mat-mdc-menu-panel),\n    &:has(.mat-menu-panel) {\n      z-index: 10030 !important;\n    }\n  }\n\n  .cdk-overlay-container {\n    .cdk-overlay-pane {\n      &[class*=\"menu\"],\n      &:has(.mat-mdc-menu-panel),\n      &:has(.mat-menu-panel) {\n        z-index: 10030 !important;\n      }\n    }\n  }\n}\n\n// Summary Preview Card Styles\n.preview-card {\n  .preview-content {\n    max-height: 600px;\n    overflow-y: auto;\n\n    &::-webkit-scrollbar {\n      width: 6px;\n    }\n\n    &::-webkit-scrollbar-track {\n      background: #f1f1f1;\n      border-radius: 3px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n      background: #c1c1c1;\n      border-radius: 3px;\n\n      &:hover {\n        background: #a8a8a8;\n      }\n    }\n  }\n\n  .mobile-preview-wrapper {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n  }\n\n  .mobile-section {\n    background: #ffffff;\n    border-radius: 16px;\n   box-shadow: 0 12px 28px rgba(31, 47, 70, 0.1);\n    overflow: hidden;\n    margin-bottom: 16px;\n\n    .mobile-media {\n      background: #000;\n      width: 100%;\n      min-height: 180px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      position: relative;\n\n      img,\n      video {\n        width: 100%;\n        max-height: 260px;\n        object-fit: cover;\n        display: block;\n      }\n\n      &.placeholder {\n        color: #9ca3af;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        gap: 8px;\n        background: #f3f4f6;\n\n        mat-icon {\n          font-size: 48px;\n          width: 48px;\n          height: 48px;\n        }\n\n        p {\n          margin: 0;\n          font-size: 14px;\n        }\n      }\n    }\n\n    .mobile-section-body {\n      padding: 20px;\n      display: flex;\n      flex-direction: column;\n      gap: 12px;\n    }\n\n    .mobile-section-title {\n      font-size: 20px;\n      font-weight: 600;\n      margin: 0;\n      color: #1f2f46;\n      line-height: 1.4;\n    }\n\n    .mobile-section-description {\n      color: #4a5568;\n      line-height: 1.6;\n      font-size: 14px;\n\n      p {\n        margin-bottom: 12px;\n      }\n    }\n\n    .mobile-meta-row {\n      display: flex;\n      align-items: center;\n      gap: 12px;\n      flex-wrap: wrap;\n      margin-top: 8px;\n\n      .info-badge {\n        display: inline-flex;\n        align-items: center;\n        gap: 4px;\n        padding: 4px 12px;\n        border-radius: 999px;\n        background: #f1f5f9;\n        color: #475569;\n        font-size: 13px;\n\n        mat-icon {\n          font-size: 18px;\n          width: 18px;\n          height: 18px;\n          color: #5ea1d8;\n        }\n      }\n    }\n  }\n\n  .preview-empty {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 48px 24px;\n    text-align: center;\n    color: #9ca3af;\n\n    mat-icon {\n      font-size: 64px;\n      width: 64px;\n      height: 64px;\n      margin-bottom: 16px;\n      color: #d1d5db;\n    }\n\n    p {\n      margin: 0;\n      font-size: 16px;\n      color: #6b7280;\n    }\n  }\n\n  // Documents view\n  .mobile-documents-view {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n  }\n\n  .mobile-documents-list,\n  .mobile-links-list {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    margin-top: 12px;\n  }\n\n  .mobile-document-item,\n  .mobile-link-item {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 12px;\n    border: 1px solid #e2e8f0;\n    border-radius: 12px;\n    background: #fff;\n    transition: all 0.2s ease;\n\n    &:hover {\n      border-color: #cbd5e1;\n      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);\n    }\n\n    .document-icon,\n    .link-icon {\n      font-size: 24px;\n      width: 24px;\n      height: 24px;\n      color: #5ea1d8;\n      flex-shrink: 0;\n    }\n\n    .document-info,\n    .link-info {\n      flex: 1;\n      min-width: 0;\n      display: flex;\n      flex-direction: column;\n      gap: 4px;\n\n      .document-name,\n      .link-name {\n        font-size: 14px;\n        font-weight: 600;\n        color: #1f2f46;\n      }\n\n      .document-link,\n      .link-url {\n        font-size: 12px;\n        color: #2563eb;\n        text-decoration: none;\n        display: inline-flex;\n        align-items: center;\n        gap: 4px;\n        font-weight: 500;\n\n        &:hover {\n          text-decoration: underline;\n        }\n\n        .link-icon-tiny {\n          font-size: 14px;\n          width: 14px;\n          height: 14px;\n        }\n      }\n    }\n  }\n\n  // Pricing view\n  .mobile-pricing-view {\n    .pricing-info {\n      display: flex;\n      flex-direction: column;\n      gap: 16px;\n    }\n\n    .pricing-row {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      padding: 12px;\n      border: 1px solid #e2e8f0;\n      border-radius: 12px;\n      background: #fff;\n\n      .pricing-label {\n        font-size: 14px;\n        font-weight: 500;\n        color: #64748b;\n      }\n\n      .pricing-value {\n        font-size: 16px;\n        font-weight: 600;\n        color: #1f2f46;\n\n        &.price-amount {\n          color: #16a34a;\n          font-size: 18px;\n        }\n      }\n\n      .pricing-warning {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        color: #dc2626;\n        font-size: 13px;\n        font-weight: 500;\n\n        mat-icon {\n          font-size: 18px;\n          width: 18px;\n          height: 18px;\n        }\n      }\n    }\n  }\n\n  @media (max-width: 767px) {\n    .mobile-pricing-view {\n      .pricing-row {\n        flex-direction: column;\n        align-items: flex-start;\n        justify-content: flex-start;\n        gap: 6px;\n      }\n    }\n  }\n\n  // Flows view\n  .mobile-flows-view {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n\n    .flows-count-badge {\n      padding: 8px 16px;\n      background: #e0f2fe;\n      border-radius: 8px;\n      text-align: center;\n      font-size: 14px;\n      font-weight: 600;\n      color: #0284c7;\n      margin-bottom: 8px;\n    }\n\n    .mobile-flows-list {\n      display: flex;\n      flex-direction: column;\n      gap: 12px;\n    }\n\n    .mobile-flow-item {\n      display: flex;\n      gap: 12px;\n      padding: 12px;\n      border: 1px solid #e2e8f0;\n      border-radius: 12px;\n      background: #fff;\n      cursor: pointer;\n      transition: all 0.2s ease;\n\n      &:hover {\n        border-color: #cbd5e1;\n        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);\n        transform: translateY(-1px);\n      }\n\n      .mobile-flow-thumbnail {\n        width: 80px;\n        height: 60px;\n        border-radius: 8px;\n        background: #f1f5f9;\n        overflow: hidden;\n        flex-shrink: 0;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n\n        img,\n        video {\n          width: 100%;\n          height: 100%;\n          object-fit: cover;\n        }\n\n        .mobile-flow-placeholder {\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          width: 100%;\n          height: 100%;\n          color: #9ca3af;\n\n          mat-icon {\n            font-size: 32px;\n            width: 32px;\n            height: 32px;\n          }\n        }\n      }\n\n      .mobile-flow-content {\n        flex: 1;\n        min-width: 0;\n        display: flex;\n        flex-direction: column;\n        gap: 4px;\n        justify-content: center;\n\n        .mobile-flow-title {\n          margin: 0;\n          font-size: 14px;\n          font-weight: 600;\n          color: #1f2f46;\n          line-height: 1.4;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          display: -webkit-box;\n          -webkit-line-clamp: 2;\n          -webkit-box-orient: vertical;\n        }\n\n        .mobile-flow-meta {\n          display: flex;\n          align-items: center;\n          gap: 8px;\n          font-size: 12px;\n          color: #64748b;\n\n          .flow-creator {\n            flex: 1;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            white-space: nowrap;\n          }\n\n          .flow-price {\n            font-weight: 600;\n            color: #16a34a;\n          }\n        }\n      }\n    }\n  }\n}\n\n// Thumbnail selection section\n.flow-thumbnail-section {\n  margin-top: 24px;\n  padding: 0;\n  background: transparent;\n}\n\n.thumbnail-section-header {\n  margin-bottom: 16px;\n\n  h4 {\n    font-size: 14px;\n    font-weight: 500;\n    color: #030303;\n    margin: 0 0 4px 0;\n    line-height: 20px;\n  }\n\n  p {\n    font-size: 13px;\n    color: #606060;\n    margin: 0;\n    line-height: 18px;\n  }\n}\n\n.thumbnail-choice-row {\n  display: flex;\n  gap: 12px;\n  margin-bottom: 16px;\n  flex-wrap: wrap;\n}\n\n.thumbnail-dialog-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.65);\n  z-index: 10010;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n}\n\n.thumbnail-dialog-card {\n  width: min(960px, 90vw);\n  max-height: 90vh;\n  background: #fff;\n  border-radius: 18px;\n  box-shadow: 0 25px 60px rgba(15, 23, 42, 0.3);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.thumbnail-dialog-header {\n  padding: 20px 24px;\n  border-bottom: 1px solid #e4e8f0;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  position: relative;\n  z-index: 10011;\n\n  h4 {\n    margin: 0;\n    font-size: 20px;\n    font-weight: 600;\n  }\n\n  p {\n    margin: 4px 0 0;\n    color: #64748b;\n    font-size: 14px;\n    max-width: 480px;\n  }\n\n  .icon-button {\n    z-index: 10012;\n  }\n}\n\n.thumbnail-dialog-body {\n  padding: 24px;\n  overflow-y: auto;\n\n  @media (max-width: 768px) {\n    padding: 16px;\n  }\n}\n\n.thumbnail-choice {\n  flex: 1;\n  min-width: 160px;\n  border: 1px dashed #d3d3d3;\n  background: #fff;\n  padding: 12px 16px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: border-color 0.2s ease, background-color 0.2s ease;\n  font-size: 13px;\n  color: #030303;\n\n  &.selected {\n    border: 1px solid #065fd4;\n    background: rgba(6, 95, 212, 0.05);\n  }\n\n  &.disabled {\n    opacity: 0.5;\n    cursor: default;\n  }\n}\n\n.choice-icon {\n  font-size: 20px;\n  color: #606060;\n}\n\n.choice-text {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 2px;\n\n  strong {\n    font-weight: 500;\n    font-size: 13px;\n  }\n\n  small {\n    font-size: 12px;\n    color: #606060;\n  }\n}\n\n.thumbnail-mode {\n  margin-top: 0;\n  margin-bottom: 16px;\n\n  &.upload-mode {\n    margin-bottom: 24px;\n  }\n}\n\n.thumbnail-mode-header {\n  margin-bottom: 12px;\n\n  h5 {\n    margin: 0;\n    font-size: 14px;\n    font-weight: 500;\n    color: #030303;\n  }\n\n  p {\n    margin: 4px 0 0 0;\n    font-size: 12px;\n    color: #606060;\n  }\n}\n\n.yt-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 6px 12px;\n  border: 1px solid #d3d3d3;\n  background: #fff;\n  color: #030303;\n  font-size: 13px;\n  border-radius: 2px;\n  cursor: pointer;\n  transition: background-color 0.2s ease, border-color 0.2s ease;\n\n  &:hover {\n    background: #f0f0f0;\n  }\n\n  &:disabled {\n    color: #9e9e9e;\n    border-color: #e0e0e0;\n    cursor: not-allowed;\n  }\n\n  &.primary {\n    background: #065fd4;\n    color: #fff;\n    border-color: #065fd4;\n\n    &:hover {\n      background: #0d96ff;\n      border-color: #0d96ff;\n    }\n  }\n\n  mat-icon {\n    font-size: 16px;\n  }\n}\n\n// Video Preview with Scrubber\n.video-preview-container {\n  margin-bottom: 16px;\n}\n\n.video-wrapper {\n  position: relative;\n  width: 100%;\n  max-width: 640px;\n  background: #000;\n  border-radius: 0;\n  overflow: hidden;\n  aspect-ratio: 16/9;\n}\n\n.thumbnail-video-preview {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  display: block;\n}\n\n.video-controls-overlay {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: linear-gradient(to top, rgba(0, 0, 0, 0.75), transparent);\n  padding: 12px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.video-scrubber-container {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.video-scrubber {\n  flex: 1;\n  height: 4px;\n  background: rgba(255, 255, 255, 0.3);\n  border-radius: 2px;\n  outline: none;\n  cursor: pointer;\n\n  &::-webkit-slider-thumb {\n    appearance: none;\n    width: 14px;\n    height: 14px;\n    background: #fff;\n    border-radius: 50%;\n    cursor: pointer;\n  }\n\n  &::-moz-range-thumb {\n    width: 14px;\n    height: 14px;\n    background: #fff;\n    border-radius: 50%;\n    cursor: pointer;\n    border: none;\n  }\n}\n\n.scrubber-time {\n  color: #fff;\n  font-size: 12px;\n  font-weight: 400;\n  white-space: nowrap;\n  min-width: 70px;\n  text-align: right;\n}\n\n.capture-frame-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  background: rgba(255, 255, 255, 0.9);\n  color: #030303;\n  border: none;\n  border-radius: 2px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.2s ease;\n\n  &:hover {\n    background: #fff;\n  }\n\n  mat-icon {\n    font-size: 16px;\n    width: 16px;\n    height: 16px;\n  }\n}\n\n.thumbnails-horizontal-scroll {\n  display: flex;\n  gap: 8px;\n  overflow-x: auto;\n  padding-bottom: 4px;\n  scrollbar-width: thin;\n  scrollbar-color: #d3d3d3 transparent;\n\n  &::-webkit-scrollbar {\n    height: 4px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: #d3d3d3;\n    border-radius: 2px;\n\n    &:hover {\n      background: #b3b3b3;\n    }\n  }\n}\n\n.thumbnail-item-small {\n  position: relative;\n  width: 120px;\n  height: 68px;\n  flex-shrink: 0;\n  border-radius: 0;\n  overflow: hidden;\n  cursor: pointer;\n  border: 2px solid transparent;\n  transition: border-color 0.15s ease;\n  background: #000;\n\n  &:hover {\n    border-color: #065fd4;\n  }\n\n  &.selected {\n    border-color: #065fd4;\n    border-width: 3px;\n  }\n\n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    display: block;\n  }\n}\n\n.thumbnail-check-small {\n  position: absolute;\n  top: 4px;\n  right: 4px;\n  background: #065fd4;\n  border-radius: 50%;\n  width: 18px;\n  height: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  mat-icon {\n    color: #fff;\n    font-size: 12px;\n    width: 12px;\n    height: 12px;\n  }\n}\n\n.thumbnails-loading-small {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 0;\n  color: #606060;\n  font-size: 13px;\n}\n\n.no-thumbnails-message {\n  padding: 12px 0;\n  text-align: left;\n  color: #606060;\n  font-size: 13px;\n}\n\n.custom-thumbnail-upload-compact {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  max-width: 320px;\n}\n\n.upload-preview-compact {\n  position: relative;\n  width: 320px;\n  height: 180px;\n  border-radius: 0;\n  overflow: hidden;\n  background: #f9f9f9;\n  border: 1px solid #d3d3d3;\n  flex-shrink: 0;\n}\n\n.custom-thumbnail-preview-small {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.upload-placeholder-compact {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background: #f9f9f9;\n  gap: 8px;\n\n  mat-icon {\n    font-size: 48px;\n    width: 48px;\n    height: 48px;\n    color: #909090;\n  }\n\n  span {\n    font-size: 13px;\n    color: #606060;\n    font-weight: 400;\n  }\n}\n\n.upload-progress-compact {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  background: #f9f9f9;\n\n  span {\n    font-size: 13px;\n    color: #606060;\n  }\n}\n\n.thumbnail-upload-action {\n  margin-top: 12px;\n}\n\n.flows-sequence-toggle-row {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-bottom: 8px;\n\n  .form-label {\n    margin-bottom: 0;\n  }\n}\n\n.nested-bundles-section {\n  margin-top: 24px;\n  padding-top: 20px;\n  border-top: 1px solid rgba(0, 0, 0, 0.08);\n}\n\n.nested-category-header {\n  margin-top: 8px;\n  margin-bottom: 20px;\n\n  h5 {\n    margin: 0 0 6px;\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 1.3;\n    color: #111827;\n  }\n\n  p {\n    margin: 0;\n    color: #6b7280;\n    font-size: 14px;\n    line-height: 1.4;\n  }\n}\n\n.nested-categories-panel {\n  margin-top: 20px;\n  padding-top: 4px;\n}\n\n.add-category-row,\n.bundle-category-card-header {\n  mat-form-field {\n    flex: 1 1 auto;\n    width: auto !important;\n    min-width: 0;\n    margin: 0 !important;\n\n    ::ng-deep .mat-mdc-form-field-subscript-wrapper {\n      display: none;\n    }\n\n    ::ng-deep .mat-mdc-form-field-infix {\n      min-height: 48px;\n      padding-top: 12px;\n      padding-bottom: 12px;\n    }\n\n    ::ng-deep .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-floating-label {\n      top: 24px;\n    }\n\n    ::ng-deep .mdc-text-field--outlined .mdc-notched-outline--upgraded .mdc-floating-label--float-above {\n      --mat-mdc-form-field-label-transform: translateY(-30.75px) scale(var(--mat-mdc-form-field-floating-label-scale, 0.75));\n      transform: var(--mat-mdc-form-field-label-transform);\n    }\n  }\n}\n\n.add-category-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 16px;\n\n  .add-flows-header-btn {\n    min-height: 48px;\n    height: 48px;\n    margin: 0 !important;\n    align-self: center;\n  }\n}\n\n.bundle-category-card {\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  border-radius: 8px;\n  padding: 16px;\n  margin-bottom: 16px;\n  background: rgba(0, 0, 0, 0.02);\n}\n\n.bundle-category-card-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 4px;\n\n  .category-name-field {\n    flex: 1;\n    margin-bottom: 0;\n\n    ::ng-deep .mat-mdc-form-field-subscript-wrapper {\n      display: none;\n    }\n  }\n\n  .icon-button {\n    flex-shrink: 0;\n    align-self: center;\n    color: #6b7280;\n\n    &:hover {\n      color: #dc2626;\n      background: #fee2e2;\n    }\n  }\n}\n\n.category-actions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 10px;\n  margin: 4px 0 12px;\n\n  .category-action-btn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n    min-height: 48px;\n    height: 48px;\n    padding: 12px 20px;\n    margin: 0;\n    border: none;\n    border-radius: 8px;\n    background: #5ea1d8;\n    color: #fff;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 1.2;\n    white-space: nowrap;\n    cursor: pointer;\n    transition: background 0.2s;\n    text-transform: none;\n    box-sizing: border-box;\n\n    mat-icon {\n      font-size: 18px;\n      width: 18px;\n      height: 18px;\n      line-height: 18px;\n    }\n\n    &:hover {\n      background: #4a8fc4;\n      color: #fff;\n    }\n  }\n}\n\n.category-subsection {\n  margin-top: 16px;\n  padding-top: 12px;\n  border-top: 1px solid rgba(0, 0, 0, 0.06);\n\n  h6 {\n    margin: 0 0 12px;\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 1.3;\n    color: #374151;\n  }\n}\n\n.journey-pane-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 16px;\n\n  h5 {\n    margin: 0;\n  }\n\n  p {\n    margin: 4px 0 0;\n    color: #6b7280;\n    font-size: 14px;\n  }\n}\n\n.add-flows-header-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  flex-shrink: 0;\n  white-space: nowrap;\n  min-height: 48px;\n  height: 48px;\n  padding: 12px 20px;\n  border: none;\n  border-radius: 8px;\n  background: #5ea1d8;\n  color: #fff;\n  font-weight: 500;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background 0.2s;\n  text-transform: none;\n  box-sizing: border-box;\n\n  mat-icon {\n    font-size: 20px;\n    width: 20px;\n    height: 20px;\n    line-height: 20px;\n  }\n\n  &:hover {\n    background: #4a8fc4;\n  }\n}\n\n@media (max-width: 768px) {\n  .journey-pane-header {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .add-flows-header-btn {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .add-category-row {\n    flex-direction: column;\n    align-items: stretch;\n\n    .add-flows-header-btn {\n      width: 100%;\n      min-height: 48px;\n      height: 48px;\n    }\n  }\n\n  .category-actions {\n    flex-direction: column;\n    align-items: stretch;\n\n    .category-action-btn {\n      width: 100%;\n      justify-content: center;\n    }\n  }\n}\n\n.flows-sequence-hint {\n  margin: 8px 0 0;\n  font-size: 14px;\n  line-height: 1.4;\n  color: #5ea1d8;\n\n  &.muted {\n    color: #666;\n  }\n}\n\n// Standardized Flow Card Structure\n.bundle-flows-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n  gap: 16px;\n  margin-top: 20px;\n  padding: 0;\n\n  @media (max-width: 768px) {\n    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));\n    gap: 12px;\n  }\n}\n\n.bundle-flow-card {\n  position: relative;\n  background: #fff;\n  border-radius: 12px;\n  border: 1px solid #e0e0e0;\n  overflow: hidden;\n  transition: all 0.2s ease;\n  cursor: pointer;\n\n  &:hover {\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n    transform: translateY(-2px);\n  }\n\n  .flow-card-delete-btn {\n    position: absolute;\n    top: 8px;\n    right: 8px;\n    z-index: 10;\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    background: rgba(0, 0, 0, 0.6);\n    border: none;\n    color: #fff;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: all 0.2s ease;\n\n    &:hover {\n      background: rgba(0, 0, 0, 0.8);\n      transform: scale(1.1);\n    }\n\n    mat-icon {\n      font-size: 18px;\n      width: 18px;\n      height: 18px;\n    }\n  }\n\n  .flow-card-checkbox {\n    position: absolute;\n    top: 8px;\n    left: 8px;\n    z-index: 10;\n    background: rgba(255, 255, 255, 0.9);\n    border-radius: 4px;\n  }\n\n  .flow-locked-badge {\n    position: absolute;\n    top: 14px;\n    left: 56px;\n    right: 8px;\n    z-index: 10;\n    width: fit-content;\n    max-width: calc(100% - 64px);\n    padding: 3px 8px;\n    border-radius: 4px;\n    background: rgba(17, 24, 39, 0.85);\n    color: #fff;\n    font-size: 11px;\n    font-weight: 600;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  &.bundle-flow-card--locked {\n    cursor: default;\n\n    .flow-card-thumbnail,\n    .flow-card-info {\n      opacity: 0.55;\n    }\n\n    &:hover {\n      box-shadow: none;\n    }\n  }\n\n  .flow-card-thumbnail {\n    position: relative;\n    width: 100%;\n    padding-top: 56.25%; // 16:9 aspect ratio\n    overflow: hidden;\n    background: #000;\n    cursor: pointer;\n\n    .flow-thumbnail-image,\n    .flow-thumbnail-video {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n    }\n\n    .flow-thumbnail-video {\n      background: #000;\n    }\n\n    .flow-seq-badge {\n      position: absolute;\n      top: 8px;\n      left: 8px;\n      z-index: 6;\n      min-width: 24px;\n      height: 24px;\n      padding: 0 8px;\n      border-radius: 999px;\n      background: rgba(94, 161, 216, 0.95);\n      color: #fff;\n      font-size: 12px;\n      font-weight: 700;\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n      pointer-events: none;\n      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);\n    }\n\n    .flow-price-badge {\n      position: absolute;\n      bottom: 8px;\n      right: 8px;\n      background: rgba(0, 0, 0, 0.8);\n      color: #fff;\n      padding: 4px 8px;\n      border-radius: 4px;\n      font-size: 12px;\n      font-weight: 600;\n      z-index: 5;\n    }\n\n    .flow-access-badge {\n      position: absolute;\n      bottom: 8px;\n      left: 8px;\n      background: rgba(30, 77, 114, 0.9);\n      color: #fff;\n      padding: 3px 8px;\n      border-radius: 4px;\n      font-size: 11px;\n      font-weight: 600;\n      z-index: 5;\n    }\n  }\n\n  .matching-access-toggle-row {\n    margin: 0 0 12px;\n  }\n\n  .flow-card-info {\n    padding: 12px;\n\n    .flow-card-title {\n      margin: 0 0 8px 0;\n      font-size: 14px;\n      font-weight: 600;\n      line-height: 1.4;\n      color: #0f0f0f;\n      cursor: pointer;\n      display: -webkit-box;\n      -webkit-line-clamp: 2;\n      -webkit-box-orient: vertical;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      min-height: 40px;\n      transition: color 0.2s ease;\n\n      &:hover {\n        color: #5ea1d8;\n      }\n    }\n\n    .flow-card-meta {\n      display: flex;\n      flex-direction: column;\n      gap: 4px;\n\n      .flow-card-creator {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        cursor: pointer;\n        transition: opacity 0.2s ease;\n\n        &:hover {\n          opacity: 0.8;\n        }\n\n        .flow-creator-avatar {\n          width: 24px;\n          height: 24px;\n          border-radius: 50%;\n          object-fit: cover;\n        }\n\n        .flow-creator-icon {\n          width: 24px;\n          height: 24px;\n          font-size: 24px;\n          color: #606060;\n        }\n\n        .flow-creator-name {\n          font-size: 12px;\n          color: #606060;\n          font-weight: 400;\n        }\n      }\n\n      .flow-card-id {\n        font-size: 12px;\n        color: #909090;\n        margin-left: 32px;\n      }\n    }\n  }\n}\n\n/* Create Bundle dark theme alignment (match create-flow modal look) */\n:host-context(body.theme-dark) {\n  .upload-dialog {\n    background: #0f172a !important;\n    color: #f3f4f6 !important;\n  }\n\n  .upload-dialog .upload-header,\n  .upload-dialog .upload-body,\n  .upload-dialog .journey-content,\n  .upload-dialog .section-card,\n  .upload-dialog .journey-card,\n  .upload-dialog .preview-card,\n  .upload-dialog .cover-form-wrapper,\n  .upload-dialog .flow-main-grid,\n  .upload-dialog .flow-main-content,\n  .upload-dialog .flow-sidebar.summary-preview-sidebar,\n  .upload-dialog .step-navigation,\n  .upload-dialog .step-panel-body,\n  .upload-dialog .video-metadata,\n  .upload-dialog .channel-info-section,\n  .upload-dialog .upload-footer,\n  .upload-dialog .mobile-footer,\n  .upload-dialog .add-flows-popup-footer {\n    background: #111827 !important;\n    color: #f3f4f6 !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n    box-shadow: none !important;\n  }\n\n  // Stage banner transparent â€” no card-like raised strip\n  .upload-dialog .stage-banner {\n    background: transparent !important;\n    border-bottom-color: rgba(148, 163, 184, 0.18) !important;\n    box-shadow: none !important;\n  }\n\n  .upload-dialog .mat-mdc-tab-group,\n  .upload-dialog .mat-mdc-tab-header,\n  .upload-dialog .mat-mdc-tab-body-wrapper,\n  .upload-dialog .mat-mdc-tab-body,\n  .upload-dialog .mat-mdc-tab-body-content,\n  .upload-dialog [role=\"tabpanel\"] {\n    background: #111827 !important;\n    color: #f3f4f6 !important;\n  }\n\n  .upload-dialog .mat-mdc-text-field-wrapper,\n  .upload-dialog .mdc-text-field,\n  .upload-dialog .mdc-text-field--outlined,\n  .upload-dialog .mdc-text-field--filled,\n  .upload-dialog input,\n  .upload-dialog textarea,\n  .upload-dialog select,\n  .upload-dialog .ql-container,\n  .upload-dialog .ql-toolbar,\n  .upload-dialog .ql-editor {\n    background: #111827 !important;\n    color: #f9fafb !important;\n    border-color: rgba(148, 163, 184, 0.35) !important;\n  }\n\n  .upload-dialog .icon-circle,\n  .upload-dialog .icon-button,\n  .upload-dialog .upload-icon-btn {\n    background: #1f2937 !important;\n    color: #f3f4f6 !important;\n  }\n\n  .upload-dialog .icon-button:hover,\n  .upload-dialog .upload-icon-btn:hover {\n    background: #334155 !important;\n  }\n\n  .upload-dialog .footer-btn.primary,\n  .upload-dialog .btn.btn-primary,\n  .upload-dialog .add-flows-header-btn,\n  .upload-dialog .category-action-btn {\n    background: #5ea1d8 !important;\n    border-color: #5ea1d8 !important;\n    color: #ffffff !important;\n  }\n\n  .upload-dialog .footer-btn.secondary,\n  .upload-dialog .footer-btn.ghost,\n  .upload-dialog .btn.btn-secondary {\n    background: #1f2937 !important;\n    color: #f3f4f6 !important;\n    border-color: rgba(148, 163, 184, 0.4) !important;\n  }\n\n  .upload-dialog .bundle-category-card {\n    background: rgba(255, 255, 255, 0.04) !important;\n    border-color: rgba(148, 163, 184, 0.25) !important;\n  }\n\n  .upload-dialog .nested-category-header h5,\n  .upload-dialog .category-subsection h6 {\n    color: #e5e7eb !important;\n  }\n\n  .upload-dialog .nested-category-header p {\n    color: #94a3b8 !important;\n  }\n\n  .upload-dialog .nested-bundles-section {\n    border-top-color: rgba(148, 163, 184, 0.2) !important;\n  }\n\n  .upload-dialog .flow-card-title,\n  .upload-dialog .flow-creator-name,\n  .upload-dialog .flow-card-id,\n  .upload-dialog .channel-name,\n  .upload-dialog .channel-meta,\n  .upload-dialog .document-name,\n  .upload-dialog .link-name,\n  .upload-dialog .mobile-section-title,\n  .upload-dialog .mobile-section-description {\n    color: #e5e7eb !important;\n  }\n}\n\n/* â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•\n   Dark mode â€“ Create Bundle: comprehensive white-bg removal\n   Base:     #111827  |  Elevated: #1e293b  |  Accent: #5ea1d8\n   â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â• */\n:host-context(body.theme-dark) {\n\n  // â”€â”€ Core dialog surfaces â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€\n  .upload-dialog {\n    background: #0f172a !important;\n  }\n\n  .upload-header,\n  .stage-banner {\n    background: #111827 !important;\n    border-color: rgba(148, 163, 184, 0.2) !important;\n  }\n\n  .section-card,\n  .cover-form-wrapper,\n  .journey-card,\n  .journey-content,\n  .upload-footer,\n  .add-flows-popup-footer {\n    background: #111827 !important;\n    border-color: rgba(148, 163, 184, 0.2) !important;\n    color: #f3f4f6 !important;\n  }\n\n  // â”€â”€ Quill editor â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€\n  .quill-wrapper {\n    background: #111827 !important;\n    border-color: rgba(148, 163, 184, 0.3) !important;\n\n    ::ng-deep .ql-toolbar {\n      background: #1e293b !important;\n      border-color: rgba(148, 163, 184, 0.25) !important;\n\n      .ql-stroke { stroke: #94a3b8 !important; }\n      .ql-fill   { fill: #94a3b8 !important; }\n      .ql-picker-label { color: #94a3b8 !important; }\n    }\n\n    ::ng-deep .ql-container,\n    ::ng-deep .ql-editor {\n      background: #111827 !important;\n      color: #f3f4f6 !important;\n    }\n\n    ::ng-deep .ql-editor.ql-blank::before {\n      color: #64748b !important;\n    }\n  }\n\n  // â”€â”€ Cover media preview area â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€\n  .table-wrapper .table-inner {\n    background: #1e293b !important;\n    border-color: rgba(148, 163, 184, 0.25) !important;\n\n    p.text-center {\n      color: #94a3b8 !important;\n    }\n  }\n\n  // â”€â”€ Scrollbar â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€\n  .journey-content {\n    scrollbar-color: #334155 #111827 !important;\n\n    &::-webkit-scrollbar-track { background: #111827 !important; }\n    &::-webkit-scrollbar-thumb {\n      background: #334155 !important;\n      &:hover { background: #475569 !important; }\n    }\n  }\n\n  // â”€â”€ Right-panel preview (mobile preview card) â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€\n  .preview-card {\n    background: #111827 !important;\n    border-color: rgba(148, 163, 184, 0.2) !important;\n  }\n\n  .mobile-section {\n    background: #1e293b !important;\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4) !important;\n\n    .mobile-media.placeholder {\n      background: #334155 !important;\n      color: #94a3b8 !important;\n    }\n\n    .mobile-section-title {\n      color: #f3f4f6 !important;\n    }\n\n    .mobile-section-description {\n      color: #cbd5e1 !important;\n      p { color: #cbd5e1 !important; }\n    }\n\n    .mobile-meta-row .info-badge {\n      background: #334155 !important;\n      color: #e2e8f0 !important;\n    }\n  }\n\n  .mobile-document-item,\n  .mobile-link-item {\n    background: #1e293b !important;\n    border-color: rgba(148, 163, 184, 0.25) !important;\n\n    .document-name,\n    .link-name {\n      color: #f3f4f6 !important;\n    }\n  }\n\n  .preview-empty {\n    color: #64748b !important;\n\n    mat-icon { color: #475569 !important; }\n    p        { color: #64748b !important; }\n  }\n\n  // â”€â”€ Add-flows popup â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€\n  .add-flows-popup-dialog {\n    background: #111827 !important;\n    border: 1px solid rgba(148, 163, 184, 0.2) !important;\n  }\n\n  .add-flows-popup-header {\n    background: #111827 !important;\n    border-bottom-color: rgba(148, 163, 184, 0.2) !important;\n\n    h4 { color: #f3f4f6 !important; }\n\n    .icon-button {\n      &:hover { background: #334155 !important; }\n      mat-icon { color: #94a3b8 !important; }\n    }\n  }\n\n  .add-flows-popup-body {\n    background: #111827 !important;\n  }\n\n  // Flow cards inside add-flows popup\n  .bundle-flow-card,\n  .flow-card-info {\n    background: #1e293b !important;\n    border-color: rgba(148, 163, 184, 0.25) !important;\n  }\n\n  .flow-card-title  { color: #f3f4f6 !important; }\n  .flow-creator-name,\n  .flow-card-meta,\n  .flow-card-id     { color: #94a3b8 !important; }\n\n  // â”€â”€ Thumbnail dialog â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€\n  .thumbnail-dialog-card {\n    background: #111827 !important;\n    border: 1px solid rgba(148, 163, 184, 0.2) !important;\n  }\n\n  .thumbnail-dialog-header {\n    background: #111827 !important;\n    border-bottom-color: rgba(148, 163, 184, 0.2) !important;\n\n    h4 { color: #f3f4f6 !important; }\n    p  { color: #94a3b8 !important; }\n  }\n\n  .thumbnail-dialog-body {\n    background: #111827 !important;\n  }\n\n  .thumbnail-choice {\n    background: #1e293b !important;\n    border-color: rgba(148, 163, 184, 0.3) !important;\n    color: #f3f4f6 !important;\n\n    &.selected {\n      background: rgba(94, 161, 216, 0.12) !important;\n      border-color: #5ea1d8 !important;\n    }\n\n    .choice-icon { color: #94a3b8 !important; }\n    .choice-text strong,\n    .choice-text small { color: #cbd5e1 !important; }\n  }\n\n  .upload-preview-compact,\n  .upload-placeholder-compact,\n  .upload-progress-compact {\n    background: #1e293b !important;\n    border-color: rgba(148, 163, 184, 0.25) !important;\n\n    mat-icon { color: #475569 !important; }\n    span     { color: #94a3b8 !important; }\n  }\n\n  // â”€â”€ Flows / Summary tab: left-column surfaces â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€\n\n  // Sticky title bar\n  .upload-dialog .flow-title-sticky,\n  .flow-title-sticky {\n    background: #111827 !important;\n    border-bottom-color: rgba(148, 163, 184, 0.2) !important;\n    box-shadow: none !important;\n\n    .video-title-sticky { color: #f3f4f6 !important; }\n  }\n\n  // Video title + action bar\n  .upload-dialog .video-metadata .video-title,\n  .flow-main-content .video-title {\n    color: #f3f4f6 !important;\n  }\n\n  .upload-dialog .action-item,\n  .flow-main-content .action-item {\n    background: #1e293b !important;\n    color: #e2e8f0 !important;\n\n    mat-icon { color: #94a3b8 !important; }\n    span     { color: #e2e8f0 !important; }\n\n    &:hover:not(.disabled) { background: #334155 !important; }\n  }\n\n  // Channel / creator section\n  .upload-dialog .channel-info-section,\n  .flow-main-content .channel-info-section {\n    background: transparent !important;\n    border-bottom-color: rgba(148, 163, 184, 0.2) !important;\n\n    .channel-name      { color: #f3f4f6 !important; }\n    .channel-meta,\n    .subscriber-count  { color: #94a3b8 !important; }\n    .material-icons    { color: #94a3b8 !important; }\n  }\n\n  // Description section\n  .upload-dialog .description-section,\n  .flow-main-content .description-section {\n    background: #1e293b !important;\n    border-radius: 12px !important;\n\n    // Header title\n    h3,\n    .description-header h3 {\n      color: #f3f4f6 !important;\n    }\n\n    // Description body â€” override ANY inline colour from Quill-injected HTML\n    .description-content {\n      color: #cbd5e1 !important;\n\n      * {\n        color: #cbd5e1 !important;\n      }\n\n      p, span, div, li, ul, ol,\n      strong, em, a, blockquote, pre, code {\n        color: #cbd5e1 !important;\n      }\n\n      a {\n        color: #7ab8e8 !important;\n        text-decoration: underline !important;\n      }\n    }\n\n    // \"Show more / Show less\" button â€” reset background from broad button rule\n    .expand-description-btn {\n      background: transparent !important;\n      background-color: transparent !important;\n      box-shadow: none !important;\n      border: none !important;\n      color: #5ea1d8 !important;\n      font-weight: 500 !important;\n\n      &:hover {\n        background: transparent !important;\n        color: #93c5fd !important;\n      }\n    }\n\n    // \"View Supporting Documents\" link\n    .supporting-docs-link a,\n    .supporting-docs-link .supportingdoc {\n      color: #7ab8e8 !important;\n\n      &:hover { color: #93c5fd !important; }\n    }\n  }\n\n  // Sidebar step buttons\n  .upload-dialog .flow-sidebar .step-btn,\n  .flow-sidebar .step-btn {\n    background: #1e293b !important;\n    color: #cbd5e1 !important;\n\n    &.active {\n      background: #5ea1d8 !important;\n      color: #ffffff !important;\n    }\n\n    .step-title-text { color: inherit !important; }\n  }\n\n  // Recommendations section\n  .upload-dialog .recommendations-section,\n  .flow-sidebar .recommendations-section {\n    border-top-color: rgba(148, 163, 184, 0.2) !important;\n\n    h2 { color: #f3f4f6 !important; }\n\n    .recommendation-item {\n      &:hover { background: #1e293b !important; }\n\n      .recommendation-title { color: #f3f4f6 !important; }\n      .recommendation-meta  { color: #94a3b8 !important; }\n    }\n  }\n\n  // â”€â”€ Supporting Documents tab â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€\n\n  // Mat-tab-group header (Attachments / HyperLink tabs)\n  .upload-dialog ::ng-deep .standard-tab-group .mat-mdc-tab-header,\n  ::ng-deep .standard-tab-group .mat-mdc-tab-header {\n    background: #111827 !important;\n    border-bottom-color: rgba(148, 163, 184, 0.2) !important;\n  }\n\n  .upload-dialog ::ng-deep .standard-tab-group .mdc-tab__text-label,\n  ::ng-deep .standard-tab-group .mdc-tab__text-label {\n    color: #94a3b8 !important;\n  }\n\n  .upload-dialog ::ng-deep .standard-tab-group .mdc-tab--active .mdc-tab__text-label,\n  ::ng-deep .standard-tab-group .mdc-tab--active .mdc-tab__text-label {\n    color: #5ea1d8 !important;\n  }\n\n  .upload-dialog ::ng-deep .standard-tab-group .mdc-tab-indicator__content--underline,\n  ::ng-deep .standard-tab-group .mdc-tab-indicator__content--underline {\n    border-color: #5ea1d8 !important;\n  }\n\n  .upload-dialog ::ng-deep .standard-tab-group .mat-mdc-tab-body-wrapper,\n  ::ng-deep .standard-tab-group .mat-mdc-tab-body-wrapper {\n    background: #111827 !important;\n  }\n\n  // Form labels inside the tab wrapper\n  .tab-design-wrapper mat-label,\n  .tab-design-wrapper ::ng-deep mat-label,\n  .upload-dialog .tab-design-wrapper ::ng-deep .mdc-floating-label,\n  .upload-dialog .tab-design-wrapper ::ng-deep mat-label {\n    color: #94a3b8 !important;\n  }\n\n  .form-label-wrapper.upload-label-inline label,\n  .form-label-wrapper.upload-label-inline .form-label,\n  .upload-label-inline label {\n    color: #cbd5e1 !important;\n  }\n\n  // Document / link list rows\n  .example-box.document-row {\n    background: #1e293b !important;\n    border-color: rgba(148, 163, 184, 0.2) !important;\n\n    &:hover {\n      border-color: #5ea1d8 !important;\n      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35) !important;\n    }\n\n    .doc-name      { color: #f3f4f6 !important; }\n    .doc-url       { color: #94a3b8 !important; }\n    .doc-type-icon { color: #5ea1d8 !important; &.link-icon { color: #a78bfa !important; } }\n\n    .doc-action-btn {\n      &.edit  { color: #7ab8e8 !important; &:hover { background: rgba(94, 161, 216, 0.15) !important; } }\n      &.delete { color: #f87171 !important; &:hover { background: rgba(239, 68, 68, 0.15) !important; } }\n    }\n  }\n\n  // Add button (both tabs)\n  .tab-design-wrapper .addbtn .btn.btn-primary,\n  .addbtn .btn.btn-primary {\n    background: #5ea1d8 !important;\n    color: #ffffff !important;\n    border-color: #5ea1d8 !important;\n\n    &:disabled {\n      background: #334155 !important;\n      color: #64748b !important;\n      border-color: #334155 !important;\n    }\n  }\n\n  // Upload PDF icon button\n  .upload-icon-btn.light {\n    background: #1e293b !important;\n    color: #f3f4f6 !important;\n    border: 1px solid rgba(148, 163, 184, 0.3) !important;\n\n    mat-icon { color: #5ea1d8 !important; }\n\n    &:hover { background: #334155 !important; }\n  }\n\n  // File link display text\n  .file-details {\n    color: #7ab8e8 !important;\n  }\n\n  // â”€â”€ Pricing tab: right-panel preview â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€\n\n  .mobile-pricing-view {\n\n    .pricing-row {\n      background: #1e293b !important;\n      border-color: rgba(148, 163, 184, 0.2) !important;\n    }\n\n    .pricing-label {\n      color: #94a3b8 !important;\n    }\n\n    .pricing-value {\n      color: #f3f4f6 !important;\n\n      &.price-amount {\n        color: #4ade80 !important;\n      }\n    }\n\n    .pricing-warning {\n      color: #f87171 !important;\n\n      mat-icon { color: #f87171 !important; }\n    }\n  }\n\n  // â”€â”€ Flows summary right panel (mobile preview) â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€\n\n  .mobile-flow-item {\n    background: #1e293b !important;\n    border-color: rgba(148, 163, 184, 0.25) !important;\n\n    &:hover {\n      border-color: #5ea1d8 !important;\n      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.4) !important;\n    }\n  }\n\n  .mobile-flow-thumbnail {\n    background: #334155 !important;\n  }\n\n  .mobile-flow-title { color: #f3f4f6 !important; }\n\n  .mobile-flow-meta,\n  .mobile-flow-meta .flow-creator { color: #94a3b8 !important; }\n\n  .mobile-flow-meta .flow-price { color: #4ade80 !important; }\n\n  .flows-count-badge {\n    background: rgba(94, 161, 216, 0.15) !important;\n    color: #7ab8e8 !important;\n    border: 1px solid rgba(94, 161, 216, 0.3) !important;\n  }\n\n  // â”€â”€ Info badge chips (matches create-flow: #1e293b bg) â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€\n  .upload-dialog .info-badge,\n  .info-badge {\n    background: #1e293b !important;\n    color: #f3f4f6 !important;\n    border-color: rgba(148, 163, 184, 0.25) !important;\n\n    mat-icon { color: #5ea1d8 !important; }\n  }\n\n  // â”€â”€ Media-size recommendation info card â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€\n  .media-size-recommendation {\n    background: rgba(30, 41, 59, 0.8) !important;\n    border-left-color: #5ea1d8 !important;\n\n    &__icon { color: #5ea1d8 !important; }\n\n    &__title { color: #7ab8e8 !important; }\n\n    &__lines,\n    &__lines div { color: #cbd5e1 !important; }\n  }\n\n  // â”€â”€ Transfer toggle section â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€\n  .transfer-toggle-section {\n    background: #1e293b !important;\n    border-color: rgba(148, 163, 184, 0.2) !important;\n\n    .toggle-label { color: #f3f4f6 !important; }\n\n    .toggle-description {\n      background: rgba(94, 161, 216, 0.1) !important;\n      border-left-color: #5ea1d8 !important;\n      color: #93c5fd !important;\n\n      .info-icon { color: #5ea1d8 !important; }\n    }\n  }\n\n  // â”€â”€ Global label override â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€\n  .upload-dialog label {\n    color: #cbd5e1 !important;\n  }\n\n  .upload-dialog .cover-form-wrapper h3 {\n    color: #f3f4f6 !important;\n  }\n\n  // â”€â”€ Flow items grid (add-flows popup) â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€\n  .item {\n    background: #1e293b !important;\n    border-color: rgba(148, 163, 184, 0.25) !important;\n    color: #f3f4f6 !important;\n\n    p { color: #f3f4f6 !important; }\n  }\n\n  // Inline style overrides (background: #f0f7ff etc.)\n  .upload-dialog [style*=\"background-color: #f0f7ff\"],\n  .upload-dialog [style*=\"background: #f0f7ff\"],\n  .upload-dialog [style*=\"background-color:#f0f7ff\"],\n  .upload-dialog [style*=\"background:#f0f7ff\"] {\n    background: rgba(30, 41, 59, 0.75) !important;\n    background-color: rgba(30, 41, 59, 0.75) !important;\n    border-left-color: #5ea1d8 !important;\n  }\n}\n\n.bundle-access-type-row {\n  margin-bottom: 12px;\n}\n\n.bundle-access-type-options {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-top: 8px;\n}\n\n.access-type-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  border: 1px solid #cbd5e1;\n  border-radius: 999px;\n  background: #fff;\n  color: #334155;\n  padding: 8px 16px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n\n  mat-icon {\n    width: 18px;\n    height: 18px;\n    font-size: 18px;\n  }\n\n  &.selected {\n    border-color: #5ea1d8;\n    background: #eef6fc;\n    color: #1e4d72;\n  }\n\n  &:disabled {\n    opacity: 0.55;\n    cursor: not-allowed;\n  }\n}\n\n.access-type-check {\n  font-size: 18px;\n  width: 18px;\n  height: 18px;\n  margin-left: 2px;\n}\n\n::ng-deep .access-menu-current {\n  margin-left: 8px;\n  font-size: 11px;\n  font-weight: 600;\n  color: #1976d2;\n}\n\n\n.journey-access-type-row {\n  margin-bottom: 16px;\n  text-align: left;\n  width: 100%;\n  max-width: 100%;\n}\n\n.journey-access-option-list {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 10px;\n  margin-top: 10px;\n  width: 100%;\n  max-width: 100%;\n\n  @media (min-width: 992px) {\n    flex-direction: row;\n    align-items: stretch;\n    gap: 10px;\n  }\n}\n\n.journey-access-option {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  width: 100%;\n  text-align: left;\n  border: 1px solid #d7dee8;\n  border-radius: 12px;\n  background: #fff;\n  color: #1e293b;\n  padding: 14px 16px;\n  cursor: pointer;\n  transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;\n\n  &:hover:not(:disabled) {\n    border-color: #93c5e8;\n    background: #f8fbfe;\n  }\n\n  &.selected {\n    border-color: #5ea1d8;\n    background: #eef6fc;\n    box-shadow: inset 0 0 0 1px #5ea1d8;\n  }\n\n  &:disabled {\n    opacity: 0.55;\n    cursor: not-allowed;\n  }\n\n  @media (min-width: 992px) {\n    flex: 1 1 0;\n    min-width: 0;\n    align-items: center;\n    gap: 8px;\n    padding: 12px 14px;\n  }\n}\n\n.journey-access-option-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 auto;\n  width: 24px;\n  height: 24px;\n  font-size: 24px;\n  line-height: 24px;\n  overflow: visible;\n  color: #5ea1d8;\n  margin-top: 0;\n}\n\n.journey-access-option-copy {\n  flex: 1 1 auto;\n  min-width: 0;\n\n  strong {\n    display: block;\n    font-size: 14px;\n    font-weight: 600;\n    color: #0f172a;\n    line-height: 24px;\n  }\n\n  p {\n    margin: 4px 0 0;\n    font-size: 13px;\n    line-height: 1.4;\n    color: #64748b;\n  }\n\n  @media (min-width: 992px) {\n    strong {\n      font-size: 13px;\n      line-height: 24px;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n\n    p {\n      display: none;\n    }\n  }\n}\n\n.journey-access-option-check {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 auto;\n  width: 22px;\n  height: 22px;\n  font-size: 22px;\n  line-height: 22px;\n  overflow: visible;\n  color: #5ea1d8;\n  margin-top: 0;\n}\n\n.journey-restricted-panel {\n  margin-top: 16px;\n  width: 100%;\n  max-width: 100%;\n  text-align: left;\n  max-height: none;\n  overflow: visible;\n  padding-bottom: 24px;\n}\n\n.access-journey-card {\n  .journey-content {\n    width: 100%;\n  }\n\n  .cover-form-wrapper.journey-access-type-row,\n  .journey-restricted-panel,\n  app-enhanced-restricted-access {\n    display: block;\n    width: 100%;\n    max-width: 100%;\n  }\n}\n\n.preview-card .mobile-section.access-summary-preview,\n.access-summary-preview {\n  overflow: visible;\n\n  .access-summary-badge {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 4px;\n\n    .access-summary-kicker {\n      display: block;\n      margin-bottom: 0;\n      font-size: 11px;\n      font-weight: 700;\n      letter-spacing: 0.04em;\n      text-transform: uppercase;\n      color: #94a3b8;\n    }\n\n    .access-summary-title-row {\n      display: inline-flex;\n      align-items: center;\n      gap: 8px;\n      min-width: 0;\n      max-width: 100%;\n      min-height: 22px;\n\n      mat-icon {\n        display: inline-flex !important;\n        align-items: center;\n        justify-content: center;\n        flex: 0 0 20px;\n        width: 20px !important;\n        height: 20px !important;\n        font-size: 20px !important;\n        line-height: 20px !important;\n        margin: 0 !important;\n        padding: 0 !important;\n        overflow: visible;\n        color: #5ea1d8;\n        /* Optical nudge: Material glyphs sit slightly high next to text */\n        transform: translateY(1px);\n      }\n\n      strong {\n        display: inline-flex;\n        align-items: center;\n        min-width: 0;\n        margin: 0;\n        padding: 0;\n        font-size: 14px;\n        font-weight: 600;\n        line-height: 20px;\n        color: #0f172a;\n      }\n    }\n\n    mat-icon {\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n      flex-shrink: 0;\n      width: 20px;\n      height: 20px;\n      font-size: 20px;\n      line-height: 20px;\n      overflow: visible;\n      color: #5ea1d8;\n    }\n\n    strong {\n      display: block;\n      min-width: 0;\n      font-size: 14px;\n      line-height: 20px;\n      color: #0f172a;\n    }\n\n    p {\n      margin: 2px 0 0;\n      font-size: 13px;\n      color: #64748b;\n      line-height: 1.4;\n    }\n  }\n\n  .access-summary-original {\n    margin-top: 14px;\n    padding-top: 12px;\n    border-top: 1px solid #e2e8f0;\n\n    .access-summary-kicker {\n      display: block;\n      margin-bottom: 2px;\n      font-size: 11px;\n      font-weight: 700;\n      letter-spacing: 0.04em;\n      text-transform: uppercase;\n      color: #94a3b8;\n    }\n\n    strong {\n      display: block;\n      font-size: 13px;\n      color: #334155;\n    }\n\n    p {\n      margin: 4px 0 0;\n      font-size: 12px;\n      color: #64748b;\n      line-height: 1.4;\n    }\n\n    .access-restore-btn {\n      display: inline-flex;\n      align-items: center;\n      gap: 6px;\n      margin-top: 10px;\n      min-height: 40px;\n      padding: 8px 16px;\n      border: 1px solid #5ea1d8;\n      border-radius: 8px;\n      background: transparent;\n      color: #5ea1d8;\n      font-size: 13px;\n      font-weight: 500;\n      line-height: 1.2;\n      cursor: pointer;\n      transition: background 0.15s, color 0.15s;\n      text-transform: none;\n      box-sizing: border-box;\n\n      mat-icon {\n        display: inline-flex !important;\n        align-items: center;\n        justify-content: center;\n        flex: 0 0 16px;\n        width: 16px !important;\n        height: 16px !important;\n        font-size: 16px !important;\n        line-height: 16px !important;\n        margin: 0 !important;\n        padding: 0 !important;\n        overflow: visible;\n      }\n\n      &:hover {\n        background: #5ea1d8;\n        color: #fff;\n      }\n    }\n  }\n\n  .access-summary-meta {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    margin-top: 12px;\n\n    span {\n      display: inline-flex;\n      align-items: center;\n      padding: 4px 10px;\n      border-radius: 999px;\n      background: #eef6fc;\n      color: #1e4d72;\n      font-size: 12px;\n      font-weight: 600;\n    }\n  }\n}\n\n.flows-sequence-hint.muted {\n  margin-top: 8px;\n  color: #6b7280;\n  font-size: 13px;\n  text-align: left;\n}\n\n.access-original-inline {\n  display: none;\n  margin-top: 16px;\n  padding: 14px 16px;\n  border-radius: 12px;\n  border: 1px solid #e2e8f0;\n  background: #f8fafc;\n\n  .access-summary-kicker {\n    display: block;\n    margin-bottom: 4px;\n    font-size: 11px;\n    font-weight: 700;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    color: #94a3b8;\n  }\n\n  .access-summary-title-row {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    min-width: 0;\n    max-width: 100%;\n\n    mat-icon {\n      display: inline-flex !important;\n      align-items: center;\n      justify-content: center;\n      flex: 0 0 20px;\n      width: 20px !important;\n      height: 20px !important;\n      font-size: 20px !important;\n      line-height: 20px !important;\n      margin: 0 !important;\n      padding: 0 !important;\n      overflow: visible;\n      color: #5ea1d8;\n      transform: translateY(1px);\n    }\n\n    strong {\n      display: inline-flex;\n      align-items: center;\n      min-width: 0;\n      margin: 0;\n      font-size: 14px;\n      font-weight: 600;\n      line-height: 20px;\n      color: #0f172a;\n    }\n  }\n\n  > p {\n    margin: 4px 0 0;\n    font-size: 13px;\n    line-height: 1.4;\n    color: #64748b;\n  }\n\n  .access-summary-meta {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    margin-top: 10px;\n\n    span {\n      display: inline-flex;\n      align-items: center;\n      padding: 4px 10px;\n      border-radius: 999px;\n      background: #eef6fc;\n      color: #1e4d72;\n      font-size: 12px;\n      font-weight: 600;\n    }\n  }\n\n  .access-restore-btn {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    margin-top: 12px;\n    min-height: 40px;\n    padding: 8px 16px;\n    border: 1px solid #5ea1d8;\n    border-radius: 8px;\n    background: transparent;\n    color: #5ea1d8;\n    font-size: 13px;\n    font-weight: 500;\n    line-height: 1.2;\n    cursor: pointer;\n    transition: background 0.15s, color 0.15s;\n    text-transform: none;\n    box-sizing: border-box;\n\n    mat-icon {\n      display: inline-flex !important;\n      align-items: center;\n      justify-content: center;\n      flex: 0 0 16px;\n      width: 16px !important;\n      height: 16px !important;\n      font-size: 16px !important;\n      line-height: 16px !important;\n      margin: 0 !important;\n      padding: 0 !important;\n      overflow: visible;\n    }\n\n    &:hover {\n      background: #5ea1d8;\n      color: #fff;\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .access-original-inline {\n    display: block;\n  }\n}\n\n.creator-access-notice {\n  .upgrade-free-link {\n    margin-left: 4px;\n    border: none;\n    background: none;\n    padding: 0;\n    color: #5ea1d8;\n    font-weight: 700;\n    font-size: 0.85rem;\n    cursor: pointer;\n    text-decoration: underline;\n  }\n}\n\n","// Rejection reason + \"Live: v3 · Editing: v4\" banners shown in the guide and guide pack editors.\n.publishing-state {\n  padding: 0 32px 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n\n  &__banner {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 10px 16px;\n    border-radius: 10px;\n    font-size: 13px;\n    line-height: 1.5;\n\n    mat-icon {\n      font-size: 18px;\n      width: 18px;\n      height: 18px;\n      flex-shrink: 0;\n    }\n\n    &--rejected {\n      background: #fdecea;\n      border: 1px solid #f5b5ae;\n      color: #8a1c12;\n      mat-icon { color: #d93025; }\n    }\n\n    &--status {\n      background: #eef4ff;\n      border: 1px solid #c7d7fe;\n      color: #1e3a8a;\n      mat-icon { color: #2563eb; }\n    }\n  }\n\n  &__text { flex: 1; }\n\n  &__hint {\n    display: block;\n    font-size: 12px;\n    opacity: 0.8;\n  }\n\n  &__change {\n    margin-left: auto;\n    border: 1px solid currentColor;\n    background: transparent;\n    color: inherit;\n    border-radius: 999px;\n    padding: 4px 12px;\n    font-size: 12px;\n    cursor: pointer;\n    white-space: nowrap;\n\n    &:disabled { opacity: 0.5; cursor: default; }\n  }\n}\n\n// Footer info icon that opens the publishing status details.\n.publishing-info-btn {\n  flex: 0 0 auto;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  border: none;\n  border-radius: 50%;\n  background: transparent;\n  color: #2563eb;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n\n  mat-icon {\n    font-size: 20px;\n    width: 20px;\n    height: 20px;\n    line-height: 20px;\n  }\n\n  &:hover,\n  &:focus-visible {\n    background: rgba(37, 99, 235, 0.1);\n  }\n}\n\n:host-context(body.theme-dark) .publishing-info-btn {\n  color: #8ab4f8;\n}\n\n:host-context(body.theme-dark) .publishing-state {\n  .publishing-state__banner--rejected {\n    background: rgba(217, 48, 37, 0.12);\n    border-color: rgba(217, 48, 37, 0.35);\n    color: #f9b4ad;\n    mat-icon { color: #f28b82; }\n  }\n  .publishing-state__banner--status {\n    background: rgba(37, 99, 235, 0.12);\n    border-color: rgba(37, 99, 235, 0.35);\n    color: #bfd3fe;\n    mat-icon { color: #8ab4f8; }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
